window.sizeChartData = window.sizeChartData || null;
window.settings = window.settings || null;
window.pageData = window.pageData || null;
window.shop = window.shop || "";
// Add global variable to store fit data
window.fitChartsData = window.fitChartsData || null;

// Helper function to check if text matches size keywords (including custom ones)
function matchesSizeKeyword(text) {
  if (!text) return false;
  const lowerText = text.toLowerCase();
  const keywords = ['size', 'サイズ'];
  
  if (window.pifySizeLabel && Array.isArray(window.pifySizeLabel)) {
    window.pifySizeLabel.forEach(label => {
      if (label && typeof label === 'string') {
        keywords.push(label);
      }
    });
  }
  
  return keywords.some(keyword => lowerText.includes(keyword.toLowerCase()));
}

// Exception collection function
let exceptionCollector = {

  // Error code definitions
  ERROR_CODES: {
    INITIALIZATION_ERROR: 'SC_INIT_001',
    API_ERROR: 'SC_API_002',
    BUTTON_PLACEMENT_ERROR: 'SC_BTN_003',
    TOOLTIP_SELECTORS_ERROR: 'SC_TIP_004',
    TOOLTIP_FILTERING_ERROR: 'SC_TIP_005',
    TOOLTIP_DATA_ERROR: 'SC_TIP_006',
    RADIO_SELECTORS_ERROR: 'SC_RAD_007',
    THEME_COMPATIBILITY_ERROR: 'SC_THM_008',
    SIZE_INFO_ERROR: 'SC_SIZ_009',
    GENERAL_ERROR: 'SC_GEN_999'
  },

  // Get today's date string (YYYY-MM-DD format)
  getTodayDateString: function () {
    const today = new Date();
    return today.getFullYear() + '-' +
      String(today.getMonth() + 1).padStart(2, '0') + '-' +
      String(today.getDate()).padStart(2, '0');
  },

  // Get storage key for current shop and theme
  getStorageKey: function () {
    const shop =  window.shop || window.Shopify?.shop || window.location.hostname;
    const themeName = window.Shopify?.theme?.schema_name || 'unknown';
    return `pify_exception_sent_${shop}_${themeName}`;
  },

  // Clean up old localStorage entries (older than 3 days)
  cleanupOldEntries: function () {
    try {
      const today = new Date();
      const threeDaysAgo = new Date(today.getTime() - 3 * 24 * 60 * 60 * 1000);
      const cutoffDate = threeDaysAgo.getFullYear() + '-' +
        String(threeDaysAgo.getMonth() + 1).padStart(2, '0') + '-' +
        String(threeDaysAgo.getDate()).padStart(2, '0');

      // Get all keys that start with our prefix
      const keysToCheck = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('pify_exception_sent_')) {
          keysToCheck.push(key);
        }
      }

      // Remove entries older than 3 days
      keysToCheck.forEach(key => {
        try {
          const storedDate = localStorage.getItem(key);
          if (storedDate && storedDate < cutoffDate) {
            localStorage.removeItem(key);
          }
        } catch (error) {
          // If any error occurs with a specific key, remove it
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      // Failed to cleanup old entries
    }
  },

  // Check if exceptions were already sent today for current shop/theme
  hasSentToday: function () {
    try {
      // Clean up old entries periodically (run cleanup on every check)
      // This only removes entries older than 3 days, ensuring today's record is preserved
      this.cleanupOldEntries();

      const storageKey = this.getStorageKey();
      const lastSentDate = localStorage.getItem(storageKey);
      const todayDate = this.getTodayDateString();

      // Compare stored date with today's date
      // Returns true if already sent today, false if not sent today or no record exists
      return lastSentDate === todayDate;
    } catch (error) {
      // Failed to check last sent date
      // If any error occurs, allow sending (return false)
      return false;
    }
  },

  // Mark that exceptions were sent today for current shop/theme
  markSentToday: function () {
    try {
      const storageKey = this.getStorageKey();
      const todayDate = this.getTodayDateString();
      localStorage.setItem(storageKey, todayDate);
    } catch (error) {
      // Failed to mark sent date
    }
  },

  // Get error code based on function name
  getErrorCode: function (functionName) {
    const functionToCodeMap = {
      'sizechart_initialization': this.ERROR_CODES.INITIALIZATION_ERROR,
      'sizechart_api_error': this.ERROR_CODES.API_ERROR,
      'sizechart_button_placement': this.ERROR_CODES.BUTTON_PLACEMENT_ERROR,
      'sizechart_tooltip_selectors': this.ERROR_CODES.TOOLTIP_SELECTORS_ERROR,
      'sizechart_tooltip_filtering': this.ERROR_CODES.TOOLTIP_FILTERING_ERROR,
      'sizechart_tooltip_data': this.ERROR_CODES.TOOLTIP_DATA_ERROR,
      'sizechart_radio_selectors': this.ERROR_CODES.RADIO_SELECTORS_ERROR,
      'Not compatible with the theme': this.ERROR_CODES.THEME_COMPATIBILITY_ERROR,
      'The corresponding size information was not found': this.ERROR_CODES.SIZE_INFO_ERROR
    };

    return functionToCodeMap[functionName] || this.ERROR_CODES.GENERAL_ERROR;
  },

  // Collect exception information
  collect: function (functionName, description) {
    try {
      // If already sent today, no need to collect new exceptions
      if (this.hasSentToday()) {
        return;
      }

      // Mark as sent immediately to prevent duplicate requests
      this.markSentToday();

      const clientInfoObject = {
        shop:  window.shop || window.Shopify?.shop || window.location.hostname, // Current store information
        themeName: window.Shopify?.theme?.schema_name || '', // Current topic name
      };

      const errorCode = this.getErrorCode(functionName);

      const exception = {
        shop:  window.shop || window.Shopify?.shop || window.location.hostname,
        errorCode: errorCode, // Error code for backend filtering
        function: functionName, // Identify the functional module with the problem
        description: description, // Problem description
        clientInfo: JSON.stringify(clientInfoObject),
        url: window.location.href, // Current page URL
        date: this.getTodayDateString() // Add today's date
      };

      // Send exception immediately
      this.sendException(exception);

    } catch (error) {
      // Failed to collect exception
    }
  },



  // Send exception information
  sendException: function (exception) {
    try {
      const xhr = new XMLHttpRequest();
      const baseUrl = getApiBaseUrl();
      xhr.open('POST', `${baseUrl}/api/front/exceptions`, true);
      xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          // Exception reported successfully
        } else {
          // Failed to report exception
        }
      };

      xhr.onerror = function () {
        // Network error when reporting exception
      };

      xhr.send(JSON.stringify(exception));
    } catch (error) {
      // Failed to send exception
    }
  },
};



getPageSizeChartData();

function getPageSizeChartData() {
  const scriptElement = document.getElementById('pify-sizechart-data');
  if (scriptElement) {
    try {
      window.pageData = JSON.parse(scriptElement.textContent);
       window.shop  = window.shop ||  window.pageData.shopDomain || window.Shopify.shop || window.location.hostname;
      return window.pageData;
    } catch (error) {
      // Parse error
    }
  }
  return null;
}

function getEnvironment() {
  // Development environment domains
  const developmentDomains = [
    'prodevolop5.myshopify.com',
    'dd-happy-shop.myshopify.com'
  ];
  if (window.shop === 'prodevolop5.myshopify.com') {
    return 'development';
  }

  // Test environment domains
  const testDomains = [
    'prodevolop14.myshopify.com',
    'vnryw.myshopify.com',
    'tiuer.myshopify.com',
    'vnryh.myshopify.com',
    'vnehw.myshopify.com',
    'vnrye.myshopify.com',
    'cvnes.myshopify.com',
    'vechw.myshopify.com',
    'dfgbn.myshopify.com',
    'sdfsk.myshopify.com',
    'vnxge.myshopify.com',
    'qvyrv.myshopify.com',
    'tyuvq.myshopify.com',
    'ptigw.myshopify.com',
    'hao01.myshopify.com',
    'bht4e.myshopify.com',
    'cndhs.myshopify.com',
    'chsugh.myshopify.com',
    'oijng.myshopify.com',//initiate shop
  ];

  if (testDomains.includes( window.shop)) {
    return 'test';
  }

  return 'production';
}

function getApiBaseUrl() {
  const env = getEnvironment();
  const API_URLS = {
    development: 'https://localhost',
    test: 'https://size-chart-test.pifyapp.com',
    production: 'https://size-chart.pifyapp.com'
  };
  return API_URLS[env];
}

function fetchSizeChartData() {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const baseUrl = getApiBaseUrl();
    const url = new URL(`${baseUrl}/api/front/sizecharts`);
    url.searchParams.append('shop', window.Shopify.shop);
    // Only append language parameter when routes.root is not '/'
    if (window.Shopify.routes?.root !== '/') {
      url.searchParams.append('language', window.Shopify.locale);
    }
    xhr.open('GET', `https://size-chart.pifyapp.com/api/front/sizecharts?shop=toesox-tavinoir.myshopify.com`, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const response = JSON.parse(xhr.responseText);
          if (response && response.success) {
            // Store fitProfiles to global pageData object
            if (!window.pageData) {
              window.pageData = {};
            }
            window.pageData.fitProfiles = response.fitProfiles || [];

            resolve({
              data: response.data,
              settings: response.settings,
              fitProfiles: response.fitProfiles || [],
              appInstallTime:response.appInstallTime || null
              // appInstallTime:'Sat Nov 01 2025 11:22:15 GMT+0800 (China Standard Time)' //New User
            });
          }
        } catch (error) {
          reject(error);
        }
      } else {
        reject(new Error(`API request failed, status code: ${xhr.status}`));
      }
    };

    xhr.onerror = function () {
      reject(new Error('Network error, unable to connect to API'));
    };

    xhr.send();
  });
}

// Common method to create button icons
function createButtonIcon(buttonDiv, fontSize = '16px') {
  // Determine icon type through buttonIconType
  const buttonIconType = window.settings?.buttonIconType || 'normal';
  const buttonIcon = window.settings?.buttonIcon || 'icon-icon2';

  
  if (buttonIconType === 'normal') {
    // Display font icon, buttonIcon is the class name
    const iconElement = document.createElement('i');
    iconElement.className = `${buttonIcon} iconfont pify_button_icon_font`;
    
    // Set font icon size via CSS variable on the parent
    buttonDiv.style.setProperty('--pify-icon-font-size', fontSize);
    
    buttonDiv.appendChild(iconElement);
  } else if (buttonIconType === 'custom') {
    // Display user uploaded image
    const iconPath = buttonIcon;
    const resolvedPath = resolveImagePath(iconPath);
    
    if (resolvedPath) {
      const img = document.createElement('img');
      img.src = resolvedPath;
      img.className = 'pify_button_icon';
      buttonDiv.appendChild(img);
    }
  }
}
function renderModule(module) {
  const moduleContainer = document.createElement('div');
  moduleContainer.className = 'pify_module_container';

  switch (module.type) {
    case 'table':
      moduleContainer.appendChild(renderTable(module.content));
      break;
    case 'text':
      moduleContainer.appendChild(renderText(module.content));
      break;
    case 'image':
      moduleContainer.appendChild(renderImage(module.content));
      break;
  }

  return moduleContainer;
}

// Local helper to convert range values with fixed decimals, independent of global settings
function convertRangeValueFixed(value, fromUnit, toUnit, decimals) {
  if (fromUnit === toUnit) return value;
  
  const factor = (fromUnit === 'cm' && toUnit === 'inch') ? 1/2.54 : 
                 (fromUnit === 'inch' && toUnit === 'cm') ? 2.54 : 1;

  if (typeof value !== 'string' && typeof value !== 'number') return value;
  const valStr = String(value);
  
  // Format number removing trailing zeros
  const fmt = (num) => {
    let d = parseInt(decimals);
    if (isNaN(d)) d = 2;
    d = Math.max(0, d);
    const fixed = parseFloat(num).toFixed(d);
    return parseFloat(fixed).toString();
  };

  // Handle range "10-12"
  if (valStr.includes('-')) {
    const parts = valStr.split('-');
    if (parts.length === 2) {
      const start = parseFloat(parts[0].trim());
      const end = parseFloat(parts[1].trim());
      if (!isNaN(start) && !isNaN(end)) {
         return `${fmt(start * factor)}-${fmt(end * factor)}`;
      }
    }
  }
  
  const num = parseFloat(valStr);
  if (!isNaN(num)) {
    return fmt(num * factor);
  }
  
  return value;
}

function renderTable(content) {
  // Ensure tableData exists (fallback to precomputed data if available)
  if (!content.tableData) {
    if (content.tableDataCM) {
      content.tableData = content.tableDataCM;
      if (!content.unit) content.unit = 'cm';
    } else if (content.tableDataINCH) {
      content.tableData = content.tableDataINCH;
      if (!content.unit) content.unit = 'inch';
    } else {
      content.tableData = [];
    }
  }

  const container = document.createElement('div');
  container.className = 'pify_table_container';

  const tableModule = document.createElement('div');
  tableModule.className = 'tableModule';

  const unitContainer = document.createElement('div');
  unitContainer.className = 'pify_unit_container';

  const tableId = 'table_' + Math.random().toString(36).substr(2, 9);
  container.dataset.tableId = tableId;
  // Respect unitDisplayMode for initial/current unit and control rendering
  const unitDisplayMode = content?.unitDisplayMode || 'both';
  const originalUnit = content?.unit || 'cm';
  // Use helper to compute initial display unit; keep original unit separately
  const currentUnit = computeInitialUnit(unitDisplayMode, originalUnit);
  container.dataset.currentUnit = currentUnit;
  container.dataset.initialUnit = originalUnit;

  if (content?.tableDataCM && content?.tableDataINCH) {
    container.dataset.hasPrecomputedData = 'true';
    container.dataset.tableDataCM = JSON.stringify(content.tableDataCM);
    container.dataset.tableDataINCH = JSON.stringify(content.tableDataINCH);
    container.dataset.tableHeaders = JSON.stringify(content.headers);

    // Ensure initial tableData matches currentUnit
    if (currentUnit === 'inch') {
      content.tableData = content.tableDataINCH;
    } else if (currentUnit === 'cm') {
      content.tableData = content.tableDataCM;
    }
  } else if (content?.originalData || (content?.tableData && content?.tableData.length > 0)) {
    // Legacy data handling: if originalData exists OR just tableData exists
    try {
        let tableDataCM, tableDataINCH;
        const originalData = content.originalData;

        if (originalData && Array.isArray(originalData) && originalData.length > 0) {
            // Scenario 1: originalData exists (usually CM)
            
            // Check structure of originalData (array of arrays or array of objects)
            const isArrayOfArrays = Array.isArray(originalData[0]);

            // Construct tableDataCM from originalData + headers
            tableDataCM = content.tableData.map((row, rowIndex) => {
                const newRow = {};
                content.headers.forEach((header, colIndex) => {
                   let val;
                   const originalRow = originalData[rowIndex];
                   
                   // Try to retrieve value from originalData
                   if (originalRow) {
                       if (isArrayOfArrays) {
                           // Array of arrays access
                           if (originalRow[colIndex] !== undefined) {
                               val = originalRow[colIndex];
                           }
                       } else if (typeof originalRow === 'object') {
                           // Array of objects access
                           if (originalRow[header] !== undefined) {
                               val = originalRow[header];
                           }
                       }
                   }

                   // Fallback to row value if originalData missing
                   if (val === undefined || val === null || val === "") {
                       val = ""; 
                   }
                   newRow[header] = val;
                });
                return newRow;
            });
            // Construct tableDataINCH from tableDataCM
            tableDataINCH = tableDataCM.map((row, rowIndex) => {
                const newRow = {};
                for (const key in row) {
                    if (key === content.headers[0] || key.trim().endsWith('*')) {
                         // If label is missing in CM (because originalData was empty), 
                         // try to recover it from the initial tableData (which might be INCH source)
                         let val = row[key];
                         if ((val === undefined || val === null || val === "") && content.tableData[rowIndex]) {
                             const initialRow = content.tableData[rowIndex];
                             if (initialRow && initialRow[key]) {
                                 val = initialRow[key];
                             }
                         }
                         newRow[key] = val;
                    } else {
                         // Convert CM -> INCH using fixed decimals helper for legacy data
                         newRow[key] = convertRangeValueFixed(row[key], 'cm', 'inch', 2);
                    }
                }
                return newRow;
            });
        } else {
            // Scenario 2: Only tableData exists
            const unit = content.unit || 'cm';
            if (unit === 'inch') {
                // We have INCH data, convert to CM
                tableDataINCH = content.tableData;
                tableDataCM = tableDataINCH.map(row => {
                    const newRow = {};
                    for (const key in row) {
                        if (key === content.headers[0] || key.trim().endsWith('*')) {
                            newRow[key] = row[key];
                        } else {
                            // Convert INCH -> CM (factor 2.54)
                            newRow[key] = convertRangeValueFixed(row[key], 'inch', 'cm', 2);
                        }
                    }
                    return newRow;
                });
            } else {
                // We have CM data (default), convert to INCH
                tableDataCM = content.tableData;
                tableDataINCH = tableDataCM.map(row => {
                    const newRow = {};
                    for (const key in row) {
                        if (key === content.headers[0] || key.trim().endsWith('*')) {
                            newRow[key] = row[key];
                        } else {
                            // Convert CM -> INCH (factor 1/2.54), fixed 2 decimals
                            newRow[key] = convertRangeValueFixed(row[key], 'cm', 'inch', 2);
                        }
                    }
                    return newRow;
                });
            }
        }

        if (tableDataCM && tableDataINCH) {
            container.dataset.hasPrecomputedData = 'true';
            
            // Store precomputed data on container for future toggles
            container.dataset.tableDataCM = JSON.stringify(tableDataCM);
            container.dataset.tableDataINCH = JSON.stringify(tableDataINCH);
            container.dataset.tableHeaders = JSON.stringify(content.headers);
            
             // Ensure initial tableData matches currentUnit by ASSIGNING directly to content.tableData
             // This is crucial because subsequent code renders table based on content.tableData
            if (currentUnit === 'inch') {
              content.tableData = tableDataINCH;
            } else if (currentUnit === 'cm') {
              content.tableData = tableDataCM;
            }
            // Also update content.tableDataINCH/CM to persist in memory if modal is reused
            content.tableDataINCH = tableDataINCH;
            content.tableDataCM = tableDataCM;
        }
    } catch (e) {
        console.error("Error processing legacy data for chart:", e);
    }
  }

  // A11y: mark unit controls as a radiogroup with accessible name
  unitContainer.id = 'unit_group_' + tableId;
  unitContainer.setAttribute('role', 'radiogroup');
  unitContainer.setAttribute('aria-label', window.settings?.unitLabels?.groupAriaLabel || 'Measurement unit');

  // Render unit controls depending on unitDisplayMode
  const { cmDisplay, inchDisplay } = getUnitDisplayTexts();
  if (content?.isTextTable || unitDisplayMode === 'none') {
    // No unit controls for text tables or explicit none mode
  } else if (unitDisplayMode === 'cm' || unitDisplayMode === 'inch') {
    const unit = unitDisplayMode;
    const label = createUnitLabel(unit, tableId, container, unitContainer, unit === 'cm' ? cmDisplay : inchDisplay, false);
    unitContainer.appendChild(label);
  } else {
    ['cm', 'inch'].forEach(unit => {
      const label = createUnitLabel(unit, tableId, container, unitContainer, unit === 'cm' ? cmDisplay : inchDisplay, true);
      unitContainer.appendChild(label);
    });
  }

  // Table
  const table = document.createElement('table');
  table.className = 'pify_size_table';
  table.dataset.tableId = tableId;
  table.dataset.hoveredRow = -1;
  table.dataset.hoveredCol = -1;
  // A11y: provide accessible name and link to unit controls
  table.setAttribute('aria-label', content?.caption || 'Size chart table');
  table.setAttribute('aria-describedby', unitContainer.id);

  // Table header
  const thead = document.createElement('thead');
  const headerRow = document.createElement('tr');
  content.headers.forEach((header, index) => {
    const th = document.createElement('th');
    th.className = 'pify_table_header';
    // Remove trailing asterisk if present
    th.textContent = header.endsWith('*') ? header.slice(0, -1) : header;
    th.dataset.colIndex = index;
    // A11y: assign column header id for cell association
    th.id = `${tableId}_col_${index}`;
    // A11y: column header semantics
    th.setAttribute('scope', 'col');

    th.addEventListener('mouseenter', () => {
      table.dataset.hoveredCol = index;
      updateTableHighlight(table);
    });

    th.addEventListener('mouseleave', () => {
      table.dataset.hoveredCol = -1;
      updateTableHighlight(table);
    });

    headerRow.appendChild(th);
  });
  thead.appendChild(headerRow);
  table.appendChild(thead);

  // Table content
  const tbody = document.createElement('tbody');
  content.tableData.forEach((row, rowIndex) => {
    const tr = document.createElement('tr');
    content.headers.forEach((header, colIndex) => {
      const td = document.createElement('td');
      td.className = 'pify_table_cell';
      const key = Object.keys(row).find(k => k === header);
      td.textContent = key ? row[key] : '-';

      td.dataset.rowIndex = rowIndex;
      td.dataset.colIndex = colIndex;
      // A11y: associate data cells with headers
      if (colIndex === 0) {
        // Treat first column as row label reference target
        td.id = `${tableId}_row_${rowIndex}`;
      } else {
        td.setAttribute('headers', `${tableId}_col_${colIndex}`);
        td.setAttribute('aria-describedby', `${tableId}_row_${rowIndex}`);
      }

      td.addEventListener('mouseenter', () => {
        table.dataset.hoveredRow = rowIndex;
        table.dataset.hoveredCol = colIndex;
        updateTableHighlight(table);
      });

      td.addEventListener('mouseleave', () => {
        table.dataset.hoveredRow = -1;
        table.dataset.hoveredCol = -1;
        updateTableHighlight(table);
      });

      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  });
  table.appendChild(tbody);

  // Only show unit container when applicable
  if (!content.isTextTable && unitDisplayMode !== 'none') {
    tableModule.appendChild(unitContainer);
  }
  tableModule.appendChild(table);
  container.appendChild(tableModule);

  // Initial conversion: if display mode forces a unit different from initial data unit
  ensureInitialConversion(container, unitDisplayMode);
  return container;
}

// Create a unit label DOM element, with optional interactive behavior for both mode
function createUnitLabel(unit, tableId, container, unitContainer, displayText, interactive) {
  const label = document.createElement('label');
  label.className = 'pify_unit_label';
  label.setAttribute('role', 'radio');
  label.dataset.unit = unit;

  const radio = document.createElement('input');
  radio.type = 'radio';
  radio.name = `unit_${tableId}`;
  radio.value = unit;

  const text = document.createElement('span');
  text.textContent = displayText;
  label.appendChild(radio);
  label.appendChild(text);

  if (interactive) {
    radio.checked = container.dataset.currentUnit === unit;
    label.setAttribute('aria-checked', radio.checked ? 'true' : 'false');
    label.tabIndex = radio.checked ? 0 : -1;

    // Ensure native radio interaction triggers unit change and UI sync
    radio.addEventListener('change', () => {
      handleUnitChange(unit, container);
      // Sync checked/aria-checked across the group
      if (unitContainer) syncUnitControls(unitContainer, unit);
    });

    // Allow clicking on label/span to select; do not block native input clicks
    label.addEventListener('click', (e) => {
      // If clicking NOT on the input itself, programmatically check and dispatch change
      if (e.target !== radio) {
        if (!radio.checked) {
          radio.checked = true;
          // Dispatch change to keep logic centralized
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      // Otherwise, let native radio click handle the change
    });

    label.addEventListener('keydown', (e) => {
      const key = e.key;
      const labels = Array.from(unitContainer.querySelectorAll('.pify_unit_label'));
      const currentIndex = labels.findIndex(l => l.dataset.unit === unit);
      if (key === ' ' || key === 'Enter') {
        e.preventDefault();
        if (!radio.checked) {
          radio.checked = true;
        }
        // Fire change to reuse the same handler logic
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (key === 'ArrowRight' || key === 'ArrowLeft') {
        e.preventDefault();
        const dir = key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (currentIndex + dir + labels.length) % labels.length;
        labels[nextIndex]?.focus();
      } else if (key === 'Home') {
        e.preventDefault();
        labels[0]?.focus();
      } else if (key === 'End') {
        e.preventDefault();
        labels[labels.length - 1]?.focus();
      }
    });
  } else {
    radio.checked = true;
    label.setAttribute('aria-checked', 'true');
    label.tabIndex = 0;
  }

  return label;
}
function renderText(content) {
  const container = document.createElement('div');
  container.className = 'pify_text_container';
  container.innerHTML = content;
  return container;
}

function resolveImagePath(path) {
  if (!path) return '';

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  const env = getEnvironment();
  if (env === 'development') {
    const normalizedPath = path.startsWith('/') ? path : '/' + path;
    return 'https://localhost' + normalizedPath;
  }

  if (path.startsWith('/')) {
    const baseUrl = getApiBaseUrl();
    return baseUrl + path;
  }

  return path;
}

function setContainerSizeClassByNaturalWidth(container, width) {
  var cMin = 'pify_image_container--min';
  var cMed = 'pify_image_container--medium';
  var cLg = 'pify_image_container--large';
  container.classList.remove(cMin, cMed, cLg);
  if (width < 500) {
    container.classList.add(cMin);
  } else if (width < 750) {
    container.classList.add(cMed);
  } else {
    container.classList.add(cLg);
  }
  container.dataset.classifiedBy = 'natural';
}

// Note: classification now relies on image natural width; no resize observer needed.

function renderImage(content) {
  const container = document.createElement('div');
  container.className = 'pify_image_container';

  const img = document.createElement('img');
  img.src = resolveImagePath(content);
  // A11y: if no alt provided, treat as decorative to avoid noisy labels
  img.alt = '';

  img.onload = function () {
    container.dataset.naturalWidth = String(img.naturalWidth || 0);
    container.dataset.naturalHeight = String(img.naturalHeight || 0);
    setContainerSizeClassByNaturalWidth(container, img.naturalWidth || 0);
  };

  if (img.complete && img.naturalWidth) {
    try { img.onload(); } catch (e) {}
  }

  img.onerror = function () {
    this.style.display = 'none';
    const errorText = document.createElement('div');
    errorText.className = 'pify_image_error';
    container.appendChild(errorText);
  };

  container.appendChild(img);
  return container;
}

function formatNumber(num) {
  const maxDecimals = (window.settings && window.settings.maxDecimals !== undefined) ? parseInt(window.settings.maxDecimals, 10) : 2;
  const formatted = parseFloat(num).toFixed(maxDecimals);
  return parseFloat(formatted).toString();
}

// Convert range values like "99-100" for unit conversion
function convertRangeValue(value, fromUnit, toUnit) {
  if (typeof value !== 'string') {
    return value;
  }
  
  // Check if it's a range value (contains dash)
  if (value.includes('-')) {
    const parts = value.split('-');
    if (parts.length === 2) {
      const start = parseFloat(parts[0].trim());
      const end = parseFloat(parts[1].trim());
      
      if (!isNaN(start) && !isNaN(end)) {
        let convertedStart, convertedEnd;
        
        if (fromUnit === 'cm' && toUnit === 'inch') {
          convertedStart = start / 2.54;
          convertedEnd = end / 2.54;
        } else if (fromUnit === 'inch' && toUnit === 'cm') {
          convertedStart = start * 2.54;
          convertedEnd = end * 2.54;
        } else {
          return value; // No conversion needed
        }
        
        // Format the converted values
        return formatNumber(convertedStart) + '-' + formatNumber(convertedEnd);
      }
    }
  }
  
  // If not a range, try to convert as a single number
  const numValue = parseFloat(value);
  if (!isNaN(numValue)) {
    if (fromUnit === 'cm' && toUnit === 'inch') {
      return formatNumber(numValue / 2.54);
    } else if (fromUnit === 'inch' && toUnit === 'cm') {
      return formatNumber(numValue * 2.54);
    }
  }
  
  // Return original value if no conversion is possible
  return value;
}

// ===== Reusable helpers for unit labels, initial unit, and table conversion =====
function getUnitTexts() {
  const cmText = window.settings?.unitLabels?.cmText || 'cm';
  const inchText = window.settings?.unitLabels?.inchText || 'inch';
  return { cmText, inchText };
}

// Display texts: prefer custom labels, fallback to uppercased defaults
function getUnitDisplayTexts() {
  const { cmText, inchText } = getUnitTexts();
  const cmDisplay = window.settings?.unitLabels?.cmText || cmText.toUpperCase();
  const inchDisplay = window.settings?.unitLabels?.inchText || inchText.toUpperCase();
  return { cmDisplay, inchDisplay };
}

function computeInitialUnit(unitDisplayMode, originalUnit) {
  if (unitDisplayMode === 'both' || unitDisplayMode === 'none') return originalUnit;
  if (unitDisplayMode === 'cm' || unitDisplayMode === 'inch') return unitDisplayMode;
  return originalUnit || 'cm';
}

function buildSizeDetailsUnitControlsHTML(unitDisplayMode, radioGroupName, initialUnit, cmText, inchText) {
  if (unitDisplayMode === 'none') {
    // Return a placeholder header cell to keep columns aligned when unit controls are hidden
    return '<th class="size-details-unit-container size-details-unit-container--placeholder" aria-hidden="true"></th>';
  }

  const singleLabel = `
    <span class="pify_unit_label size-details-unit size-details-unit-label" role="radio" aria-checked="true" data-group="${radioGroupName}" data-unit="${initialUnit}">
      <span>${initialUnit === 'cm' ? cmText : inchText}</span>
    </span>`;

  const bothLabels = `
    <span class="pify_unit_label size-details-unit size-details-unit-label" role="radio" aria-checked="${initialUnit === 'cm'}" data-group="${radioGroupName}" data-unit="cm" onclick="handleSizeDetailsUnitChange(this, 'cm')">
      <span>${cmText}</span>
    </span>
    <span class="pify_unit_label size-details-unit size-details-unit-label" role="radio" aria-checked="${initialUnit === 'inch'}" data-group="${radioGroupName}" data-unit="inch" onclick="handleSizeDetailsUnitChange(this, 'inch')">
      <span>${inchText}</span>
    </span>`;

  return `
    <th>
      <div class="size-details-unit-container" role="radiogroup">
        ${unitDisplayMode === 'both' ? bothLabels : singleLabel}
      </div>
    </th>`;
}

function cacheTableOriginalData(tableEl, cacheOwnerEl) {
  if (!tableEl || !cacheOwnerEl) return;
  if (cacheOwnerEl.dataset.originalData) return;

  const originalData = [];
  const rows = tableEl.querySelectorAll('tbody tr, tr:not(:first-child)');
  rows.forEach(row => {
    const rowData = [];
    const cells = row.querySelectorAll('td');
    cells.forEach((cell, index) => {
      if (index > 0 && cell.textContent !== '-') {
        rowData.push(cell.textContent.trim());
      } else {
        rowData.push(cell.textContent);
      }
    });
    originalData.push(rowData);
  });
  cacheOwnerEl.dataset.originalData = JSON.stringify(originalData);
}

function convertTableFromTo(tableEl, cacheOwnerEl, fromUnit, toUnit) {
  if (!tableEl || !cacheOwnerEl) return;

  // Check for precomputed data
  if (cacheOwnerEl.dataset.hasPrecomputedData === 'true') {
    const targetDataKey = toUnit === 'inch' ? 'tableDataINCH' : 'tableDataCM';
    const targetDataStr = cacheOwnerEl.dataset[targetDataKey];
    const headersStr = cacheOwnerEl.dataset.tableHeaders;

    if (targetDataStr && headersStr) {
      const targetData = JSON.parse(targetDataStr);
      const headers = JSON.parse(headersStr);
      const rows = tableEl.querySelectorAll('tbody tr, tr:not(:first-child)');

      let dataRowIndex = 0;
      rows.forEach((row) => {
        const cells = row.querySelectorAll('td');
        if (cells.length > 0) {
          // Use index to find rowData instead of name matching to support empty first columns
          // This fixes the issue where rows with empty first column values would all map to the first matching empty row
          const rowData = targetData[dataRowIndex];
          dataRowIndex++;

          if (rowData) {
            cells.forEach((cell, index) => {
              // For precomputed data, we MUST update the first column (index 0) as well
              // because tableDataINCH might have recovered labels that are empty in tableDataCM.
              // If we skip index 0, the DOM will keep showing the old value (empty) even if we have the correct label in data.
              const header = headers[index];
              const key = Object.keys(rowData).find(k => k === header);
              const value = key ? rowData[key] : '-';
              cell.textContent = value;
            });
          }
        }
      });
      return;
    }
  }

  if (!cacheOwnerEl.dataset.originalData) return;
  const originalData = JSON.parse(cacheOwnerEl.dataset.originalData);
  const rows = tableEl.querySelectorAll('tbody tr, tr:not(:first-child)');
  rows.forEach((row, rowIndex) => {
    const cells = row.querySelectorAll('td');
    cells.forEach((cell, index) => {
      if (index > 0 && cell.textContent !== '-') {
        if (originalData[rowIndex] && originalData[rowIndex][index] !== undefined) {
          const originalValue = originalData[rowIndex][index];
          const convertedValue = convertRangeValue(originalValue, fromUnit, toUnit);
          cell.textContent = convertedValue;
        }
      }
    });
  });
}

// Ensure initial conversion for single-mode when original differs from current
function ensureInitialConversion(container, unitDisplayMode) {
  if (!container) return;
  if ((unitDisplayMode === 'cm' || unitDisplayMode === 'inch') && (container.dataset.initialUnit !== container.dataset.currentUnit)) {
    handleUnitChange(container.dataset.currentUnit, container);
  }
}

function handleUnitChange(newUnit, container) {
  container.dataset.currentUnit = newUnit;
  // Sync label ARIA and roving tabindex for radiogroup
  const unitGroup = container.querySelector('.pify_unit_container');
  if (unitGroup) {
    syncUnitControls(unitGroup, newUnit);
    // Reflect checked state on inputs as well
    const inputs = unitGroup.querySelectorAll('input[type="radio"]');
    inputs.forEach(inp => {
      inp.checked = (inp.value === newUnit);
    });
  }

  const table = container.querySelector('.pify_size_table');
  if (!table) return;

  const initialUnit = container.dataset.initialUnit || 'cm';
  if (!container.dataset.originalData) {
    cacheTableOriginalData(table, container);
    container.dataset.originalUnit = initialUnit;
  }
  const originalUnit = container.dataset.originalUnit || initialUnit;
  convertTableFromTo(table, container, originalUnit, newUnit);
  // A11y: announce unit change to screen readers
  updateLiveRegion(`Unit changed to ${String(newUnit).toUpperCase()}`);
}

// Keep unit radiogroup labels in sync with current selection
function syncUnitControls(unitContainer, activeUnit) {
  const labels = unitContainer.querySelectorAll('.pify_unit_label');
  labels.forEach(label => {
    const isActive = label.dataset.unit === activeUnit;
    label.setAttribute('aria-checked', isActive ? 'true' : 'false');
    label.tabIndex = isActive ? 0 : -1;
  });
}

function createModal(sizeChart,index) {
  if(sizeChart.code == "a1a7e74c-d89a-49dc-996f-eab1d70d0503" || sizeChart.code == "8f98ab4c-26c5-4e4f-9a7b-f7f7774fd11e" || sizeChart.code == "d9e46f01-1873-4e18-841a-fcffc141b028"){
    const link = document.createElement("a");
    link.setAttribute("tabindex", "0");
    link.className = "item";
    if (index === 0) {
      link.classList.add('active');
    }
    link.setAttribute("data-name", sizeChart.name.toLowerCase());
    link.textContent = sizeChart.name;

    document.querySelector('.main-tab').append(link);

    // Modal
    
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'overlay ' + sizeChart.name.toLowerCase();

    if (index === 0) {
      modalOverlay.classList.add('active');
    }

    const modalContent = document.createElement('div');
    modalContent.className = 'pify_modal_content';

    // close button
    const closeButton = document.createElement('button');
    closeButton.className = 'pify_close_button';
    closeButton.innerHTML = '✕';

    // tab
    const tabsContainer = document.createElement('div');
    tabsContainer.className = 'pify_tabs_container hidden';

    // Content area
    const contentContainer = document.createElement('div');
    contentContainer.className = 'pify_size_chart_content';

    // Create tabs - using data from sizeChart.settings.blocks
    const tabs = sizeChart.settings.blocks;
    var click = null;
    tabs.forEach((tab, index) => {
      const tabElement = document.createElement('div');
      tabElement.className = `pify_tab ${index === 0 ? 'pify_tab_active' : ''}`;
      tabElement.textContent = tab.name;
      // tabElement.onclick = () => switchTab(index, contentContainer, sizeChart,click=true);
      tabElement.onclick = () => switchTab(index, contentContainer, sizeChart, tabElement,click=true);
      tabsContainer.appendChild(tabElement);
    });

    // Assemble modal
  //   modalContent.appendChild(closeButton);
    modalContent.appendChild(tabsContainer);
    modalContent.appendChild(contentContainer);
    modalOverlay.appendChild(modalContent);

    // Close events
    closeButton.onclick = () => modalOverlay.remove();
    modalOverlay.onclick = (e) => {
      if (e.target === modalOverlay) {
        modalOverlay.remove();
      }
    };

    switchTab(0, contentContainer, sizeChart,false);

    return modalOverlay;
  }
}

// A11y: shared utility to announce messages in a polite live region
function updateLiveRegion(message) {
  // Find live region inside the current modal
  const region = document.querySelector('.pify_modal_content .pify_live_region');
  if (!region) return;
  // Clear then set to ensure announcement is fired
  region.textContent = '';
  // Use requestAnimationFrame to avoid batching text updates
  window.requestAnimationFrame(() => {
    region.textContent = String(message || '');
  });
}

// A11y: announce within a given root (inline content wrapper)
function updateInlineLiveRegion(root, message) {
  if (!root) return;
  const region = root.querySelector('.pify_live_region');
  if (!region) return;
  region.textContent = '';
  window.requestAnimationFrame(() => {
    region.textContent = String(message || '');
  });
}

function switchTab(selectedIndex, contentContainer, sizeChart) {
  const tabs = document.querySelectorAll('.pify_modal_content .pify_tab');
  tabs.forEach((tab, index) => {
    if (index === selectedIndex) {
      tab.classList.add('pify_tab_active');
      // A11y: active tab state
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
    } else {
      tab.classList.remove('pify_tab_active');
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    }
  });

  contentContainer.innerHTML = '';

  // A11y: panel semantics and association
  const panelId = `pify_tabpanel_${selectedIndex}`;
  const activeTab = tabs[selectedIndex];
  contentContainer.setAttribute('role', 'tabpanel');
  contentContainer.id = panelId;
  if (activeTab) {
    const labelledBy = activeTab.id || `pify_tab_${selectedIndex}`;
    contentContainer.setAttribute('aria-labelledby', labelledBy);
  }

  // Announce tab change
  const currentTab = sizeChart.settings.blocks[selectedIndex];
  if (currentTab && currentTab.name) {
    updateLiveRegion(`Tab selected: ${currentTab.name}`);
  }

  if (currentTab && currentTab.modules) {
    currentTab.modules.forEach(module => {
      contentContainer.appendChild(renderModule(module));
    });
  }
}

function checkTagsCollectionsVendors(targeting) {
  let hasCondition = false;

  // Check Tags
  if (targeting.productTags && Array.isArray(targeting.productTags) && targeting.productTags.length > 0) {
    hasCondition = true;
    if (!window.pageData || !window.pageData.productTags || !Array.isArray(window.pageData.productTags)) return false;
    
    const hasTag = targeting.productTags.some(tag => 
      window.pageData.productTags.includes(tag)
    );
    if (!hasTag) return false;
  }

  // Check Collections
  if (targeting.selectedCollections && Array.isArray(targeting.selectedCollections) && targeting.selectedCollections.length > 0) {
    hasCondition = true;
    if (!window.pageData || !window.pageData.collectionIds || !Array.isArray(window.pageData.collectionIds)) return false;

    const hasCollection = targeting.selectedCollections.some(collection => {
      if (!collection || !collection.id) return false;
      const collectionId = collection.id.split('/').pop();
      const collectionIdStr = String(collectionId);
      return window.pageData.collectionIds.some(pageCollectionId =>
        String(pageCollectionId) === collectionIdStr
      );
    });
    if (!hasCollection) return false;
  }

  // Check Vendors
  if (targeting.selectedVendors && Array.isArray(targeting.selectedVendors) && targeting.selectedVendors.length > 0) {
    hasCondition = true;
    if (!window.pageData || !window.pageData.productVendor) return false;
    
    const hasVendor = targeting.selectedVendors.includes(window.pageData.productVendor);
    if (!hasVendor) return false;
  }

  return hasCondition;
}

function shouldDisplaySizeChart(sizeChart) {
  if (!sizeChart || !sizeChart.settings || !sizeChart.settings.targeting) {
    return false;
  }
  const isProductPage = window.location.pathname.startsWith('/products/') ||
    window.location.pathname.includes('/products/') ||
    window.location.pathname.startsWith('/products_preview');
  if (!isProductPage) {
    return false;
  }

  // Global product-level exclusion, applies to all modes
  const excludedProducts = sizeChart.settings.targeting.excludedProducts;
  if (excludedProducts && Array.isArray(excludedProducts) && window.pageData && window.pageData.productId) {
    const pageProductIdStr = String(window.pageData.productId);
    const isExcluded = excludedProducts.some(product => {
      if (!product || !product.id) return false;
      const productId = product.id.split('/').pop();
      return String(productId) === pageProductIdStr;
    });
    if (isExcluded) return false;
  }

  if (sizeChart.settings.targeting.displayPosition === 'all') return true;
  if (sizeChart.settings.targeting.displayPosition === 'products') {
    if (!window.pageData || !window.pageData.productId) return false;

    return sizeChart.settings.targeting.selectedProducts.some(product => {
      if (!product || !product.id) return false;

      const productId = product.id.split('/').pop();
      const productIdStr = String(productId);
      const pageProductIdStr = String(window.pageData.productId);

      return productIdStr === pageProductIdStr;
    });
  }
  if (sizeChart.settings.targeting.displayPosition === 'collections') {
    if (!window.pageData || !window.pageData.collectionIds || !Array.isArray(window.pageData.collectionIds)) return false;

    return sizeChart.settings.targeting.selectedCollections.some(collection => {
      if (!collection || !collection.id) return false;

      const collectionId = collection.id.split('/').pop();
      const collectionIdStr = String(collectionId);

      return window.pageData.collectionIds.some(pageCollectionId =>
        String(pageCollectionId) === collectionIdStr
      );
    });
  }
  if (sizeChart.settings.targeting.displayPosition === 'tags') {
    if (!window.pageData || !window.pageData.productTags || !Array.isArray(window.pageData.productTags)) return false;
    if (!sizeChart.settings.targeting.productTags || !Array.isArray(sizeChart.settings.targeting.productTags)) return false;

    return sizeChart.settings.targeting.productTags.some(tag =>
      window.pageData.productTags.includes(tag)
    );
  }
  if (sizeChart.settings.targeting.displayPosition === 'vendors') {
    if (!window.pageData || !window.pageData.productVendor) return false;
    const selectedVendors = sizeChart.settings.targeting.selectedVendors;
    if (!selectedVendors || !Array.isArray(selectedVendors)) return false;
    return selectedVendors.includes(window.pageData.productVendor);
  }

  if (sizeChart.settings.targeting.displayPosition === 'tags_collections_vendors') {
    return checkTagsCollectionsVendors(sizeChart.settings.targeting);
  }

  return false;
}

function getButtonContainerClasses() {
  return [
    'product-form__buttons',
    'product-form__controls',
    'product-form__actions',
    'product-form__button-container',
    'product-form__payment-container',
    'product-form__atc-container',
    'product-form__submit-container',
    'product-form__cta',
    'product-form__buttons-container',
    'product-form__add-to-cart',
    'product__submit',
    'product__buttons',
    'product-page__submit',
    'add-to-cart-container',
    'atc-btn-container',
    'button-wrapper',
    'button-container',
    'btn-wrapper',
    'form-actions',
    'product-form__buy-buttons',
    'product-form__atc-wrapper',
    'product-form__button-wrapper',
    'product-form__submit-wrapper',
    'product-form__action-wrapper',
    'product-buy-buttons',
    'product-add-to-cart',
    'product-form-inline-atc',
    'product-form__buy-now',
    'product-form__payment-buttons',
    'product-form__buttons--primary',
    'product-form__buttons--secondary',
    'button-action-wrapper',
    'btn-cart-wrapper',
    'atc-button-container',
    'product-summary__add-to-cart',
    'product-checkout-buttons'
  ];
}

function findButtonContainer(element, containerSelectors) {
  // First check if there are specific parent container class names
  const specificContainers = [
    'qty_addtocart_btns',
    'product-form__buttons',
    'product-form__controls',
    'product-form__actions',
    'product-form__button-container',
    'product-form__payment-container',
    'product-form__atc-container',
    'product-form__submit-container',
    'product-form__cta',
    'product-form__buttons-container',
    'product-form__add-to-cart',
    'product__submit',
    'product__buttons',
    'product-page__submit',
    'add-to-cart-container',
    'atc-btn-container',
    'button-wrapper',
    'button-container',
    'btn-wrapper',
    'form-actions'
  ];

  // Check all parent elements
  let currentElement = element;
  while (currentElement) {
    // Check if the current element's class name matches a specific container
    if (currentElement.classList) {
      for (const className of specificContainers) {
        if (currentElement.classList.contains(className)) {
          return currentElement;
        }
      }
    }
    currentElement = currentElement.parentElement;
  }

  // If no specific container is found, try using the provided selectors
  for (const selector of containerSelectors) {
    const container = element.closest(selector);
    if (container) {
      return container;
    }
  }

  return null;
}

function getThemeSelectors() {
  const defaultSelectors = {
    buttonSelectors: [
      'button[name="add"][type="submit"]',
      'input[name="add"][type="submit"]',
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] input[type="submit"]',
      '#AddToCart',
      '#add-to-cart',
      '[id*="AddToCart"]',
      '.product-form__submit',
      '.add-to-cart',
      '.addtocart',
      '.dT_AddToCart',
      '.add-to-cart-btn',
      'button[class*="add-to-cart"]',
      'input[class*="add-to-cart"]',
      '.btn-cart',
      '.enj-add-to-cart-btn',
      'button[name="add"]',
      'button[type="submit"]',
      'input[type="submit"]',
      'button.button-add-to-cart',
      'button.product__add-to-cart',
      'button.product-form__add-btn',
      'button.button-action',
      'button.add-to-cart-button',
      'button.js-cart-link',
      'button[aria-label="Add to cart"]',
      'button[name="add"].btn-main',
      'input[type="submit"][data-add_to_cart]',
      'input[type="submit"].add-to-cart-btn',
      'form[action*="/cart/add"]'
    ],
    containerSelectors: [
      '.product-form__buttons',
      '.product-form__controls',
      '.product-form__actions',
      '.product-form__button-container',
      '.product-form__payment-container',
      '.product-form__atc-container',
      '.product-form__submit-container',
      '.product-form__cta',
      '.product-form__buttons-container',
      '.product-form__add-to-cart',
      '.product__submit',
      '.product__buttons',
      '.product-page__submit',
      '.add-to-cart-container',
      '.atc-btn-container',
      '.button-wrapper',
      '.button-container',
      '.btn-wrapper',
      '.form-actions'
    ],
    sizeSelectorPatterns: [
      'div.variant-dropdown',
      'select[id^="template"][id*="single-option-form"]',
      'select[id*="Product-SingleOptionSelector"]',
      'select[id*="Option-template"]',
      'select.Form__Select',
      'select#option-size',
      'fieldset.product-option',
      'fieldset.product-form__input',
      'fieldset[role="radiogroup"]',
      'fieldset.js.product-form-input',
      'fieldset[data-option-name="Size"]',
      'fieldset.product-selector__wrapper',
      'div.product-option-row',
      'select.product-form__select',
      'select.product-form__variant-select',
      'div.product-form__input--dropdown select',
      'div.variant-field',
      'div.variant-swatch',
      'div.styled-pills-radio',
      'div.product-selector-option.select-size',
      'fieldset.radio__fieldset',
      'div.variant-picker__input',
      'div.variant-picker__option-values',
      'fieldset.js-product-form-input',
      'fieldset.option-selector[data-option="Size"]',
      'div.main-product__fieldset',
      'fieldset.variant-picker__input',
      'div.radio__fieldset',
      'fieldset.variant-input-wrap',
      'div.swatches__container',
      'div.js-variant-selector',
      'fieldset.js.product-form__inpt.size_main',
      'fieldset[data_options="Size"]',
      'fieldset.size_main',
      'div.swatch-element',
      'div.variant-pills-wrapper',
      'div.radio__container',
      'div.product-variant_options-wrap',
      'div.variant-options-wrap',
      'div.variant-radios div.variant-radio',
      'div.product-variant__item--size',
      'div.product-variant__item',
      'fieldset.variant-picker__buttons',
      'fieldset.variant-picker__swatches',
      'div.option-selector__btns',
      'li.size__option',
      'div.product-variant-option',
      'div.xo-product-variant__inner-value',
      'product-option[data-name="Size"]',
      'div.radio-field',
      'div.block-swatch ',
      'div.product-options__default',
      'div.options-selection__option-value',
      'div.variant-input',
      'li.BlockSwatchWrapper',
      'div.label-only-input',
      'div.form-options-wrapper',
      'div[class*="product-options-radio"]',
      'div.radios--container',
      'fieldset.variant-button-wrap',
      'li.variant--item',
      'div.inline-field-wrapper',
      'div.variant-options--wrapper',
      'li.variant-item',
      '.product-option-picker__list',
      'ul.check',
      'div.radio-container',
      'li.variant_option',
      'div.form__variants',
      'li.product-swatch-item',
      'li.swatches-list-item',
      'div.variantPickerButtonsWrap',
      'div.product__variants-radio',
      'div.options-frame',
      'span.leading-solid',
      'div[class*="form-field"]',
      'div.product__color-chips',
      'div.product-form__chip-wrapper',
      'div.option-group__chips-container',
      'div.product-variant-picker__pill-list',
      'ul.clickyboxes',
      'div.product-form__swatch__item',
      'div.product-form__controls-group',
      'div.single-option-selector__wrap-option',
      'fieldset.variant-input-wrapper',
      'select.product-variant-container',
      'select.single-option-selector',
      'select.input-select__select',
      'div.product-form__input-wrapper',
      'div.hdt-product-form__values',
      'div.variant-input-wrap',
      'fieldset.variant-option--buttons',
      'div.t4s-swatch__list',
      'div.product-options__section',
      'div.swatch-group_wrapper',
      'div.input-group',
      'div.swt-type-button',
      'div.product-single-option',
      'div.variants__options',
      'fieldset.product-variant-form-input',
      'div.prd-size',
      'span.option-item[data-option="size"]',
      'div.selector-wrapper',
      'div.tawcvs-swatches',
      'span.swatch[data-value]',
      'div.tt-wrapper',
      'div.option-block',
      'fieldset.prd-option-list',
      'div.product-form__label-container'
    ],
    variantSelectors: [
      'variant-radios',
      'variant-selects',
      'variant-selects[data-type="multiple"]'
    ],
    tooltipStyles: {
      position: 'absolute',
      bottom: '100%',
      left: '50%',
      transform: 'translateX(-50%)',
      marginBottom: '10px',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      color: 'white',
      padding: '12px',
      borderRadius: '4px',
      fontSize: '14px',
      zIndex: '999999',
      minWidth: '160px',
      maxWidth: '250px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
      pointerEvents: 'none',
      opacity: '0',
      transition: 'opacity 0.2s ease-in-out',
      whiteSpace: 'normal',
      display: 'block !important',
      visibility: 'visible !important'
    }
  };

  return {
    default: defaultSelectors,
    'electro theme': {
      ...defaultSelectors,
      sizeSelectorPatterns: [
        '.swatch-group_inner'
      ]
    },
    'wokiee': {
      ...defaultSelectors,
      sizeSelectorPatterns: [
        'div.tt-wrapper'
      ]
    },
    'nitro': {
      ...defaultSelectors,
      sizeSelectorPatterns: [
        '.bee-swatch',
        '.bee-swatch__item',
        '.bee-product-sizes',
        '.product-option-picker__list',
        '.product-option-picker__list-item',
        'span.option-item[data-option="size"]',
        'div[data-option="size"]',
        'select[name*="size"]',
        'select[name*="Size"]',
        'fieldset[data-option="Size"]',
        'div.size-selector',
        'div.variant-selector',
        'div.product-form__input',
        'div.product-form__buttons'
      ]
    }
  };
}

function getCurrentThemeSelectors() {
  // Get theme name from Shopify.theme.schema_name
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';

  const normalizedThemeName = themeName.toLowerCase();
  // Check if the theme name exactly matches known themes
  const selectors = getThemeSelectors();
  if (selectors[normalizedThemeName]) {
    return selectors[normalizedThemeName];
  }

  // If no matching theme is found, return default selectors
  return selectors.default;
}

function isTransparentColor(value) {
  if (!value) return true;
  const s = String(value).trim().toLowerCase();
  if (s === 'transparent') return true;
  if (s.startsWith('#')) {
    if (s.length === 9) {
      const aa = s.slice(7, 9);
      if (aa === '00') return true;
    } else if (s.length === 5) {
      const a = s.slice(4, 5);
      if (a === '0') return true;
    }
  }
  if (s.includes('rgba')) {
    const m = s.match(/rgba\([^,]+,[^,]+,[^,]+,\s*0(?:\.0+)?\)/);
    if (m) return true;
  }
  if (s.includes('hsla')) {
    const m = s.match(/hsla\([^,]+,[^,]+%,[^,]+%,\s*0(?:\.0+)?\)/);
    if (m) return true;
  }
  return false;
}

// Helper function to check if an element is visible
function isElementVisible(element) {
  if (!element) return false;
  const style = window.getComputedStyle(element);
  const isBasicallyVisible = style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    style.opacity !== '0';

  if (!isBasicallyVisible) return false;

  const hasSize = element.offsetWidth > 0 && element.offsetHeight > 0;

  if (hasSize) return true;

  // Consider disabled buttons as valid special buttons
  const isSpecialButton = element.tagName === 'BUTTON' ||
    element.tagName === 'INPUT' ||
    element.closest('form[action*="/cart/add"]') !== null ||
    element.hasAttribute('disabled'); // Add disabled elements as special case

  return isSpecialButton;
}

function addCustomButtons() {
  if (!window.sizeChartData || !Array.isArray(window.sizeChartData)) {
    return;
  }

  // Get current theme selectors
  const themeSelectors = getCurrentThemeSelectors();
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';

  // If there is a box with the class name "pify_size_chart_wrapper" on the page, the button will be inserted into it first.
  const pifyWrapper = document.querySelector('.block-text_EwB88D') || true;
  if (pifyWrapper) {
    // Create a button for each size chart - 完全移除容器，直接添加按钮
    window.sizeChartData.forEach((sizeChart, index) => {
    //   if (!shouldDisplaySizeChart(sizeChart)) return;

      // 简化为单层结构，只保留pify_size_chart_button
      const buttonDiv = document.createElement('div');
      buttonDiv.className = 'pify_size_chart_button pify_inline_button';
      
      // 设置按钮的自定义属性，用于CSS样式应用
      const buttonStyle = window.settings?.inlineButton?.style || {};
      if (buttonStyle.backgroundColor) {
        buttonDiv.style.setProperty('--button-bg-color', buttonStyle.backgroundColor);
      }
      if (buttonStyle.color) {
        buttonDiv.style.setProperty('--button-text-color', buttonStyle.color);
      }
      if (buttonStyle.borderColor) {
        buttonDiv.style.setProperty('--button-border-color', buttonStyle.borderColor);
      }
      if (buttonStyle.borderRadius) {
        buttonDiv.style.setProperty('--button-border-radius', buttonStyle.borderRadius);
      }
      if (buttonStyle.borderWidth) {
        buttonDiv.style.setProperty('--button-border-width', buttonStyle.borderWidth);
      }
      if (buttonStyle.fontSize) {
      buttonDiv.style.setProperty('--button-font-size', buttonStyle.fontSize);
    }
    if (buttonStyle.textDecoration) {
      buttonDiv.style.setProperty('--button-text-decoration', buttonStyle.textDecoration);
    }

      // 创建按钮图标
      createButtonIcon(buttonDiv);

      const textSpan = document.createElement('span');
      textSpan.className = 'pify_button_text';
      textSpan.textContent = window.settings?.buttonText || 'Size Chart';
      buttonDiv.appendChild(textSpan);
     const modal = createModal(sizeChart,index);
    document.querySelector('#size-chart-data').appendChild(modal);

      buttonDiv.addEventListener('click', function () {
      });

    //   pifyWrapper.appendChild(buttonDiv);
    });

    return;
  }
  
  // 根据按钮类型决定创建哪种按钮
  const buttonType = window.settings?.buttonType || 'inline';
  
  // 如果是纯浮动按钮，只创建浮动按钮
  if (buttonType === 'floating') {
    applyFloatingToContainer();
    return;
  }
  
  // 如果是both类型，先创建浮动按钮
  if (buttonType === 'both') {
    applyFloatingToContainer();
  }
  
  // Custom selectors take priority
  const userSelector = window.settings?.inlineButton?.cssSelector;
  let targetElement = null;

  // Try to use custom selector
  if (userSelector) {
    const elements = document.querySelectorAll(userSelector);
    for (const element of elements) {
      if (isElementVisible(element)) {
        targetElement = element;
        break;
      }
    }
  }

  // If custom selector didn't find visible elements, try theme-specific selectors
  if (!targetElement) {
    const themeButtonConfigs = {
      'vantage': {
        selector: '.product-add.clearfix input[type="submit"][name="button"].AddtoCart',
        useContainer: false
      },
      'machina': {
        selector: '.add-to-cart__wrapper.product-form-margin-bottom .add-to-cart__submit .atc-container button[type="submit"][name="add"].add-to-cart-button',
        useContainer: false
      },
      'noire': {
        customHandler: () => {
          // Look for Add to cart button inside item-field container
          const itemFields = document.querySelectorAll('.item-field');
          for (const itemField of itemFields) {
            const addToCartButton = itemField.querySelector('button[type="submit"][name="add"].button.add-to-cart-button.primary-button.text-capitalize');
            if (addToCartButton && isElementVisible(addToCartButton)) {
              // Set the item-field container as target element so we can place size chart button after it
              return itemField;
            }
          }

          // Fallback: if no item-field found, look for any non-floated Add to cart button
          const allNoireButtons = document.querySelectorAll('button[type="submit"][name="add"]');
          for (const button of allNoireButtons) {
            if (!isElementVisible(button)) continue;

            const form = button.closest('form');
            const isFloatedForm = form && form.id && form.id.includes('floated-product-form');

            if (!isFloatedForm) {
              return button;
            }
          }
          return null;
        }
      },
      'nexa': {
        selector: '.main-product_form-btns',
        useContainer: false
      },
      'whisk': {
        selector: '.featured-product__add-to-cart-button',
        useContainer: false
      },
      'zero': {
        selector: '.main-product_atc-btn',
        useContainer: false
      },
      'mono': {
        selector: '.button--primary-outline',
        useContainer: false
      },
      'roam': {
        selector: '.btn-full-width',
        useContainer: false
      },
      'maranello': {
        selector: '.product-actions',
        useContainer: false
      },
      'multi': {
        selector: '[class*="product-form-add-to-cart"]',
        useContainer: false
      },
      'enterprise': {
        selector: '.product-info__add-to-cart',
        useContainer: false
      },
      'align': {
        selector: '.button.button--add-to-cart[name="add"]',
        useContainer: false
      },
      'xtra': {
        selector: '.f8pr-button',
        useContainer: false
      },
      'avenue': {
        selector: '.purchase-section',
        useContainer: false
      },
      'atlantic': {
        selector: '.product-submit',
        useContainer: false
      },
      'tailor': {
        selector: '.button-action',
        useContainer: false
      },
      'label': {
        customHandler: () => {
          const labelButton = document.querySelector('.add-to-cart-btn');
          if (labelButton && isElementVisible(labelButton)) {
            const flexContainer = labelButton.closest('.lg\\:flex');
            return flexContainer || labelButton;
          }
          return null;
        }
      },
      'momentum': {
        selector: '.product--add-to-cart-button',
        useContainer: false
      },
      'lumin': {
        selector: '.product-common_btns-wrap',
        useContainer: false
      },
      'satoshi': {
        selector: '#product-actions',
        useContainer: false
      },
      'responsive': {
        selector: '.purchase-details__buttons',
        useContainer: false
      },
      'zest': {
        selector: 'button[id*="ProductSubmitButton-template"].f-product-form__submit.btn.btn--secondary, .f-product-form__submit.btn.btn--secondary',
        useContainer: false
      },
      'pinnacle': {
        selector: '.single-add-to-cart-button',
        useContainer: false
      },
      'minimog - os 2.0': {
        selector: '.m-product-form--wrapper',
        useContainer: false
      },
      'porto': {
        selector: '.add-to-cart-box',
        useContainer: false
      },
      'lezada os 2.0': {
        selector: '.product-cart-action',
        useContainer: false
      },
      'lumia': {
        selector: '.row.gx-2.gx-xl-3.gy-3',
        useContainer: false
      },
      'elomus': {
        selector: '.button-cart',
        useContainer: false
      },
      'goodwin': {
        selector: '.btn-wrap',
        useContainer: false
      },
      'vinova modamate': {
        selector: '.product-form__item--quantity',
        useContainer: false
      },
      'foxic': {
        selector: '.btn-wrap',
        useContainer: false
      },
      'lusion': {
        selector: '.form-add-cart',
        useContainer: false
      },
      'lusion-christmas': {
        selector: '.form-add-cart',
        useContainer: false
      },
      'aero': {
        selector: '.btn-wishlist',
        useContainer: false
      },
      'corano': {
        selector: '.product-cart-action',
        useContainer: false
      },
      'unero': {
        selector: '.single-add-to-cart-btn',
        useContainer: false
      },
      'vinova salehup': {
        selector: '.product-form__item--submit',
        useContainer: false
      },
      'learts - shopify theme ': {
        selector: '.product-cart-action',
        useContainer: false
      },
      'ella': {
        selector: '.product-form__buttons',
        useContainer: false
      },
      'ecomus': {
        selector: '.hdt-product-form__submit',
        useContainer: false
      },
      'optimal': {
        selector: '.pr_btn',
        useContainer: false
      },
      'ritual': {
        selector: '.product-form-buttons',
        useContainer: false
      },
      'shella': {
        selector: '.product-page-info__button-add-to-cart',
        useContainer: false
      },
      'atelier': {
        selector: '.product-form-buttons',
        useContainer: false
      },
      'lusion-fashion-women': {
        selector: '.gp-product-main-button',
        useContainer: false
      },
      'roxxe': {
        selector: '.product-add-to-cart-wrapper',
        useContainer: false
      },
      'lusion-minimalist': {
        selector: '.product-form--payment-button-no-variants',
        useContainer: false
      },
    };

    const themeConfig = themeButtonConfigs[themeName];
    if (themeConfig) {
      if (themeConfig.customHandler) {
        targetElement = themeConfig.customHandler();
      } else if (themeConfig.selector) {
        const foundElement = document.querySelector(themeConfig.selector);
        if (foundElement && isElementVisible(foundElement)) {
          targetElement = foundElement;
        }
      }
    }

    if (!targetElement) {
      const allButtons = document.querySelectorAll('button[type="submit"], input[type="submit"], button.product-buy-buttons--primary, button-content');
      const addToCartButtons = Array.from(allButtons).filter(button =>
        hasAddToCartText(button) && isElementVisible(button)
      );

      if (addToCartButtons.length > 1) {
        // If there are multiple buttons, try to find the correct one
        // 1. First check the parent element of the button
        const productForm = document.querySelector('form[action="/cart/add"]');
        if (productForm) {
          // Look for the button inside the form
          const formButton = productForm.querySelector('button[type="submit"], input[type="submit"], button-content');
          if (formButton && isElementVisible(formButton)) {
            targetElement = formButton;
          }
        }

        // 2. If not found, check the position of the button
        if (!targetElement) {
          const productInfo = document.querySelector('.product__info, .product-info, .product-details');
          if (productInfo) {
            // Look for the button in the product information area
            const infoButton = productInfo.querySelector('button[type="submit"], input[type="submit"], button-content');
            if (infoButton && isElementVisible(infoButton)) {
              targetElement = infoButton;
            }
          }
        }

        // 3. If still not found, use specific class names
        if (!targetElement) {
          const specificButton = addToCartButtons.find(button =>
            button.classList.contains('ux-cart') ||
            button.classList.contains('button--add-to-cart') ||
            button.classList.contains('product-buy-buttons--primary') ||
            button.classList.contains('product-form__submit') ||
            button.classList.contains('overlay-buy_button') ||
            button.closest('.product-form__buttons') ||
            button.closest('.product-form__submit')
          );
          if (specificButton) {
            targetElement = specificButton;
          }
        }

        // 4. If still not found, select the last visible button
        if (!targetElement) {
          targetElement = addToCartButtons[addToCartButtons.length - 1];
        }
      } else if (addToCartButtons.length === 1) {
        targetElement = addToCartButtons[0];
      }
    }
    if (!targetElement) {
      for (const selector of themeSelectors.buttonSelectors) {
        const elements = document.querySelectorAll(selector);
        for (const element of elements) {
          if (isElementVisible(element)) {
            if (hasAddToCartText(element) || isInAddToCartForm(element)) {
              targetElement = element;
              break;
            }
          }
        }
        if (targetElement) break;
      }
    }
  }

  const position = window.settings?.inlineButton?.detailedPosition || 'above';

  // 创建按钮容器（简化为单层结构）
  const container = document.createElement('div');
  container.className = 'pify_inline_buttons_container';

  // Create a button for each size chart
  window.sizeChartData.forEach((sizeChart, index) => {
    if (!shouldDisplaySizeChart(sizeChart)) return;

    // 简化为单层结构，只保留pify_size_chart_button
    const buttonDiv = document.createElement('div');
    buttonDiv.className = 'pify_size_chart_button pify_inline_button';
    
    // 设置按钮的自定义属性，用于CSS样式应用
    const buttonStyle = window.settings?.inlineButton?.style || {};
    if (buttonStyle.backgroundColor) {
      buttonDiv.style.setProperty('--button-bg-color', buttonStyle.backgroundColor);
    }
    if (buttonStyle.color) {
      buttonDiv.style.setProperty('--button-text-color', buttonStyle.color);
    }
    if (buttonStyle.borderColor) {
      buttonDiv.style.setProperty('--button-border-color', buttonStyle.borderColor);
    }
    if (buttonStyle.borderRadius) {
      buttonDiv.style.setProperty('--button-border-radius', buttonStyle.borderRadius);
    }
    if (buttonStyle.borderWidth) {
      buttonDiv.style.setProperty('--button-border-width', buttonStyle.borderWidth);
    }
    if (buttonStyle.fontSize) {
      buttonDiv.style.setProperty('--button-font-size', buttonStyle.fontSize);
    }
    if (buttonStyle.textDecoration) {
      buttonDiv.style.setProperty('--button-text-decoration', buttonStyle.textDecoration);
    }

    // 创建按钮图标
    createButtonIcon(buttonDiv);

    const textSpan = document.createElement('span');
    textSpan.className = 'pify_button_text';
    textSpan.textContent = window.settings?.buttonText || 'Size Chart';
    buttonDiv.appendChild(textSpan);

    buttonDiv.addEventListener('click', function () {
    });

    container.appendChild(buttonDiv);
  });

  // Try to search for the product information container
  const productInfoContainers = document.querySelectorAll('.product__info-container');
  let visibleProductInfoContainer = null;
  for (const container of productInfoContainers) {
    if (isElementVisible(container)) {
      visibleProductInfoContainer = container;
      break;
    }
  }

  // If the target element has not been found yet, try to look for the "Buy it now" button.
  if (!targetElement) {
    const buyItNowButtons = document.querySelectorAll('button, input[type="submit"], a');
    for (const button of buyItNowButtons) {
      if (isElementVisible(button)) {
        const textContent = (button.textContent || '').toLowerCase();
        const value = (button.value || '').toLowerCase();

        if (textContent.includes('buy it now') || value.includes('buy it now') ||
          textContent.includes('buy now') || value.includes('buy now')) {
          targetElement = button;
          break;
        }
      }
    }
  }

  // If the target element has not been found, try to search for the titles that have the "product__title" class name.
  if (!targetElement) {
    const productTitleElements = document.querySelectorAll('.product__title, .product-title, h1.product__title, h1.product-title');
    for (const titleElement of productTitleElements) {
      if (isElementVisible(titleElement)) {
        targetElement = titleElement;
        break;
      }
    }
  }

  if (targetElement) {
    // Atlantic theme special handling
    if (themeName === 'atlantic' && targetElement.classList.contains('product-submit')) {
      targetElement.parentNode.insertBefore(container, targetElement);
      return;
    }

    // Satoshi theme special handling - insert outside the #product-actions container
    if (themeName === 'satoshi' && targetElement.id === 'product-actions') {
      targetElement.parentNode.insertBefore(container, targetElement);
      return;
    }

    // Lumia theme special handling - insert outside the row container
    if (themeName === 'lumia' && targetElement.classList.contains('row')) {
      targetElement.parentNode.insertBefore(container, targetElement);
      return;
    }

    // If the target element exists, use the new insertion logic
    const buttonContainer = findButtonContainer(targetElement, themeSelectors.containerSelectors);
    const parentElement = targetElement.parentElement;
    const grandParentElement = parentElement?.parentElement;

    if (position === 'above') {
      if (buttonContainer) {
        // If the button container is found, insert it above the container
        buttonContainer.parentNode.insertBefore(container, buttonContainer);
      } else if (parentElement) {
        // If there is a parent element, insert it above the parent element
        parentElement.parentNode.insertBefore(container, parentElement);
      } else if (grandParentElement) {
        // If there is a grandparent element, try to insert it into the grandparent element
        grandParentElement.insertBefore(container, parentElement);
      } else {
        // If there is no suitable parent element, insert it directly in front of the target element
        targetElement.parentNode.insertBefore(container, targetElement);
      }
    } else if (position === 'below') {
      if (buttonContainer) {
        // If the button container is found, insert it below the container
        buttonContainer.parentNode.insertBefore(container, buttonContainer.nextSibling);
      } else if (parentElement) {
        // If there is a parent element, insert it below the parent element
        parentElement.parentNode.insertBefore(container, parentElement.nextSibling);
      } else if (grandParentElement) {
        // If there is a grandparent element, try to insert it into the grandparent element
        grandParentElement.insertBefore(container, parentElement.nextSibling);
      } else {
        // If there is no suitable parent element, insert it directly behind the target element
        targetElement.parentNode.insertBefore(container, targetElement.nextSibling);
      }
    } else if (position === 'inside' && buttonContainer) {
      // If the position is inside and there is a button container
      buttonContainer.insertBefore(container, targetElement);
    } else {
      // Default behavior: insert it in front of the target element
      targetElement.parentNode.insertBefore(container, targetElement);
    }
  } else if (visibleProductInfoContainer) {
    // Only use the product information container as a fallback if no add to cart button is found
    visibleProductInfoContainer.appendChild(container);
  } else {
    // Collect container information on the page
    exceptionCollector.collect(
      'sizechart_button_placement',
      'Failed to find target element for size chart button placement'
    );
  }

  if (
    themeName === 'shella' &&
    targetElement.classList.contains('product-page-info__button-add-to-cart')
  ) {
    const w100 = targetElement.closest('.w-100');
    if (w100) {
      const dFlex = w100.closest('.d-flex');
      if (dFlex && dFlex.parentNode) {
        dFlex.parentNode.insertBefore(container, dFlex);
        return;
      }
    }
  }
}

// Floating button
function applyFloatingToContainer() {
  // Create button for each size chart
  window.sizeChartData.forEach((sizeChart, index) => {
    if (!shouldDisplaySizeChart(sizeChart)) return;

    // Simplify to single-layer structure, only keep pify_floating_button
    const buttonDiv = document.createElement('div');
    buttonDiv.className = 'pify_floating_button';
    const accessibleLabel = (window.settings?.buttonText || 'Size Chart').trim();
    buttonDiv.setAttribute('aria-label', accessibleLabel);
    buttonDiv.setAttribute('role', 'button');
    buttonDiv.tabIndex = 0;
    
    // Set button custom attributes for CSS style application
    const buttonStyle = window.settings?.floatingButton?.style || {};
    if (buttonStyle.backgroundColor) {
      buttonDiv.style.setProperty('--button-bg-color', buttonStyle.backgroundColor);
    }
    if (buttonStyle.color) {
      buttonDiv.style.setProperty('--button-text-color', buttonStyle.color);
    }
    if (buttonStyle.borderColor) {
      buttonDiv.style.setProperty('--button-border-color', buttonStyle.borderColor);
    }
    if (buttonStyle.borderRadius) {
      buttonDiv.style.setProperty('--button-border-radius', buttonStyle.borderRadius);
    }
    if (buttonStyle.borderWidth) {
      buttonDiv.style.setProperty('--button-border-width', buttonStyle.borderWidth);
    }
    if (buttonStyle.fontSize) {
      buttonDiv.style.setProperty('--button-font-size', buttonStyle.fontSize);
    }
    if (buttonStyle.textDecoration) {
      buttonDiv.style.setProperty('--button-text-decoration', buttonStyle.textDecoration);
    }

    // Add text
    const textSpan = document.createElement('span');
    textSpan.className = 'pify_button_text';
    textSpan.textContent = window.settings?.buttonText || 'Size Chart';
    buttonDiv.appendChild(textSpan);
    (function(){
      var btnText = textSpan.textContent || '';
      var isCJK = /[\u4E00-\u9FFF\u3040-\u30FF\uAC00-\uD7AF]/.test(btnText);
      if (isCJK) {
        textSpan.classList.add('pify_cjk');
      }
      })();

    // Add icon
    createButtonIcon(buttonDiv, buttonStyle.fontSize || '16px');

    // Add click event
    buttonDiv.addEventListener('click', () => {
      const modal = createModal(sizeChart);
      document.body.appendChild(modal);
    });

    // Keyboard activation consistency (Enter/Space)
    buttonDiv.addEventListener('keydown', (event) => {
      if (event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        buttonDiv.click();
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        buttonDiv.click();
      }
    });

    // Add button directly to body, no additional container needed
    document.body.appendChild(buttonDiv);
  });

  // Set floating positioning styles
  const applyPositionStyles = () => {
    const buttons = document.querySelectorAll('.pify_floating_button');
    const isMobile = window.innerWidth <= 768;
    const position = isMobile 
      ? (window.settings?.floatingButton?.mobileFloatingPosition || window.settings?.floatingButton?.floatingPosition || 'top-right')
      : (window.settings?.floatingButton?.floatingPosition || 'middle-right');
    
    buttons.forEach(button => {
      // Add position class name
      button.className = button.className.replace(/pify_position_\S+/g, '');
      button.classList.add(`pify_position_${position.replace('-', '_')}`);
      
      if (isMobile) {
        button.classList.add('pify_mobile');
        button.classList.remove('pify_desktop');
      } else {
        button.classList.add('pify_desktop');
        button.classList.remove('pify_mobile');
      }
    });
  };
  
  applyPositionStyles();
  
  // Add window resize listener for reapplying styles when switching between mobile and desktop
  const handleResize = () => {
    applyPositionStyles();
  };
  
  // Add debounce handling to avoid frequent triggers
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 100);
  });
}

function addStyleSheet() {
  const styleId = 'pify-main-styles';
  // Check if styles already exist to avoid duplicates
  if (document.getElementById(styleId)) {
    return;
  }
  
  const styleSheet = document.createElement('style');
  styleSheet.id = styleId;
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';

  let styles = ``;
  
  // Add custom CSS first to ensure it has lower priority
  if (window.settings && window.settings?.customCSS) {
    styles += window.settings?.customCSS + '\n';
  }
  
  styles += `
      /* ==========================================================================
         Base Styles - Desktop First
         ========================================================================== */
      
      .pify_inline_buttons_container {
        display: block;
        width: 100%;
        margin: 10px 0;
      }

      /* Floating button base styles */
      .pify_floating_button {
        height:auto;
        min-width:30px;
        position: fixed;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 8px 12px;
        border-radius: var(--button-border-radius, 8px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        background: var(--button-bg-color, white);
        color: var(--button-text-color, #333);
        border: var(--button-border-width, 1px) solid var(--button-border-color, transparent);
        cursor: pointer;
        transition: all 0.3s ease;
        white-space: nowrap;
        font-size: var(--button-font-size, 14px);
        line-height: initial;
      }

      /* Focus visible indicator for floating button */
      .pify_floating_button:focus-visible {
        outline: 2px solid var(--button-text-color, #2d72d2);
        outline-offset: 2px;
        box-shadow: 0 0 0 3px rgba(45, 114, 210, 0.25);
      }

      .pify_floating_button:hover {
        background-color: var(--button-bg-color, transparent);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        transform: translateY(-1px);
      }

      .pify_button_icon {
        width: calc(var(--button-font-size, 16px) * 2);
        height: calc(var(--button-font-size, 16px) * 2);
        max-width: 25px;
        max-height: 25px;
      }

      .pify_button_icon_font {
        font-size: calc(var(--pify-icon-font-size, 16px) * 1.2);
      }

      .pify_button_text {
        margin: 0;
        font-size: inherit;
        color: inherit;
        text-decoration: var(--button-text-decoration, none);
      }
      .pify_floating_button .pify_button_icon{
         transform: rotate(-90deg);
      }
      /* Only floating buttons have vertical text */
      .pify_floating_button .pify_button_text {
        writing-mode: vertical-lr;
        transform: rotate(180deg);
      }
      .pify_floating_button .pify_button_text.pify_cjk {
        writing-mode: vertical-lr;
        text-orientation: sideways;
        -webkit-text-orientation: sideways;
        transform: rotate(180deg);
      }
      .pify_position_top_left .pify_button_text.pify_cjk, .pify_position_middle_left .pify_button_text.pify_cjk, .pify_position_bottom_left .pify_button_text.pify_cjk{
        transform: rotate(360deg);
      }
      .pify_floating_button .pify_button_icon_font{
        transform: rotate(-90deg);
      }

      /* ==========================================================================
         Floating Button Position Styles
         ========================================================================== */

      /* Desktop position styles */
      .pify_floating_button.pify_desktop.pify_position_top_right {
        top: 220px;
        right: 0px;
        border-radius:  var(--button-border-radius, 15px)  0 0 var(--button-border-radius, 15px);
      }

      .pify_floating_button.pify_desktop.pify_position_middle_right {
        top: 50%;
        right: 0px;
        transform: translateY(-50%);
        border-radius: var(--button-border-radius, 15px)  0 0 var(--button-border-radius, 15px) ;
      }

      .pify_floating_button.pify_desktop.pify_position_bottom_right {
        bottom: 120px;
        right: 0px;   
        border-radius:  var(--button-border-radius, 15px)  0 0 var(--button-border-radius, 15px);
      }

      .pify_floating_button.pify_desktop.pify_position_top_left {
        top: 220px;
        left: 1px;
        border-radius: 0  var(--button-border-radius, 15px) var(--button-border-radius, 15px)  0;
      }

      .pify_floating_button.pify_desktop.pify_position_middle_left {
        top: 50%;
        left: 1px;
        transform: translateY(-50%);
        border-radius:0 var(--button-border-radius, 15px) var(--button-border-radius, 15px) 0 ;
      }

      .pify_floating_button.pify_desktop.pify_position_bottom_left {
        bottom: 120px;
        left: 1px;
        border-radius: 0 var(--button-border-radius, 15px) var(--button-border-radius, 15px) 0 ;
      }

      /* Mobile position styles */
      .pify_floating_button.pify_mobile.pify_position_top_right {
        top: 160px;
        right: 0px;
        border-radius: var(--button-border-radius, 15px) 0 0 var(--button-border-radius, 15px) ;
      }

      .pify_floating_button.pify_mobile.pify_position_top_left {
        top: 160px;
        left: 0px;
        border-radius: 0 var(--button-border-radius, 8px) var(--button-border-radius, 8px) 0 ;
      }

      .pify_floating_button.pify_mobile.pify_position_bottom_right {
        bottom: 100px;
        right: 0px;
        border-radius:var(--button-border-radius, 8px)  0 0 var(--button-border-radius, 8px)  ;
      }

      .pify_floating_button.pify_mobile.pify_position_bottom_left {
        bottom: 100px;
        left: 0px;
        border-radius: 0 var(--button-border-radius, 8px) var(--button-border-radius, 8px) 0 ;
      }



      /* ==========================================================================
         Layout and Container Styles
         ========================================================================== */

      .pify_module_container {
        margin-bottom: 10px;
      }

      .pify_table_container {
        margin-bottom: 10px;
      }

      .pify_unit_container {
        display: flex;
        gap: 15px;
        padding: 12px 0 12px 12px;
        text-align: left!important;
      }

      .pify_unit_label {
        display: flex;
        align-items: center;
        gap: 5px;
        cursor: pointer;
        color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || 'rgb(35,35,35)'};
      }
      .pify_unit_label:focus-visible {
        outline: 2px solid ${window.settings?.primaryInteractiveColor?.focusRing || 'rgba(0,0,0,0.6)'};
        outline-offset: 2px;
        border-radius: 4px;
      }

      .tableModule {
        width: 100%;
        position: relative;
        overflow-y: auto;
        scrollbar-width: thin;
      }

      /* ==========================================================================
         Button Styles
         ========================================================================== */

      /* Inline button styles */
      .pify_inline_button {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        line-height: 0px;
        height:auto;
        gap: 7px;
        width: fit-content;
        background-color: var(--button-bg-color, transparent) !important;
        color: var(--button-text-color, #000000) !important;
        border: var(--button-border-width, 1px) solid var(--button-border-color, transparent);
        border-radius: var(--button-border-radius, 6px);
        font-size: var(--button-font-size, 16px);
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        text-decoration: none;
        box-sizing: border-box;
        margin: 8px 0 8px 0;
        text-align: center;
        padding: var(--button-padding, 0 0);
        float:none;
        font-family: inherit;
      }

      .pify_inline_button:hover {
        background-color: var(--button-bg-color, transparent);
        opacity: 0.9;
        transform: translateY(-1px);
      }
      .pify_inline_button:before {
          background-color: transparent;
          border:none;
      }

      .pify_inline_button .pify_button_icon {
        width: calc(var(--button-font-size, 16px) * 2);
        height: calc(var(--button-font-size, 16px) * 2);
        object-fit: contain;
        flex-shrink: 0;
      }

      .pify_inline_button .pify_button_text {
        font-size: inherit;
        color: inherit;
        font-weight: inherit;
        line-height: 1;
        text-decoration: var(--button-text-decoration, none);
        white-space: nowrap;
      }

      /* ==========================================================================
         Table Styles
         ========================================================================== */

      .pify_size_table {
        width: 100%;
        border-collapse: collapse;
      }

      .pify_size_table tbody tr:nth-child(even) {
        background-color: #fafafa;
      }

      .pify_table_header {
        border: 1px solid #e1e3e5!important;
        background-color: #f6f6f7!important;
        font-weight: 600!important;
        text-align: center!important;
        min-width: 60px!important;
        height: 36px!important;
        vertical-align: middle;
      }

      .pify_table_cell {
        border: 1px solid #e1e3e5!important;
        text-align: center!important;
        min-width: 60px!important;
        height: 36px!important;
        line-height: 36px!important;
      }
      
      .pify_table_cell_hover {
       background-color: ${window.settings?.primaryInteractiveColor?.backgroundColor || '#000'}!important;
       color: #fff!important;
      }

      .pify_table_header,
      .pify_table_cell {
        transition: background-color 0.2s, color 0.2s;
      }

      /* ==========================================================================
         Content Container Styles
         ========================================================================== */

      .pify_text_container {
        padding: 10px;
        overflow-wrap: break-word;
      }

      .pify_text_container h1 {
          font-size: 32px;
          font-weight: bold;
          margin: 10px 0;
          color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#000'};
      }

      .pify_text_container h2 {
          font-size: 28px;
          font-weight: bold;
          margin: 10px 0;
          color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#000'};
      }

      .pify_text_container h3 {
          font-size: 24px;
          font-weight: bold;
          margin: 10px 0;
          color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#000'};
      }

      .pify_text_container h4 {
          font-size: 20px;
          font-weight: bold;
          margin: 10px 0;
          color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#000'};
      }

      .pify_text_container h5 {
          font-size: 18px;
          font-weight: bold;
          margin: 10px 0;
          color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#000'};
      }

      .pify_text_container h6 {
          font-size: 16px;
          font-weight: bold;
          margin: 10px 0;
          color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#000'};
      }

      .pify_text_container ul,
      .pify_text_container ol {
          padding-left: 2em;
          margin: 0.5em 0;
      }

      .pify_text_container ul {
          list-style: disc;
      }

      .pify_text_container ol {
          list-style: decimal;
      }

      .pify_text_container p {
          font-size: 16px;
          margin:10px 0 0 0;
          color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#000'};
      }
      .pify_text_container p:empty {
          margin:20px 0 0 0;
          display: block;
      }

      .pify_text_container em {
          font-style: italic;
      }

      .pify_text_container strong {
          font-weight: bold;
      }

      .pify_image_container {
        width: 100%;
        // height: 380px;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .pify_image_container img{
        width: auto;
        max-width: 100%;
        max-height: 100%;
        display: block;
        margin: 0px auto;
        // object-fit: contain;
      }

      

      .pify_image_container--min img{
        max-width: 100%;
      }

      .pify_image_container--medium img{
        max-width: 65%;
      }

      .pify_image_container--large img{
        max-width: 90%;
      }

      .pify_modal_overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding-top: 60px;
        z-index: 99999;
        touch-action: none;
        overscroll-behavior: contain;
      }

      .pify_modal_content {
        background: white;
        padding: 20px;
        border-radius: 12px;
        // max-width: 850px;
        width: 60%;
        min-width: 850px;
        // max-width: 70%;
        max-height: calc(90vh - 60px);
        max-height: calc(90dvh - 60px);
        display: flex;
        flex-direction: column;
        position: relative;
        color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#121212BF'};
        font-size: 16px!important;
      }

      .pify_modal_content .pify_size_chart_content{
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: #e3e1e1 transparent;
        max-height: calc(90vh - 120px);
        max-height: calc(90dvh - 120px);
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
      }
      .pify_close_button {
        position: absolute;
        right: 10px;
        top: 10px;
        border: none;
        background: none;
        font-size: 18px;
        cursor: pointer;
        text-align: right;
        color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#000'};
        --button-border-color: none;
      }

      .pify_tabs_container {
        display: flex;
        border-bottom: 2px solid #e1e3e5;
        // margin-top: 10px;
      }

      .pify_tab {
        padding: 4px 8px;
        cursor: pointer;
        font-weight: 600;
        font-size: 14px;
      }

      .pify_tab_active {
        border-bottom: 2px solid ${window.settings?.primaryInteractiveColor?.backgroundColor || '#000'};
         color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#000'};
      }

      .pify_size_chart_button {
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: baseline;
        gap: 8px;
        display:flex;
        justify-content: flex-start;
      }



      .pify_unit_label input[type="radio"] {
        accent-color: ${window.settings?.primaryInteractiveColor?.backgroundColor || '#000'};
        appearance: radio !important;
        min-height: 0!important;
        width: 16px!important;
        height: 16px!important;
        box-shadow: none!important;
        outline: none!important;
        position: relative;
        margin: 0;
      }
      
      .pify_table_header,
      .pify_table_cell {
        transition: background-color 0.2s, color 0.2s;
      }

      .pify_size_tooltip {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 10px;
        background-color: ${window.settings?.primaryInteractiveColor?.backgroundColor || 'rgba(0, 0, 0, 0.8)'};
        color: white;
        padding: 12px;
        border-radius: 4px;
        font-size: 14px;
        z-index: 1000;
        min-width: 160px;
        pointer-events: none; /* Disable mouse events, allow click-through */
        opacity: 0 !important;
        transition: all 0.2s ease-in-out;
        white-space: normal;
        display: block !important;
        visibility: visible !important;
      }
      .pify_size_tooltip td, .pify_size_tooltip th{
        background-color: ${window.settings?.primaryInteractiveColor?.backgroundColor || 'rgba(0, 0, 0, 0.8)'} !important;
      }

      .pify_size_tooltip::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid ${window.settings?.primaryInteractiveColor?.backgroundColor || 'rgba(0, 0, 0, 0.8)'};
      }

      label:hover .pify_size_tooltip,
      .bee-swatch__item:hover .pify_size_tooltip,
      .bee-swatch__item .pify_size_tooltip:hover {
        opacity: 1 !important;
      }

      .pify_tooltip_title {
        font-weight: bold;
        margin-bottom: 8px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
        padding-bottom: 4px;
        text-align: center;
      }

      .pify_tooltip_row {
        margin: 4px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        text-align: center;
      }

      .size-details-content {
        max-height: 300px;
        overflow-x: auto;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: #e0e0e0 transparent;
      }

      .size-details-content::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      .size-details-content::-webkit-scrollbar-track {
        background: transparent
        border-radius: 3px;
      }

      .size-details-content::-webkit-scrollbar-thumb {
        background: #e5e5e5;
        border-radius: 3px;
      }

      .size-details-content::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
      }

      .size-details-content::-webkit-scrollbar-button {
        display: none;
        width: 0;
        height: 0;
      }

      .size-details-content::-webkit-scrollbar-button:start:decrement,
      .size-details-content::-webkit-scrollbar-button:end:increment {
        display: none;
        width: 0;
        height: 0;
      }

      .size-details-content::-webkit-scrollbar-corner {
        background: transparent;
      }

      .size-details-table {
        width: 100%;
        border-collapse: collapse;
      }

      .size-details-table th,
      .size-details-table td {
        text-align: center;
        min-width: 68px;
        font-size: 14px;
        white-space: normal;
        padding: 6px 12px;
        color: #121212BF;
      }

      .size-details-table th {
        font-weight: 600;
        color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#333'};
      }

      .size-details-table td {
        color: #666;
      }

      .size-details-table tr.selected-size-row {
        background-color: #f6f6f7;
      }

      .size-details-table tr.selected-size-row td {
        color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#333'};
        font-weight: 500;
      }

      .size-details-unit-container {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .size-details-unit-label {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 12px;
        background: #fff;
        border: 1px solid ${window.settings?.primaryInteractiveColor?.backgroundColor || '#333'};
        min-width: 40px;
        color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#121212BF'};
      }

      .size-details-unit-label:first-child {
        border-right: none;
      }

      .size-details-unit-label[aria-checked="true"] span {
        color: #fff;
      }

      .size-details-unit-label[aria-checked="true"] {
        background: ${window.settings?.primaryInteractiveColor?.backgroundColor || '#333'} !important;
      }
      /* Size chart title styles */
      .size_chart_title {
        display: flex !important;
        justify-content: space-between;
        align-items: center;
        width:100% !important;
      }

      /* ==========================================================================
         Mobile Responsive Styles
         ========================================================================== */

      /* Floating button mobile styles */
      @media (max-width: 768px) {
        .pify_floating_button {
          min-width:50px;
          gap: 4px;
          padding: 6px 10px;
          font-size: var(--button-font-size-mobile, 12px);
          border-radius: var(--button-border-radius-mobile, 6px);
        }

        .pify_button_icon {
          width: calc(var(--button-font-size-mobile, 12px) * 1.8);
          height: calc(var(--button-font-size-mobile, 12px) * 1.8);
        }
      }

      @media (max-width: 375px) {
        .pify_floating_button {
          min-width:50px;
          gap: 3px;
          padding: 5px 8px;
          font-size: var(--button-font-size-mobile, 11px);
          border-radius: var(--button-border-radius-mobile, 5px);
        }

        .pify_button_icon {
          width: calc(var(--button-font-size-mobile, 11px) * 1.6);
          height: calc(var(--button-font-size-mobile, 11px) * 1.6);
        }
        .pify_modal_content .pify_size_chart_content{
         max-height: 400px;
        } 
      }

      /* Modal Responsive Styles */
      @media (max-width: 768px) {
        .pify_modal_content {
          max-height: 100vh;
          max-height: 100dvh;
          padding:5px 12px;
          width: 100%;
          overflow:hidden;
          min-width: 0;
          margin: 5px;
        }
        
        .pify_modal_content .pify_size_chart_content {
          overflow-y: auto;
          scrollbar-width: thin;
          max-height: calc(100vh - 180px);
          max-height: calc(100dvh - 180px);
          scrollbar-color: #c1c1c1 transparent;
          -webkit-overflow-scrolling: touch;
          overscroll-behavior: contain;
          padding: 0 5px;
        }
        .pify_image_container--min img{
          max-width: 100%;
        }

        .pify_image_container--medium img{
          max-width: 100%;
        }

        .pify_image_container--large img{
          max-width: 90%;
        }
      }
      }
    `;

  // Theme-specific styles
  const themeStyles = {
    'pinnacle': `
        .product-form__input--block {
          overflow: visible !important;
        }

        .product-form__input--block label {
          overflow: visible !important;
        }
      `,
    'shine': `
        .product-option .js-variant-option-label {
          overflow: visible !important;
        }
      `,
    'nimbus': `
        .swatch-block {
          position: relative !important;
        }
        .swatch-block:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
        .variant-picker .swatch-block {
          overflow: visible !important;
        }
        .variant-picker .swatch-block label {
          position: relative !important;
          z-index: 1 !important;
        }
       @media (max-width: 768px) {
        .size-details-unit-label {
          font-size: 10px;
          min-width: 30px;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
          font-size: 12px;
          min-width: 42px;
        }
        
        /* Mobile floating button style optimization */
        .pify_floating_button.pify_mobile {
          padding: 6px 10px;
          border-radius: 6px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
          font-size: 14px;
          gap: 4px;
        }

        /* Mobile inline button style optimization */
        .pify_inline_button {
          font-size: 13px;
          gap: 6px;
          margin: 6px 0;
          width: 140px;
          justify-content: center;
        }


        .pify_size_chart_button {
          width: 140px;
        }

        .pify_inline_button .pify_button_icon {
          width: calc(13px * 1.2);
          height: calc(13px * 1.2);
        }
      `,
    'normcore': `
        .js-variant-option-label {
          overflow: visible !important;
        }
      `,
    'vision': `
        .product-form__input--block {
          overflow: visible !important;
        }

        .product-form__input--block label {
          overflow: visible !important;
        }
      `,
    'impulse': `
        .variant-input {
          overflow: visible !important;
        }

        .variant-input label{
          overflow: visible !important;
        }
      `,
    'motion': `
        .variant-input {
          overflow: visible !important;
        }

        .variant-input label{
          overflow: visible !important;
        }
      `,
    'luxe': `
        .radio-options-wrapper label{
          overflow: visible !important;
        }
      `,
    'roam': `
        .option-value:hover {
          overflow: visible;
        }
      `,
    'vantage': `
        .swatch-element label{
          overflow: visible !important;
        }
      `,
    'flawless': `
        .variant-pills-wrapper label{
          overflow: visible !important;
        }
      `,
    'kidu': `
        .product-card-variants .variant-row--pills {
          flex-wrap: wrap;
        }
      `,
    'creator': `
        .size-details-table th {
          color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#666'};
        }
      `,
    'icon': `
        .swatches__swatch--regular label{
          overflow: visible !important;
        }

        .pify_modal_content .pify_close_button {
          width: 30px;
        }

        .pify_tooltip_row {
          height: 22px;
        }
      `,
    'fashionopolism': `
        .swatches__swatch--regular label{
          overflow: visible !important;
        }
      `,
    'wonder': `
        .f-button__list__item label{
          overflow: visible !important;
        }
      `,
    'gem': `
        .variant-button-wrap label{
          overflow: visible !important;
        }
      `,
    'honey': `
        .single-option-selector__option-wrap label{
          overflow: visible !important;
        }
      `,
    'fetch': `
        .variant-button-wrap label{
          overflow: visible !important;
        }
      `,
    'expanse': `
        .variant-button-wrap label{
          overflow: visible !important;
        }
      `,
    'streamline': `
        .variant-input label{
          overflow: visible !important;
        }
      `,
    'drop': `
        .swatches__swatch--regular label{
          overflow: visible !important;
        }
      `,
    'bespoke': `
        .option-value-rounded label{
          overflow: visible !important;
          position: relative !important;
          z-index: 1 !important;
        }
      `,
    'testament': `
        .pify_modal_content .pify_close_button {
          width: 30px;
        }
      `,
    'noire': `
        .size-details-table {
          table-layout: auto;
        }
      `,
    'paris': `
        .product-swatch-item {
          position: relative !important;
          overflow: visible !important;
        }
        .product-swatch-item:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
      `,
    'frame': `
        .single-option-selector__option-wrap label {
          overflow: visible !important;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 6px;
        }
      `,
    'master': `
        .variant-item {
          position: relative !important;
        }
        .variant-item:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
      `,
    'shark': `
        .variant-item {
          position: relative !important;
        }
        .variant-item:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
      `,
    'fame': `
        .variant_option {
          position: relative !important;
        }
        .variant_option:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
      `,
    'yuva': `
        .variant_option {
          position: relative !important;
        }
        .variant_option:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
      `,
    'eclipse': `
      .variant-option--chips button.chip {
        overflow: visible !important;
      }
    `,
    'showcase': `
      .size-details-table th, .size-details-table td {
        padding: 6px 0;
      }
    `,
    'beyond': `
      .size-details-table th, .size-details-table td {
        padding: 6px 0;
        font-size: 12px;
        min-width: 54px;
      }
    `,
    'king': `
      .size-details-table th, .size-details-table td {
        padding: 6px 0;
        font-size: 12px;
        min-width: 66px;
      }
      .variant--item:hover .pify_size_tooltip {
        opacity: 1 !important;
        visibility: visible !important;
        display: block !important;
      }
    `,
    'xclusive': `
      #f8pr-ul-check-3{
        z-index: 49 !important;
      }
    `,
    'next': `
      #f8pr-ul-check-3{
        z-index: 99 !important;
      }
    `,
    'neat': `
        .size-details-table {
          table-layout: auto;
        }
    `,
    'urban': `
      @media (max-width: 768px) {
        .size-details-unit-label {
          font-size: 10px;
          min-width: 20px;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
          font-size: 12px;
          min-width: 42px;
        }
        .pify_table_header, .pify_table_cell {
          padding: 0 5px;
          white-space: nowrap;
        }
      }
    `,
    'etheryx': `
      .size-details-table th, .size-details-table td {
        padding: 6px 0;
        font-size: 12px;
        min-width: 42px;
      }
      .size-details-unit-label {
          min-width: 30px;
      }
    `,
    'borders': `
      @media (max-width: 768px) {
        .size-details-unit-label {
          font-size: 12px;
          min-width: 30px;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
          font-size: 12px;
          min-width: 42px;
        }
      }
    `,
    'boost': `
      @media (max-width: 768px) {
        .size-details-unit-label {
          font-size: 12px;
          min-width: 30px;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
          font-size: 12px;
          min-width: 42px;
        }
      }
    `,
    'providence': `
      .size-details-unit-label {
        padding-bottom: 0;
      }
    `,
    'strong': `
      .size-details-table {
          table-layout: auto;
      }
    `,
    'editions': `
      .pify_unit_container {
        display: flex;
        gap: 15px;
      }
    `,
    'retina': `
      .size-details-table th, .size-details-table td {
        min-width: 58px;
        font-size: 12px;
        padding: 6px 0;
      }
    `,
    'emporium': `
      .size-details-table th, .size-details-table td {
        min-width: 62px;
        font-size: 12px;
        padding: 6px 0;
      }
    `,
    'sunrise': `
      .size-details-table th, .size-details-table td {
        min-width: 58px;
        font-size: 12px;
        padding: 6px 0;
      }
    `,
    'avenue': `
      .swatch-element .swatch-label.label:hover + label .pify_size_tooltip,
      .swatch-element:hover .pify_size_tooltip {
         opacity: 1 !important;
         visibility: visible !important;
         display: block !important;
      }
      .swatch .swatch-element .label {
          overflow: visible !important;
          position: relative;
      }
      .size-details-table th, .size-details-table td {
        font-size: 13px;
        padding: 6px 0;
      }

    `,
    'grid': `
      .size-details-table th, .size-details-table td {
        padding: 6px 8px;
      }
      .pify_unit_label {
        margin: 0;
      }
      .pify_table_header, .pify_table_cell {
        padding: 0;
      }
      .pify_size_table {
        margin-top: 0;
      }
    `,
    'iris': `
      @media (max-width: 768px) {
        .size-details-unit-label {
          font-size: 10px;
          min-width: 26px;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
          font-size: 12px;
          min-width: 54px;
        }
      }
    `,
    'kingdom': `
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
        }
        .size-details-unit-container .size-details-unit-label[aria-checked="true"]{
          background: ${window.settings?.primaryInteractiveColor?.backgroundColor || '#333'} !important;
          color: #fff;
        }
    `,
    'zora': `
      .pify_unit_label[aria-checked="true"]{
          background: ${window.settings?.primaryInteractiveColor?.backgroundColor || '#333'} !important;
          color: #fff;
      }
    `,
    'modular': `
      .pify_size_tooltip {
          padding: 2px;
      }
    `,
    'masonry': `
        .size-details-table th, .size-details-table td {
          padding: 6px 4px;
        }
    `,
    'bazaar': `
      input[type=radio]:checked~.radio-label {
        pointer-events: auto !important;
      }
    `,
    'responsive': `
      .pify_modal_content .pify_close_button {
          width: 30px;
          padding: 0;
      }
      .pify_modal_content .pify_close_button:hover {
          background-color: transparent;
      }
    `,
    'highlight': `
      .pify_inline_buttons_container {
        margin-left: 10px;
      }
    `,
    'whisk': `
      .size-details-table {
        table-layout: auto;
      }
      .size-details-table th {
        white-space: nowrap;
      }
    `,
    'mojave': `
      .pify_inline_buttons_container {
        grid-column: 1 / -1;
      }
    `,
    'wpbingo': `
        .single-option-selector label{
          overflow: visible !important;
        }
    `,
    'electro theme': `
        .input-group {
          overflow: visible !important;
        }
    `,
    'lusion': `
      .pify_size_tooltip {
          padding: 2px;
      }
    `,
    'goodwin': `
      .size-list {
          overflow: visible !important;
      }
    `,
    'vegist': `
      .size-details-table th, .size-details-table td {
          padding: 6px 4px;
          font-size: 12px;
          min-width: 45px;
          white-space: nowrap;
      }
    `,
    'horizon': `
      .variant-option__button-label {
        overflow: visible !important;
      }
    `,
    'optimal': `
      .swatch-element label.size {
        overflow: visible !important;
      }
    `
  };

  // Add theme-specific styles
  if (themeName && themeStyles[themeName]) {
    styles += themeStyles[themeName];
  }
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}

// Initialize stylesheet function on load
// A flag to ensure the initialization logic runs only once.
let isSizeChartInitialized = false;

/**
 * Check if the app install time is before 2025-10-30
 * @param {string} appInstallTime - The app install time string
 * @returns {boolean} - True if should skip insertSizeChartButtonNearVariant logic
 */
function checkAppInstallTime(appInstallTime) {
  try {
    if (!appInstallTime) {
      // Log removed
      return true; // Default to skip if no install time provided
    }
    
    const installDate = new Date(appInstallTime);
    const cutoffDate = new Date('2025-10-30T00:00:00.000Z');
    
    const shouldSkip = installDate < cutoffDate;
    
    return shouldSkip;
  } catch (error) {
    console.error('Error parsing app install time:', error);
    return true; // Default to skip on error
  }
}

function observeDomChanges() {
  // If no size chart data, no need to observe
  if (!window.sizeChartData || !Array.isArray(window.sizeChartData) || window.sizeChartData.length === 0) {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    
    // Check if we have any relevant mutations
    for (let i = 0; i < mutations.length; i++) {
      const mutation = mutations[i];
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (let j = 0; j < mutation.addedNodes.length; j++) {
          const node = mutation.addedNodes[j];
          if (node.nodeType === 1) { // Element node
             // 1. Check if the added node itself is the wrapper
             if (node.classList.contains('pify_size_chart_wrapper')) {
               shouldUpdate = true;
               break;
             }
             // 2. Check if the added node contains the wrapper (using getElementsByClassName for better performance)
             if (node.getElementsByClassName('pify_size_chart_wrapper').length > 0) {
               shouldUpdate = true;
               break;
             }
          }
        }
      }
      if (shouldUpdate) break;
    }
    
    if (shouldUpdate) {
      clearTimeout(window.pifyResizeTimeout);
      window.pifyResizeTimeout = setTimeout(() => {
        // If it is a pure floating button, do not add inline button
        const buttonType = window.settings?.buttonType || 'inline';
        if (buttonType === 'floating') {
          return;
        }
        addCustomButtons();
      }, 200);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

/**
 * Initializes the size chart functionality and styles.
 * This function is idempotent and can be safely called multiple times.
 */
 function safeInitialize() {
  if (isSizeChartInitialized) {
    return;
  }
  isSizeChartInitialized = true;
  
  addFitSelectorStyles();
  fetchSizeChartData()
    .then( (result) => {
      try {
        window.sizeChartData = result.data;
        window.settings = result.settings;
        
        // Start observing DOM changes only after data is loaded and confirmed
        observeDomChanges();

        // Check app install time to determine if insertSizeChartButtonNearVariant should be skipped
        // const shouldSkipVariantButton = checkAppInstallTime(result.appInstallTime);
        // const existingWrapper = document.querySelector('.pify_size_chart_wrapper');
        // const userSelector = window.settings?.inlineButton?.cssSelector;
        
        // Decide which button to create based on button type
        const buttonType = window.settings?.buttonType || 'inline';
        // If it's a pure floating button, only create floating button
        if (buttonType === 'floating') {
          applyFloatingToContainer();
        }
        // If it's both type, create floating button first, then inline button
        else if (buttonType === 'both') {
          applyFloatingToContainer();
          addCustomButtons();
        }
        // Default case (inline) only create inline button
        else {
          addCustomButtons();
        }
        addStyleSheet();
        addSizeSelectorTooltip();
        createSizeChartInlineBlock();

      } catch (error) {
        console.error('Error processing size chart data:', error);
      }
    })
    .catch(error => {
      console.error('Failed to fetch size chart data:', error);
    });
}
// Run the initialization logic once the DOM is ready.
// This handles cases where the script is loaded at different times.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', safeInitialize);
} else {
  safeInitialize();
}

function updateTableHighlight(table) {
  const hoveredRow = parseInt(table.dataset.hoveredRow);
  const hoveredCol = parseInt(table.dataset.hoveredCol);
  // Get cell hover background color setting
  // const hoverBackgroundColor = window.settings?.primaryInteractiveColor?.backgroundColor || window.settings?.appearance?.hoverBackgroundColor || 'rgb(51, 51, 51)';
  // // Set CSS variable for hover background color
  // document.documentElement.style.setProperty('--pify-hover-bg-color', hoverBackgroundColor);
  
  // Remove hover class from all cells
  table.querySelectorAll('.pify_table_cell_hover').forEach(cell => {
    cell.classList.remove('pify_table_cell_hover');
  });

  if (hoveredRow >= 0 && hoveredCol >= 0) {
    const hoveredCell = table.querySelector(`td[data-row-index= "${hoveredRow}"][data-col-index= "${hoveredCol}"]`);
    if (hoveredCell) {
      hoveredCell.classList.add('pify_table_cell_hover');
    }

    // Skip adding hover class for cells in thead
    const headerCell = table.querySelector(`th[data-col-index="${hoveredCol}"]`);
    if (headerCell) {
      headerCell.classList.add('pify_table_cell_hover');
    }

    const rowHeader = table.querySelector(`td[data-row-index= "${hoveredRow}"][data-col-index="0"]`);
    if (rowHeader) {
      rowHeader.classList.add('pify_table_cell_hover');
    }
  }
}

function hasAddToCartText(element) {
  const textContent = (element.textContent || '').toLowerCase();
  const value = (element.value || '').toLowerCase();

  // Use regex to match
  const cartTextRegex = /(add\s+to\s+(cart|bag|basket)|purchase|buy\s+now|pre-?order)/i;
  if (cartTextRegex.test(textContent) || cartTextRegex.test(value)) {
    return true;
  }

  // Check data attributes
  const dataAttributes = [
    'data-add-to-cart-text',
    'data-button-text',
    'data-atc-text',
    'data-product-button',
    'data-text-add-to-cart',
    'data-add_to_cart'
  ];

  return dataAttributes.some(attr => {
    const attrValue = element.getAttribute(attr);
    return attrValue && cartTextRegex.test(attrValue);
  });
}

function isInAddToCartForm(element) {
  const form = element.closest('form');
  if (!form) return false;

  const formAction = form.getAttribute('action') || '';
  return formAction.includes('/cart/add') ||
    form.querySelector('[name="add"]') !== null ||
    form.id.toLowerCase().includes('add-to-cart') ||
    form.className.toLowerCase().includes('add-to-cart');
}

// Add size selector tooltip functionality
function addSizeSelectorTooltip() {
  const isProductPage = window.location.pathname.startsWith('/products/') ||
    window.location.pathname.includes('/products/');
  // Check if current page is product page
  if (!isProductPage) return;

  if (!window.sizeChartData || !Array.isArray(window.sizeChartData)) {
    // No sizeChartData available
    return;
  }

  // Check if any size chart should be displayed based on targeting configuration
  const hasDisplayableSizeChart = window.sizeChartData.some(sizeChart => shouldDisplaySizeChart(sizeChart));
  // Check if has displayable size chart
  if (!hasDisplayableSizeChart) {
    return;
  }

  // Check showTooltip and showSizeDetails settings
  const showTooltip = window.settings?.primaryInteractiveColor?.showTooltip !== false;
  const showSizeDetails = window.settings?.primaryInteractiveColor?.showSizeDetails !== false;

  
  // If both tooltip and size details are disabled, skip the entire function
  if (!showTooltip && !showSizeDetails) {
    return;
  }
  // Get current theme name
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase();
  // Get theme name

  // Themes that should skip tooltip functionality
  const skipTooltipThemes = [
    'infinity',
    'refine',
    'debut',
    'startup',
    'next',
    'xclusive',
    'xtra',
    'forge',
    'electro',
    'amber',
    'erickson',
    'retina',
    'emporium',
    'parallax',
    'responsive',
    'nostalgia',
    'lumin',
    'woodstock',
    'highlight',
    'marble',
    'etheryx',
    'aisle',
    'futurer',
    'redefine',
    'madrid',
    'space',
    'paper',
    'warehouse',
    'zest',
    'showtime',
    'eclipse',
    'vincent',
    'aurora',
    'pursuit',
    'ascension',
    'pinnacle',
    'borders',
    'vision',
    'bullet',
    'creative',
    'venue',
    'blockshop',
    'canopy',
    'sahara',
    'keystone',
    'satoshi',
    'local',
    'showcase'
  ];

  // Skip functionality for specified themes
  if (skipTooltipThemes.includes(themeName)) {
    exceptionCollector.collect(
      'Not compatible with the theme',
      `Tooltip functionality skipped for theme: ${themeName} (intentionally disabled for compatibility)`
    );
    return;
  }

  // Get current theme selectors
  const themeSelectors = getCurrentThemeSelectors();
  // Get theme selectors

  // Get custom size selector patterns from settings (priority)
  const customSizeSelectorCss = window.settings.inlineButton?.sizeSelector;
  // Get custom size selector CSS
  let sizeSelectorPatterns = [];

  // 1. Try custom selectors first
  if (customSizeSelectorCss && customSizeSelectorCss.trim()) {
    // Split by comma and clean up
    sizeSelectorPatterns = customSizeSelectorCss.split(',').map(s => s.trim()).filter(s => s.length > 0);
    // Using custom sizeSelectorPatterns
  } else {
    // No custom size selector patterns found
  }

  // 2. If no custom selectors or no elements found, use theme selectors
  let potentialSelectors = [];

  if (sizeSelectorPatterns.length > 0) {
    // Searching with custom patterns
    for (const pattern of sizeSelectorPatterns) {
      try {
        const elements = document.querySelectorAll(pattern);
        // Pattern search result
        if (elements.length > 0) {
          potentialSelectors = potentialSelectors.concat(Array.from(elements));
        }
      } catch (error) {
        // Error with pattern search
      }
    }
  }

  // 3. If custom selectors didn't find anything, fallback to theme selectors
  if (potentialSelectors.length === 0) {
    // Fallback to theme selectors
    sizeSelectorPatterns = themeSelectors.sizeSelectorPatterns;
    // Theme sizeSelectorPatterns
    for (const pattern of sizeSelectorPatterns) {
      const elements = document.querySelectorAll(pattern);
      // Theme pattern search result
      if (elements.length > 0) {
        potentialSelectors = potentialSelectors.concat(Array.from(elements));
      }
    }
  }

  // Remove duplicates: if the same element is matched by multiple patterns
  potentialSelectors = [...new Set(potentialSelectors)];
  // Special handling for XO theme dropdown structure
  const xoSelectors = document.querySelectorAll('xo-popover[xo-name*="filter-select-custom-Size"], .xo-field-select-custom__popover');
  if (xoSelectors.length > 0) {
    potentialSelectors = potentialSelectors.concat(Array.from(xoSelectors));
  }

  // Special handling for Globo App structure
  const globoSelectors = document.querySelectorAll('.globo-swatch-list .swatch--gl, .globo-swatch-product-detail .swatch--gl');
  if (globoSelectors.length > 0) {
    potentialSelectors = potentialSelectors.concat(Array.from(globoSelectors));
  }

  // Potential selectors found
  
  if (potentialSelectors.length === 0) {
    // Collect compatibility anomaly information - No size selectors were found
    exceptionCollector.collect(
      'sizechart_tooltip_selectors',
      'Failed to find size selector elements for tooltip functionality'
    );
    return;
  }

  // 2. Filter out real size selectors

  const sizeSelectors = potentialSelectors.filter(selector => {
    if (themeName === 'wokiee') {
      if (selector.classList.contains('tt-wrapper')) {
        const titleElement = selector.querySelector('.tt-title-options');
        if (titleElement) {
          const titleText = titleElement.textContent.trim().toLowerCase();
          if (matchesSizeKeyword(titleText)) {
            return true;
          }
        }
        const sizeLinks = selector.querySelectorAll('li a[data-value]');
        if (sizeLinks.length > 0) {
          const sizeValues = Array.from(sizeLinks).map(link => link.getAttribute('data-value'));
          const sizePatterns = [
            /^(XXS|XS|S|M|L|XL|XXL|XXXL)$/i,
            /^(2XS|3XS|2XL|3XL|4XL|5XL)$/i,
            /^\d+$/,
            /^\d+[A-Z]?$/i,
            /^\d+\.\d+$/,
            /^\d+\/\d+$/,
            /^(ONE SIZE|ONESIZE|OS|FREE SIZE|FREESIZE)$/i
          ];

          let sizeCount = 0;
          sizeValues.forEach(value => {
            if (sizePatterns.some(pattern => pattern.test(value))) {
              sizeCount++;
            }
          });

          if (sizeCount / sizeValues.length >= 0.5) {
            return true;
          }
        }
      }
    }

    if (themeName === 'kalles' || themeName === 'unsen') {
      if (selector.querySelector('.t4s-swatch__item')) {
        return true;
      }
    }

    // Special handling for Unero theme
    if (themeName === 'unero') {
      if (selector.classList.contains('tawcvs-swatches') ||
        selector.querySelector('span.swatch[data-value]')) {
        return true;
      }
    }

    if (themeName === 'takeout') {
      if (selector.classList.contains('product-form__input--dropdown') ||
        selector.querySelector('.select__select') ||
        selector.closest('.product-form__input--dropdown') ||
        selector.tagName !== 'FIELDSET') {
        return false;
      }
    }

    if (themeName === 'carbon') {
      if (selector.classList.contains('product-form__input--dropdown') ||
        selector.querySelector('.select__select') ||
        selector.closest('.product-form__input--dropdown') ||
        !selector.classList.contains('product-form__input-wrapper')) {
        return false;
      }
    }

    // Check if element is visible
    const style = window.getComputedStyle(selector);

    // Improved visibility detection - relaxed conditions, consider custom dropdown structures
    // Even if the element itself appears "hidden", if it is a select element or contains a select element, we consider it visible
    const isSpecialDropdown = selector.tagName === 'SELECT' ||
      selector.querySelector('select') !== null;

    const isVisible = (style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      selector.offsetWidth > 0 &&
      selector.offsetHeight > 0) || isSpecialDropdown;

    if (!isVisible) {
      return false;
    }

    // Exclude quantity selectors
    if (selector.closest('.product-form__quantity')) {
      return false;
    }

    // Check if it's a size selector
    const legend = selector.querySelector('legend');
    const label = selector.querySelector('.form__label, .variant-swatches-text, .option-name, .variant-title, .radio__legend__label, .variant__label, .option-label');
    const radioInput = selector.querySelector('input[type="radio"][name="Size"], input[type="radio"][name*="Size"], input[type="radio"][name*="product-size"], input[type="radio"][name="size"], input[type="radio"][name*="size-option"], input[type="radio"][name*="サイズ"]');
    const optionName = selector.querySelector('.option-name, .variant-title, .variant__label');
    const optionValue = selector.querySelector('.option-value, .variant-value');

    // Check if it's a color selector
    const isColorSelector =
      (optionName && optionName.textContent.toLowerCase().includes('color')) ||
      (optionValue && optionValue.textContent.toLowerCase().includes('color')) ||
      (label && label.textContent.toLowerCase().includes('color')) ||
      (legend && legend.textContent.toLowerCase().includes('color')) ||
      selector.classList.contains('color-swatch') ||
      selector.classList.contains('color-option') ||
      selector.classList.contains('color-selector') ||
      selector.getAttribute('data-option-name')?.toLowerCase().includes('color') ||
      selector.getAttribute('data-option')?.toLowerCase().includes('color');

    if (isColorSelector) {
      return false;
    }

    const isSelectWithSizeName = selector.tagName === 'SELECT' &&
      (matchesSizeKeyword(selector.name || '') ||
        (selector.id || '').toLowerCase().includes('option') ||
        (selector.id || '').toLowerCase().includes('single-option-form'));

    let customSelectSelector = 'select[name*="Size"], select[name*="size"], select[name*="サイズ"], select[id*="option"], select[id*="single-option-form"]';
    if (window.pifySizeLabel && Array.isArray(window.pifySizeLabel)) {
       window.pifySizeLabel.forEach(label => {
         if (label && typeof label === 'string') {
             const safeLabel = label.replace(/"/g, '\\"');
             customSelectSelector += `, select[name*="${safeLabel}"]`;
         }
       });
    }
    const hasSelectWithSizeName = selector.querySelector(customSelectSelector) !== null;

    // Check if it's a size selector
    const isSizeSelector =
      isSelectWithSizeName ||
      hasSelectWithSizeName ||
      (legend && matchesSizeKeyword(legend.textContent.trim())) ||
      (label && matchesSizeKeyword(label.textContent.trim())) ||
      matchesSizeKeyword(selector.id) ||
      (selector.getAttribute('data-option-id') && matchesSizeKeyword(selector.getAttribute('data-option-id'))) ||
      selector.classList.contains('variant-dropdown') ||
      selector.classList.contains('variant-selector-card') ||
      selector.classList.contains('select-size') ||
      selector.classList.contains('swatch-element') ||
      selector.classList.contains('option-selector__btns') ||
      selector.classList.contains('size__option') ||
      selector.classList.contains('block-swatch') ||
      selector.classList.contains('product-options__default') ||
      selector.classList.contains('options-selection__option-value') ||
      selector.classList.contains('BlockSwatchWrapper') ||
      selector.getAttribute('data_options') === 'Size' ||
      selector.querySelector('.quantity_box.quantity_num.option-swatch[data-option-name="SIZE"]') !== null ||
      radioInput !== null ||
      (selector.querySelector('.field-wrap-inner') && selector.querySelector('input[type="radio"][name="Size"]')) ||
      (selector.classList.contains('radio__container') && selector.querySelector('input[type="radio"][data-option="Size"]')) ||
      selector.classList.contains('radios--container') ||
      (selector.classList.contains('variant--item') && selector.querySelector('.variant-item-name')) ||
      (selector.classList.contains('variant-item')) ||
      (selector.classList.contains('inline-field-wrapper') && matchesSizeKeyword(selector.querySelector('.input-field-title')?.textContent)) ||
      selector.classList.contains('variant_option') ||
      selector.classList.contains('variant-picker__option-values') ||
      selector.classList.contains('swatches-list-item') ||
      (selector.classList.contains('variantPickerButtonsWrap') && selector.querySelectorAll('.optionBtns').length > 0) ||
      (selector.classList.contains('options-frame') && selector.querySelectorAll('a.swatch.not-color').length > 0) ||
      (selector.classList.contains('product__color-chips') && selector.querySelectorAll('.product__chip').length > 0) ||
      (selector.classList.contains('product-form__chip-wrapper') && selector.querySelectorAll('.product-form__chip').length > 0) ||
      selector.classList.contains('option-group__chips-container') ||
      selector.classList.contains('product-variant-picker__pill-list') ||
      (selector.classList.contains('check') && !selector.closest('.mega-menu-content')) ||
      selector.classList.contains('input-select__select') ||
      (selector.getAttribute('data-property') === 'size' && selector.querySelectorAll('[data-value]').length > 0) ||
      (selector.classList.contains('product-options__section') && selector.querySelectorAll('[data-value]').length > 0) ||
      selector.classList.contains('swt-type-button') ||
      selector.classList.contains('variants__options') ||
      selector.classList.contains('swatch-group_inner') ||
      selector.classList.contains('selector-wrapper') ||
      selector.querySelector('.option-item[data-option="size"]') ||
      selector.classList.contains('bee-swatch') ||
      selector.classList.contains('bee-swatch__item') ||
      selector.classList.contains('bee-product-sizes');

    return isSizeSelector;
  });

  if (sizeSelectors.length === 0) {
    // Collect compatibility anomaly information - Found potential selectors but none passed size selector filtering
    const selectorInfo = customSizeSelectorCss && customSizeSelectorCss.trim()
      ? `Custom selectors used: ${customSizeSelectorCss}`
      : 'Using default theme selectors';

    exceptionCollector.collect(
      'sizechart_tooltip_filtering',
      `Found potential selectors but none passed size selector filtering. ${selectorInfo}. Found ${potentialSelectors.length} potential elements.`
    );
    return;
  }

  // 3. Get size chart data
  const sizeChartData = window.sizeChartData;
  let sizeInfo = {};
  let sizeInfoUnit = 'cm'; // Default unit
  let sizeOrder = []; // Add array to maintain original order
  let firstTableProcessed = false;

  if (sizeChartData && sizeChartData.length > 0) {
    // Find the appropriate size chart for current product
    let targetSizeChart = null;

    // First, try to find a size chart that should be displayed for current product
    for (const sizeChart of sizeChartData) {
      if (shouldDisplaySizeChart(sizeChart)) {
        targetSizeChart = sizeChart;
        break;
      }
    }

    // If no specific size chart found for current product, fallback to first one
    if (!targetSizeChart) {
      targetSizeChart = sizeChartData[0];
    }

    if (targetSizeChart?.settings?.blocks) {
      targetSizeChart.settings.blocks.forEach(block => {
        if (block.modules) {
          block.modules.forEach(module => {
            if (module.type === 'table') {
              // Log removed
            }

            // Relaxed condition: check for tableData OR tableDataCM to support new structure
            if (module.type === 'table' && module.content?.headers && (module.content?.tableData || module.content?.tableDataCM)) {
              if (firstTableProcessed) {
                return;
              }
              const headers = module.content.headers;
              // Fallback to tableDataCM if tableData is missing
              const tableData = module.content.tableData || module.content.tableDataCM;
              const unit = module.content.unit || 'cm'; // Get unit from module content
              const isTextTable = module.content.isTextTable || false; // Get isTextTable from module content
              const sizeColumnIndex = 0;

              // Save the unit, display mode, isTextTable and headers from the first table module
              if (Object.keys(sizeInfo).length === 0) {
                sizeInfoUnit = unit;
                // Persist unit display mode from the first table module if available
                sizeInfo._unitDisplayMode = module.content.unitDisplayMode || 'both';
                sizeInfo._isTextTable = isTextTable;
                sizeInfo._headers = headers;

                // Capture precomputed data
                // Explicitly check for properties even if they are empty arrays, but they should exist
                if (module.content.tableDataCM && module.content.tableDataINCH) {
                  sizeInfo._hasPrecomputedData = true;
                  sizeInfo._tableDataCM = module.content.tableDataCM;
                  sizeInfo._tableDataINCH = module.content.tableDataINCH;
                }

                // Support for legacy data: if originalData exists OR if we just have tableData (legacy inch case)
                if (!sizeInfo._hasPrecomputedData) {
                  try {
                    // Scenario 1: We have originalData (usually CM) and tableData (usually INCH)
                    if (module.content.originalData && Array.isArray(module.content.originalData) && module.content.originalData.length > 0) {
                      const originalData = module.content.originalData;
                      // Check structure of originalData
                      const isArrayOfArrays = Array.isArray(originalData[0]);
                      
                      // Construct tableDataCM from originalData + headers
                      const tableDataCM = tableData.map((row, rowIndex) => {
                        const newRow = {};
                        headers.forEach((header, colIndex) => {
                          let val;
                          const originalRow = originalData[rowIndex];
                          
                          if (originalRow) {
                             if (isArrayOfArrays) {
                               if (originalRow[colIndex] !== undefined) val = originalRow[colIndex];
                             } else if (typeof originalRow === 'object') {
                               if (originalRow[header] !== undefined) val = originalRow[header];
                             }
                          }
                          
                          if (val === undefined || val === null) {
                             val = row[header];
                          }
                          newRow[header] = val;
                        });
                        return newRow;
                      });
                      
                      // Construct tableDataINCH from tableDataCM
                      const tableDataINCH = tableDataCM.map(row => {
                        const newRow = {};
                        for (const key in row) {
                           if (key === headers[0] || key.trim().endsWith('*')) {
                               newRow[key] = row[key];
                           } else {
                               // Use fixed 2 decimals for legacy data conversion to preserve original precision
                               newRow[key] = convertRangeValueFixed(row[key], 'cm', 'inch', 2);
                           }
                        }
                        return newRow;
                      });
                      
                      sizeInfo._hasPrecomputedData = true;
                      sizeInfo._tableDataCM = tableDataCM;
                      sizeInfo._tableDataINCH = tableDataINCH;
                    } 
                    // Scenario 2: We only have tableData (legacy), and unit tells us what it is
                    else if (tableData && tableData.length > 0) {
                         if (unit === 'inch') {
                             // We have INCH data, convert to CM
                             const tableDataINCH = tableData;
                             const tableDataCM = tableDataINCH.map(row => {
                                 const newRow = {};
                                 for (const key in row) {
                                     if (key === headers[0] || key.trim().endsWith('*')) {
                                         newRow[key] = row[key];
                                     } else {
                                         // Convert INCH -> CM (factor 2.54)
                                         newRow[key] = convertRangeValueFixed(row[key], 'inch', 'cm', 2);
                                     }
                                 }
                                 return newRow;
                             });
                             sizeInfo._hasPrecomputedData = true;
                             sizeInfo._tableDataCM = tableDataCM;
                             sizeInfo._tableDataINCH = tableDataINCH;
                         } else {
                             // We have CM data (default), convert to INCH
                             const tableDataCM = tableData;
                             const tableDataINCH = tableDataCM.map(row => {
                                 const newRow = {};
                                 for (const key in row) {
                                     if (key === headers[0] || key.trim().endsWith('*')) {
                                         newRow[key] = row[key];
                                     } else {
                                         // Convert CM -> INCH (factor 1/2.54), fixed 2 decimals
                                         newRow[key] = convertRangeValueFixed(row[key], 'cm', 'inch', 2);
                                     }
                                 }
                                 return newRow;
                             });
                             sizeInfo._hasPrecomputedData = true;
                             sizeInfo._tableDataCM = tableDataCM;
                             sizeInfo._tableDataINCH = tableDataINCH;
                         }
                    }
                  } catch (e) {
                    console.error("Error processing legacy data in sizeInfo construction:", e);
                  }
                }
              }

              tableData.forEach(row => {
                const sizeName = row[headers[sizeColumnIndex]];
                if (sizeName) {
                  const measurements = {};
                  headers.forEach((header, index) => {
                    if (index > 0) {
                      measurements[header] = row[header];
                    }
                  });
                  sizeInfo[sizeName] = measurements;
                  // Add to sizeOrder array to maintain original order
                  sizeOrder.push(sizeName);
                }
              });
              firstTableProcessed = true;
            }
          });
        }
      });
    } else {
    }
  }

  // Add unit information to sizeInfo for global access
  if (Object.keys(sizeInfo).length > 0) {
    sizeInfo._unit = sizeInfoUnit;
    sizeInfo._sizeOrder = sizeOrder; // Add size order array to sizeInfo
  }
  
  if (Object.keys(sizeInfo).length === 0) {
    // Collect compatibility anomaly information - No size information data found
    const sizeChartInfo = {
      hasSizeChartData: !!sizeChartData,
      sizeChartDataLength: sizeChartData ? sizeChartData.length : 0,
      firstSizeChartStructure: null
    };

    if (sizeChartData && sizeChartData.length > 0) {
      const firstChart = sizeChartData[0];
      sizeChartInfo.firstSizeChartStructure = {
        hasSettings: !!firstChart.settings,
        hasBlocks: !!firstChart.settings?.blocks,
        blocksLength: firstChart.settings?.blocks?.length || 0,
        blockTypes: firstChart.settings?.blocks?.map(block => ({
          hasModules: !!block.modules,
          modulesLength: block.modules?.length || 0,
          moduleTypes: block.modules?.map(module => module.type) || []
        })) || []
      };
    }

    exceptionCollector.collect(
      'sizechart_tooltip_data',
      'Failed to extract size information from size chart data'
    );

    return;
  }

  // 4. Create size details display area for each size selector only if showSizeDetails is enabled
  let existingSizeDetails = document.querySelector('.pify_size_details_container');
  if (!existingSizeDetails && showSizeDetails) {
    existingSizeDetails = document.createElement('div');
    existingSizeDetails.className = 'pify_size_details_container';
    existingSizeDetails.style.margin = '10px 0';
    existingSizeDetails.style.display = 'none';

    if (themeName === 'handy') {
      const firstSwtContainer = document.querySelector('.swt-container');
      if (firstSwtContainer && firstSwtContainer.parentNode) {
        firstSwtContainer.parentNode.insertBefore(existingSizeDetails, firstSwtContainer.nextSibling);
      }
    } else {
      // Filter out color selectors, make sure we only process size selectors
      const realSizeSelectors = sizeSelectors.filter(selector => {
        const isColorRelated =
          selector.closest('.color-option') ||
          selector.closest('.color-circle') ||
          selector.closest('.variants-image') ||
          selector.classList.contains('color-option') ||
          selector.classList.contains('color-circle') ||
          selector.querySelector('[data-pallet-color]') ||
          selector.querySelector('[style*="--swatch_color"]');

        if (isColorRelated) return false;

        // Additional check for dropdown selectors - ensure they are actually size selectors
        if (isSelect(selector)) {
          const select = selector.tagName.toLowerCase() === 'select' ? selector : selector.querySelector('select');
          if (select) {
            const selectName = select.getAttribute('name') || '';
            const isActualSizeSelector = matchesSizeKeyword(selectName);

            // Also check the label text
            let labelText = '';
            const label = selector.querySelector('.form__label, .variant-swatches-text, .option-name, .variant-title');
            if (label) {
              labelText = label.textContent.trim().toLowerCase();
            }

            const isSizeSelectorByLabel = matchesSizeKeyword(labelText);

            // New: Check if it's a size selector by analyzing option values
            let isSizeSelectorByOptions = false;
            const options = select.querySelectorAll('option');
            if (options.length > 0) {
              // Common size patterns
              const sizePatterns = [
                /^(XXS|XS|S|M|L|XL|XXL|XXXL)$/i,  // Standard letter sizes
                /^(2XS|3XS|2XL|3XL|4XL|5XL)$/i,   // Extended letter sizes
                /^\d+$/,                           // Numeric sizes (32, 34, 36, etc.)
                /^\d+[A-Z]?$/i,                    // Numeric with letter (32R, 34L, etc.)
                /^\d+\.\d+$/,                      // Decimal sizes (8.5, 9.5, etc.)
                /^\d+\/\d+$/,                      // Fraction sizes (1/2, 3/4, etc.)
                /^(ONE SIZE|ONESIZE|OS|FREE SIZE|FREESIZE)$/i  // One size fits all
              ];

              let sizeOptionCount = 0;
              options.forEach(option => {
                const value = option.value.trim();
                const text = option.textContent.trim();

                // Skip empty options
                if (!value || !text) return;

                // Check if value or text matches size patterns
                const matchesPattern = sizePatterns.some(pattern =>
                  pattern.test(value) || pattern.test(text)
                );

                if (matchesPattern) {
                  sizeOptionCount++;
                }
              });

              // If more than half of the options look like sizes, consider it a size selector
              const validOptions = Array.from(options).filter(opt => opt.value.trim() && opt.textContent.trim());
              if (validOptions.length > 0 && sizeOptionCount / validOptions.length >= 0.5) {
                isSizeSelectorByOptions = true;
              }
            }

            return isActualSizeSelector || isSizeSelectorByLabel || isSizeSelectorByOptions;
          }
        }

        return true;
      });

      // Use the filtered array of real size selectors
      const selectorToUse = realSizeSelectors.length > 0 ?
        realSizeSelectors[realSizeSelectors.length - 1] : sizeSelectors[0];

      // Unified handling for all themes
      const parentElement = selectorToUse.parentElement;
      if (parentElement) {
        // If there is a parent element, insert after the parent element
        parentElement.parentNode.insertBefore(existingSizeDetails, parentElement.nextSibling);
      } else {
        // If there is no parent element, insert after the selector
        selectorToUse.parentNode.insertBefore(existingSizeDetails, selectorToUse.nextSibling);
      }
    }

    // Check if there's already a selected size and show details immediately
    // if (showSizeDetails && existingSizeDetails) {
    //   // Check for selected size in various selector types
    //   const selectedSize = getSelectedSizeValue(sizeSelectors);
    //   if (selectedSize && sizeInfo[selectedSize]) {
    //     debugger
    //     updateSizeDetails(selectedSize, sizeInfo, existingSizeDetails);
    //     return
    //   }
    // }
  }

  // Helper function to get currently selected size value
  function getSelectedSizeValue(selectors) {
    for (const selector of selectors) {
      // Check select dropdown
      const select = selector.querySelector('select');
      if (select && select.value) {
        return select.value.split('[')[0].trim();
      }
      
      // Check radio buttons
      const checkedRadio = selector.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        return checkedRadio.value || checkedRadio.getAttribute('data-value') || checkedRadio.title;
      }
      
      // Check selected buttons/chips
      const selectedButton = selector.querySelector('.selected, .active, .is-selected, .variant-option--selected');
      if (selectedButton) {
        return selectedButton.getAttribute('data-value') || selectedButton.getAttribute('data-option-value') || selectedButton.textContent.trim();
      }
    }
    return null;
  }

  // Final sizeSelectors to process
  
  sizeSelectors.forEach((selector, index) => {
    // Processing selector
    
    // First check for specific selector structure
    if (isSelect(selector)) {
      // Handling as select dropdown
      // Handle dropdown
      handleSelectSizeSelector(selector, sizeInfo, existingSizeDetails);
      return;
    } else if (selector.querySelector('.product-option-picker__list-item')) {
      // Handling as li+div structure with handleLiSizeSelector
      // Handle li+div structure
      handleLiSizeSelector(selector, sizeInfo, existingSizeDetails);
      return;
    } else if (selector.tagName === 'XO-POPOVER' || selector.classList.contains('xo-field-select-custom__popover')) {
      // Handling as XO theme dropdown
      // Handle XO theme special dropdown structure
      handleXoFieldSelectCustom(selector, sizeInfo, existingSizeDetails);
      return;
    } else if (selector.classList.contains('swatch--gl') || selector.closest('.globo-swatch-product-detail')) {
      handleRadioSizeSelector(selector, sizeInfo, existingSizeDetails);
      return;
    }
    // Process different structures according to theme name
    switch (themeName) {
      case 'andaman':
        // Handle Andaman theme size selector - process a + span structure
        handleAndamanSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles <a class="swatch"> + <span> structure
        break;
      case 'modules':
      case 'spark':
      case 'lorenza':
      case 'cornerstone':
      case 'stiletto':
        // Handle button-style size selector - applicable to multiple themes
        handleButtonSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles button-style selectors <div class="optionBtns"> or <div class="product__chip"> structure
        break;

      case 'eclipse':
        // Handle Eclipse theme size selector - process label > input+button structure
        handleChipSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles chip-style selectors <label class="variant-option--chips"> > <input type="radio"> + <button class="chip"> structure
        break;

      case 'aurora':
        // Handle pill style selector - label + span structure
        handlePillSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles pill-style selectors <label class="pill"> > <span class="pill__label"> structure
        break;

      case 'showcase':
        // Handle Showcase theme clickyboxes structure - process li + a structure
        handleClickyboxesSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles clickyboxes structure <ul> > <li> > <a data-value=""> structure
        break;

      case 'xtra':
        // Handle xtra theme special structure
        handleXtraSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles special structure <li> > <input type="radio" title="Default / M"> + <label> structure
        break;

      case 'momentum':
        // Handle custom dropdown menu - button + ul structure
        handleCustomDropdownSelector(selector, sizeInfo, existingSizeDetails);
        // Handles custom dropdown menu <button> + <ul role="listbox"> > <li data-option-value=""> structure
        break;

      case 'kalles':
        handleKallesSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Kalles theme structure <div class="t4s-swatch__item" data-value=""> structure
        break;

      case 'unsen':
        handleKallesSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Reuses Kalles structure handling
        break;

      case 'shella':
        handleShellaSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Shella theme structure <div class="product-options__value" data-value=""> structure
        break;

      case 'umino':
        handleUminoSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Umino theme structure <div class="bls__option-swatch" data-value=""> structure
        break;

      case 'venedor':
        // Handle Venedor theme size selector - process label structure without radio buttons
        handleVenedorSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Venedor theme structure <label class="option-label" data-value=""> structure (no radio buttons)
        break;

      case 'vinova modamate':
        // Handle Vinova Modamate theme size selector - process fieldset.product-variant-form-input structure
        handleVinovaModamateSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Vinova Modamate theme structure <fieldset> > <div class="product-single__variant-item"> > <input type="radio"> + <label> structure
        break;

      case 'foxic':
        // Handle Foxic theme size selector - process div.prd-size structure
        handlePrdSizeListSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Foxic theme structure <div class="prd-size"> > <ul class="size-list"> > <li> > <a data-value=""> structure
        break;

      case 'goodwin':
        // Handle Goodwin theme size selector - process div.prd-size structure with hidden select
        handlePrdSizeListSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Goodwin theme structure <div class="prd-size"> > <ul class="size-list"> > <li> > <a data-value=""> structure
        break;

      case 'corano':
        // Handle Corano theme size selector - process swatch structure without hover tooltips
        handleCoranoSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Corano theme structure <div class="swatch"> > <div class="swatch-element"> > <input type="radio"> + <label> structure
        break;

      case 'lusion':
        // Handle Lusion theme size selector - process div.selector-wrapper structure
        handleLusionSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Lusion theme structure <div class="selector-wrapper"> > <div class="swatch"> > <span class="option-item" data-value=""> structure
        break;

      case 'lusion-fashion-women':
        // Handle Lusion theme size selector - process div.selector-wrapper structure
        handleLusionSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Lusion theme structure <div class="selector-wrapper"> > <div class="swatch"> > <span class="option-item" data-value=""> structure
        break;

      case 'eva':
        // Handle Eva theme size selector - process span.swatch structure
        handleLusionSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Reuses Lusion structure handling but uses <span class="swatch" data-value=""> structure
        break;

      case 'unero':
        // Handle Unero theme size selector - process span.swatch structure
        handleLusionSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Reuses Lusion structure handling but uses <span class="swatch" data-value=""> structure
        break;
        
      case 'nitro':
        // Handle Nitro theme size selector - process bee-swatch structure
        handleBeeSwatchSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Nitro theme structure <div class="bee-swatch"> > <div class="bee-swatch__item" data-value=""> structure
        break;

      case 'lumia':
        // Handle lumia theme size selector - process prd-option-list structure
        handlePrdOptionListSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles lumia theme structure <fieldset class="prd-option-list"> > <label class="label-radio"> > <input type="radio"> + <span> structure
        break;

      case 'wokiee':
        // Handle Wokiee theme size selector - process tt-wrapper structure
        handleWokieeSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Wokiee theme structure <div class="tt-wrapper"> > <ul class="tt-options-swatch"> > <li> > <a data-value=""> structure
        break;
      default:
        // Handle traditional radio+label structure
        handleRadioSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles traditional radio button structure <fieldset> > <input type="radio"> + <label for=""> structure
        break;
    }
  });

  // Apply theme-specific fixes using the helper function
  const themesWithPositionFixes = ['proto', 'electro theme', 'elomus', 'corano', 'lezada os 2.0', 'learts - shopify theme '];
  themesWithPositionFixes.forEach(theme => {
    if (themeName === theme) {
      fixSizeDetailsPosition(themeName, null, sizeInfo, existingSizeDetails);
    }
  });
}

function isSelect(selector) {
  if (selector.tagName === 'SELECT') {
    return true;
  }
  // 1. Check if there is a visible select element
  const select = selector.querySelector('select');
  if (!select) return false;

  // 2. Check if select is hidden
  const style = window.getComputedStyle(select);
  if (style.display === 'none' ||
    style.visibility === 'hidden' ||
    select.classList.contains('hidden') ||
    select.hasAttribute('hidden')) {
    return false;
  }

  // 3. Check if there is a radio element
  const hasRadio = selector.querySelector('input[type="radio"]') !== null;
  if (hasRadio) return false;

  // 4. Check if there is a custom dropdown style class
  const hasCustomSelectClass = selector.classList.contains('styled-pills-radio') ||
    selector.classList.contains('custom-select') ||
    selector.classList.contains('styled-select');
  if (hasCustomSelectClass) return false;

  return true;
}

// Handle dropdown size selector
function handleSelectSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  const select = selector.tagName.toLowerCase() === 'select' ?
    selector :
    selector.querySelector('select');

  if (!select || select.dataset.pifyProcessed === 'true') {
      return;
  }
  select.dataset.pifyProcessed = 'true';

  // Check if this is actually a size selector by checking the name attribute or label
  const selectName = select.getAttribute('name') || '';
  const isActualSizeSelector = matchesSizeKeyword(selectName);

  // Also check the label text to confirm it's a size selector
  let labelText = '';
  const label = selector.querySelector('.form__label, .variant-swatches-text, .option-name, .variant-title');
  if (label) {
    labelText = label.textContent.trim().toLowerCase();
  }
  const isSizeSelectorByLabel = matchesSizeKeyword(labelText);

  // New: Check if it's a size selector by analyzing option values
  let isSizeSelectorByOptions = false;
  const options = select.querySelectorAll('option');
  if (options.length > 0) {
    // Common size patterns
    const sizePatterns = [
      /^(XXS|XS|S|M|L|XL|XXL|XXXL)$/i,  // Standard letter sizes
      /^(2XS|3XS|2XL|3XL|4XL|5XL)$/i,   // Extended letter sizes
      /^\d+$/,                           // Numeric sizes (32, 34, 36, etc.)
      /^\d+[A-Z]?$/i,                    // Numeric with letter (32R, 34L, etc.)
      /^\d+\.\d+$/,                      // Decimal sizes (8.5, 9.5, etc.)
      /^\d+\/\d+$/,                      // Fraction sizes (1/2, 3/4, etc.)
      /^(ONE SIZE|ONESIZE|OS|FREE SIZE|FREESIZE)$/i,  // One size fits all
      /[-_\s](XXS|XS|S|M|L|XL|XXL|XXXL)$/i, // Ends with size (e.g. "Costume - S")
      /^(XXS|XS|S|M|L|XL|XXL|XXXL)[-_\s]/i  // Starts with size
    ];

    let sizeOptionCount = 0;
    options.forEach(option => {
      const value = option.value.trim();
      const text = option.textContent.trim();

      // Skip empty options
      if (!value || !text) return;

      // Check if value or text matches size patterns
      const matchesPattern = sizePatterns.some(pattern =>
        pattern.test(value) || pattern.test(text)
      );

      if (matchesPattern) {
        sizeOptionCount++;
      }
    });

    // If more than half of the options look like sizes, consider it a size selector
    const validOptions = Array.from(options).filter(opt => opt.value.trim() && opt.textContent.trim());
    if (validOptions.length > 0 && sizeOptionCount / validOptions.length >= 0.5) {
      isSizeSelectorByOptions = true;
    }
  }

  // Only proceed with container repositioning if this is actually a size selector
  if (!isActualSizeSelector && !isSizeSelectorByLabel && !isSizeSelectorByOptions) {
    return;
  }

  // Ensure select element has correct positioning
  const selectParent = select.parentNode;
  if (window.getComputedStyle(selectParent).position === 'static') {
    selectParent.style.position = 'relative';
  }

  // Create a hover tooltip for the dropdown only if showTooltip is enabled
  const showTooltip = window.settings?.primaryInteractiveColor?.showTooltip !== false;
  let tooltip = null;
  if (showTooltip) {
    tooltip = document.createElement('div');
    tooltip.className = 'pify_size_tooltip';
    tooltip.style.opacity = '0';
    tooltip.style.display = 'none';
    selectParent.appendChild(tooltip);
    // setTooltipParentOverflow(tooltip);
  }

  // Modify: Move the size details container after the entire selector container
  // Find the entire selector container - determine selector based on theme name
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
  let selectorString;
  switch (themeName) {
    case 'sunrise':
      selectorString = '.variant-picker';
      break;
    case 'emporium':
      selectorString = '.options-selection__select-wrapper';
      break;
    case 'grid':
      selectorString = '.product-options';
      break;
    case 'berlin':
    case 'sydney':
      selectorString = '.product-parameters__item';
      break;
    case 'handmade':
      selectorString = '.product-form__wrapper';
      break;
    case 'exhibit':
      selectorString = '.product-variant-picker-block';
      break;
    case 'mojave':
      selectorString = '.main-product__form-input';
      break;
    case 'swipe':
      selectorString = '.product-form__controls';
      break;
    default:
      selectorString = '.product-form__input';
  }

  // Ensure the size details container is in the correct position in the DOM
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Get the correct selector container and insert size details
  let selectorContainer = null;

  if (themeName === 'foodie') {
    // Special handling for foodie theme - first check if the select name attribute contains "Size"
    const selectName = select.getAttribute('name') || '';
    if (matchesSizeKeyword(selectName)) {
      // Use the current select's parent container directly
      selectorContainer = select.closest('.product-form__input');
    } else {
      // Try to find a size selector with a Size label or name attribute in the page
      let foodieSelector = '.product-form__input select[name*="Size"], .product-form__input select[name*="size"]';
      if (window.pifySizeLabel && Array.isArray(window.pifySizeLabel)) {
         window.pifySizeLabel.forEach(label => {
           if (label && typeof label === 'string') {
               const safeLabel = label.replace(/"/g, '\\"');
               foodieSelector += `, .product-form__input select[name*="${safeLabel}"]`;
           }
         });
      }
      const allSelects = document.querySelectorAll(foodieSelector);
      if (allSelects.length > 0) {
        // Use the first found size select's parent container
        selectorContainer = allSelects[0].closest('.product-form__input');
      }

      // If still not found, try to find it through the label text
      if (!selectorContainer) {
        const sizeLabels = document.querySelectorAll('.form__label');
        for (const label of sizeLabels) {
          if (matchesSizeKeyword(label.textContent.trim())) {
            selectorContainer = label.closest('.product-form__input');
            if (selectorContainer) break;
          }
        }
      }

      // If all else fails, use the regular method
      if (!selectorContainer) {
        selectorContainer = selector.closest(selectorString) || selector.parentElement;
      }
    }
  } else if (themeName === 'chord') {
    // Special handling for chord theme - find the correct container through the select id
    // First get the select element
    if (select.id === 'options-variant_picker-[Size]') {
      // Find the Form__Item containing this select
      selectorContainer = select.closest('.Form__Item');
      // If still not found, try to find ProductForm__Option
      if (!selectorContainer) {
        selectorContainer = select.closest('.ProductForm__Option');
      }
    } else {
      // Find the select element with id options-variant_picker-[Size] in the page
      const sizeSelect = document.getElementById('options-variant_picker-[Size]');
      if (sizeSelect) {
        selectorContainer = sizeSelect.closest('.Form__Item') || sizeSelect.closest('.ProductForm__Option');
      } else {
        selectorContainer = selector.parentElement;
      }
    }
  } else {
    selectorContainer = selector.closest(selectorString) || selector.parentElement;
  }

  // Insert the size details container after the selector container
  if (selectorContainer && selectorContainer.parentNode) {
    selectorContainer.parentNode.insertBefore(selectedSizeDetails, selectorContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Helper function to find case-insensitive key
  const findSizeKey = (value) => {
    return matchSizeValue(value, sizeInfo);
  };

  // Update hover tooltip content function
  const updateTooltipContent = (sizeValue) => {
    const matchedKey = findSizeKey(sizeValue);
    if (tooltip && matchedKey) {
      const smartTooltip = createSmartSizeTooltip(matchedKey, sizeInfo);
      if (smartTooltip) {
        tooltip.innerHTML = smartTooltip.innerHTML;
        tooltip.style.display = 'block';
        // Ensure consistent styling with button tooltips
        tooltip.style.pointerEvents = 'none';
        tooltip.style.transition = 'all 0.2s ease-in-out';
      } else {
        tooltip.style.display = 'none';
      }
    } else if (tooltip) {
      tooltip.style.display = 'none';
    }
  };

  const handleSizeChange = function (e) {
    const rawValue = e.target.value;
    const selectedValue = rawValue.split('[')[0].trim();
    const matchedKey = findSizeKey(selectedValue);
    updateTooltipContent(selectedValue); // This will call findSizeKey internally
    if (matchedKey) {
        updateSizeDetails(matchedKey, sizeInfo, selectedSizeDetails);
    }
  };

  select.removeEventListener('change', handleSizeChange);
  select.addEventListener('change', handleSizeChange, { capture: true });

  select.addEventListener('mouseenter', () => {
    const currentValue = select.value.split('[')[0].trim();
    const matchedKey = findSizeKey(currentValue);
    if (tooltip && matchedKey) {
      updateTooltipContent(currentValue); // Reuse content update logic
      tooltip.style.setProperty('opacity', '1', 'important');
    }
  });

  select.addEventListener('mouseleave', () => {
    if (tooltip) {
      tooltip.style.setProperty('opacity', '0', 'important');
    }
  });

  if (select.value) {
    const cleanValue = select.value.split('[')[0].trim();
    const matchedKey = findSizeKey(cleanValue);
    if (matchedKey) {
        updateTooltipContent(cleanValue);
        updateSizeDetails(matchedKey, sizeInfo, selectedSizeDetails);
    }
  }
}

// Helper to attach tooltip to body to avoid overflow issues
function attachTooltipToBody(target, tooltip) {
  document.body.appendChild(tooltip);
  
  // Override conflicting CSS class styles using important
  tooltip.style.setProperty('position', 'absolute', 'important');
  tooltip.style.setProperty('z-index', '2147483647', 'important');
  tooltip.style.setProperty('display', 'block', 'important');
  tooltip.style.setProperty('opacity', '0', 'important'); // Initial hidden state
  tooltip.style.setProperty('bottom', 'auto', 'important');
  tooltip.style.setProperty('transform', 'none', 'important');
  tooltip.style.setProperty('margin', '0', 'important');
  tooltip.style.setProperty('visibility', 'hidden', 'important'); // Use visibility for initial hide
  tooltip.style.setProperty('transition', 'opacity 0.2s ease-in-out, visibility 0.2s ease-in-out', 'important');
  
  tooltip.style.pointerEvents = 'none'; // Ensure it doesn't block interaction

  const show = () => {
    const rect = target.getBoundingClientRect();
    const scrollX = window.scrollX || window.pageXOffset;
    const scrollY = window.scrollY || window.pageYOffset;

    // First calculate position while hidden but available for layout
    tooltip.style.setProperty('visibility', 'hidden', 'important');
    tooltip.style.setProperty('display', 'block', 'important');

    const tooltipRect = tooltip.getBoundingClientRect();

    // Position: centered above
    let left = rect.left + scrollX + (rect.width / 2) - (tooltipRect.width / 2);
    let top = rect.top + scrollY - tooltipRect.height - 10;

    // Basic viewport boundary check
    if (left < 0) left = 10;
    // If top is offscreen, flip to bottom
    if (top < scrollY) {
        top = rect.bottom + scrollY + 10;
    }

    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;

    // Now show with animation
    // Use requestAnimationFrame to ensure style changes are applied before opacity transition
    requestAnimationFrame(() => {
        tooltip.style.setProperty('visibility', 'visible', 'important');
        tooltip.style.setProperty('opacity', '1', 'important');
    });
  };

  const hide = () => {
    tooltip.style.setProperty('opacity', '0', 'important');
    tooltip.style.setProperty('visibility', 'hidden', 'important');
    // We don't need to set display:none because visibility:hidden handles the visual hiding
    // and pointer-events:none handles interaction. Keeping display:block avoids layout thrashing next time.
  };

  target.addEventListener('mouseenter', show);
  target.addEventListener('mouseleave', hide);
}

// Handle radio button size selector
function handleRadioSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  let lastUpdatedValue = null;
  let rafId = null;
  let pendingValue = null;
  function scheduleUpdate(value) {
    if (!selectedSizeDetails || !value) return;
    pendingValue = value;
    if (rafId !== null) return;
    rafId = requestAnimationFrame(() => {
      const v = pendingValue;
      rafId = null;
      pendingValue = null;
      if (v && v !== lastUpdatedValue) {
        updateSizeDetails(v, sizeInfo, selectedSizeDetails);
        lastUpdatedValue = v;
      }
    });
  }

  // Special handling for whisk theme - distinguish between quick-add and main product selectors
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';

  if (themeName === 'whisk') {
    const radioButtons = selector.querySelectorAll('input[type="radio"]');
    if (radioButtons.length > 0) {
      const firstRadio = radioButtons[0];
      const radioName = firstRadio.getAttribute('name') || '';
      const isQuickAdd = radioName.includes('pdp-quick-add');

      if (isQuickAdd) {
        // This is a quick-add selector, find the main product selector instead
        const mainProductRadios = document.querySelectorAll('input[type="radio"][name*="--size--"]:not([name*="pdp-quick-add"])');
        if (mainProductRadios.length > 0) {
          // Use the first main product size radio's container
          const mainSizeSelector = mainProductRadios[0].closest('fieldset.variant-picker__buttons');
          if (mainSizeSelector) {
            // Ensure the size details container is positioned after the main selector
            if (selectedSizeDetails.parentNode) {
              selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
            }
            if (mainSizeSelector.parentNode) {
              mainSizeSelector.parentNode.insertBefore(selectedSizeDetails, mainSizeSelector.nextSibling);
            }
            return; // Exit early, don't process the quick-add selector
          }
        }
      }
    }
  }

  if (themeName === 'noire') {
    const radioButtons = selector.querySelectorAll('input[type="radio"]');
    if (radioButtons.length > 0) {
      const firstRadio = radioButtons[0];
      const formAttribute = firstRadio.getAttribute('form') || '';
      const isFloatedForm = formAttribute.includes('floated-product-form');

      if (isFloatedForm) {
        // This is a floated selector, find the main product selector instead
        const mainProductRadios = document.querySelectorAll('input[type="radio"][name="Size"]:not([form*="floated-product-form"])');
        if (mainProductRadios.length > 0) {
          // Use the first main product size radio's container
          const mainSizeSelector = mainProductRadios[0].closest('.variant-field');
          if (mainSizeSelector) {
            // Ensure the size details container is positioned after the main selector
            if (selectedSizeDetails.parentNode) {
              selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
            }
            if (mainSizeSelector.parentNode) {
              mainSizeSelector.parentNode.insertBefore(selectedSizeDetails, mainSizeSelector.nextSibling);
            }

            // Check for default selected radio in main product selector and update size details
            const defaultSelectedRadio = mainSizeSelector.querySelector('input[type="radio"]:checked');
            if (defaultSelectedRadio) {
              const selectedValue = defaultSelectedRadio.value.split('[')[0].trim();
            const matchedSizeValue = matchSizeValue(selectedValue, sizeInfo);
              if (matchedSizeValue) {
                scheduleUpdate(matchedSizeValue);
              }
            }

            return; // Exit early, don't process the floated selector
          }
        }
      }
    }
  }

  const radioButtons = selector.querySelectorAll('input[type="radio"]');

  if (!radioButtons.length) {
    // Collect compatibility anomaly information - No radio buttons found
    exceptionCollector.collect(
      'sizechart_radio_selectors',
      'No radio buttons found in size selector element'
    );
    return;
  }

  // Check if it's a special theme structure
  // Handle themes with hidden labels
  const isSpecialTheme = selector.closest('.product-swatch-item') !== null || // Paris theme
    selector.closest('.variant-item') !== null || // Master theme
    selector.closest('.variant_option') !== null ||// Fame theme
    selector.closest('.swatch-element') !== null; // avenue theme

  // Save the original text content of the label
  const labelOriginalTextMap = new Map();

  radioButtons.forEach((radio, index) => {
    if (radio.dataset.pifyProcessed === 'true') return;
    radio.dataset.pifyProcessed = 'true';

    // Get the corresponding label - support for new label structures
    const escapedId = CSS.escape(radio.id);
    const label = selector.querySelector(`label[for="${escapedId}"]`) ||
      radio.parentElement.querySelector('label') ||
      radio.closest('.radio__button')?.querySelector('label') ||
      radio.closest('.product-selector__button__holder')?.querySelector('label') ||
      radio.closest('.variant-picker__option')?.querySelector('.variant-picker__option-button') ||
      radio.closest('li')?.querySelector('.variant-radio') ||
      radio.closest('.option-selector__btns')?.querySelector('.opt-label[for="' + escapedId + '"]') ||
      radio.closest('.button--pill') ||
      radio.closest('.variant-picker__label') ||
      radio.closest('.radio__buttons')?.querySelector(`label[for="${escapedId}"]`) ||
      radio.closest('.variant-input')?.querySelector(`label[for="${escapedId}"]`) ||
      radio.closest('.option-swatch')?.querySelector(`label[for="${escapedId}"]`) ||
      radio.closest('.xo-field-radio') ||
      radio.closest('.options-selection__option-value-label') ||
      radio.closest('.variant-option__button-label');
    if (!label) {
      return;
    }

    // Save the original text content of the label
    let originalText;
    if (label.classList.contains('swatch-anchor') && label.querySelector('.attr-title-hover')) {
      const clone = label.cloneNode(true);
      const hoverSpan = clone.querySelector('.attr-title-hover');
      if (hoverSpan) hoverSpan.remove();
      originalText = clone.textContent.trim();
    } else {
      originalText = label.childNodes.length > 0 ?
        (label.childNodes[0].nodeType === Node.TEXT_NODE ? label.childNodes[0].textContent.trim() : label.textContent.trim()) :
        label.textContent.trim();
    }

    labelOriginalTextMap.set(radio.id, originalText);

    // First try to match the input's value with the size chart
    let sizeValue = radio.value.split('[')[0].trim();

    // Try to find matching size value with case variations
    let matchedSizeValue = matchSizeValue(sizeValue, sizeInfo);

    // If the input value cannot find corresponding data in the size chart, try to use the label text
    if (!matchedSizeValue && label) {
      matchedSizeValue = matchSizeValue(originalText, sizeInfo);
    }

    if (matchedSizeValue) {
      const tooltip = createSmartSizeTooltip(matchedSizeValue, sizeInfo);

      // Only perform DOM operations when tooltip is not null
      if (tooltip) {
        // Check for overflow issues or specific theme classes
        const labelStyle = window.getComputedStyle(label);
        const hasOverflowIssue = label.classList.contains('variant-option__button-label') || 
                                 label.classList.contains('swatch-anchor') || // Globo App
                                 ['hidden', 'clip', 'scroll', 'auto'].includes(labelStyle.overflow) || 
                                 ['hidden', 'clip', 'scroll', 'auto'].includes(labelStyle.overflowX) || 
                                 ['hidden', 'clip', 'scroll', 'auto'].includes(labelStyle.overflowY);

        if (hasOverflowIssue) {
          attachTooltipToBody(label, tooltip);
        } else {
          // Ensure label has the correct positioning
          if (labelStyle.position === 'static') {
            label.style.position = 'relative';
          }
          label.appendChild(tooltip);
          // setTooltipParentOverflow(tooltip);

          // If it's a special theme structure, add event listeners to the span element
          if (isSpecialTheme) {
            const span = radio.closest('.product-swatch-item')?.querySelector('.swatch-variant-item') ||
              radio.closest('.variant-item')?.querySelector('.variant-item-name') ||
              radio.closest('.variant_option')?.querySelector('.option') ||
              radio.closest('.swatch-element')?.querySelector('.swatch-label');

            if (span) {
              span.style.position = 'relative';
              span.appendChild(tooltip.cloneNode(true));

              const handleMouseEnter = (e) => {
                e.stopPropagation();
                const tooltips = document.querySelectorAll('.pify_size_tooltip');
                tooltips.forEach(t => {
                  if (t.textContent.includes(matchedSizeValue)) {
                    t.style.opacity = '1';
                  }
                });
              };

              const handleMouseLeave = (e) => {
                e.stopPropagation();
                const tooltips = document.querySelectorAll('.pify_size_tooltip');
                tooltips.forEach(t => {
                  if (t.textContent.includes(matchedSizeValue)) {
                    t.style.opacity = '0';
                  }
                });
              };

              span.addEventListener('mouseenter', handleMouseEnter);
              span.addEventListener('mouseleave', handleMouseLeave);
            }
          }

          // Use event delegation to handle mouse events
          const handleMouseEnter = (e) => {
            e.stopPropagation();
            if (tooltip) {
              tooltip.style.opacity = '1';
            }
          };

          const handleMouseLeave = (e) => {
            e.stopPropagation();
            if (tooltip) {
              tooltip.style.opacity = '0';
            }
          };

          label.removeEventListener('mouseenter', handleMouseEnter);
          label.removeEventListener('mouseleave', handleMouseLeave);

          label.addEventListener('mouseenter', handleMouseEnter);
          label.addEventListener('mouseleave', handleMouseLeave);
        }
      }
    }

    // Add change event listener to all radio buttons, regardless of whether there is data
    const handleChange = (e) => {
      const element = e.target;
      let newSizeValue = element.value.split('[')[0].trim();
      const originalText = labelOriginalTextMap.get(element.id);
      const matchedNewSizeValue =
        matchSizeValue(newSizeValue, sizeInfo) ||
        (originalText ? matchSizeValue(originalText, sizeInfo) : null) ||
        newSizeValue;
      
      scheduleUpdate(matchedNewSizeValue);
      // Keep base behavior; no ATC/variant-id forcing here
    };

    radio.removeEventListener('change', handleChange);
    radio.addEventListener('change', handleChange);
  });

  // Ensure the size details container is in the correct position in the DOM
  if (selectedSizeDetails && selector.parentNode) {
    // Check if we need to move the container
    if (selectedSizeDetails.parentNode !== selector.parentNode || selectedSizeDetails.previousElementSibling !== selector) {
       if (selectedSizeDetails.parentNode) {
         selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
       }
       selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
    }
  }

  const defaultSelectedRadio = selector.querySelector('input[type="radio"]:checked');
  if (defaultSelectedRadio) {
    // First try using input value
    let selectedValue = defaultSelectedRadio.value.split('[')[0].trim();

    // Try to find matching size value with case variations
    let matchedSelectedValue = matchSizeValue(selectedValue, sizeInfo);

    // If the size chart doesn't have corresponding data, try using label text
    if (!matchedSelectedValue) {
      // Get original text from saved Map
      const originalText = labelOriginalTextMap.get(defaultSelectedRadio.id);

      if (originalText) {
        matchedSelectedValue = matchSizeValue(originalText, sizeInfo);
      }
    }

    scheduleUpdate(matchedSelectedValue || selectedValue);
  }
}

function matchSizeValue(value, sizeInfo) {
  if (!value) return null;
  
  // Helper to normalize whitespace (replace non-breaking spaces and multiple spaces with single space)
  const normalize = (str) => String(str || '').replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  
  const targetValue = normalize(value);

  // Check for new structure
  if (sizeInfo && sizeInfo._hasPrecomputedData && sizeInfo._tableDataCM && sizeInfo._headers) {
      const sizeKey = sizeInfo._headers[0];
      
      // Check in tableDataCM
      const matchedRow = sizeInfo._tableDataCM.find(row => {
          const dbValue = normalize(row[sizeKey]);
          return dbValue === targetValue;
      });

      if (matchedRow) {
          // Return the exact key from the DB to ensure consistency
          return String(matchedRow[sizeKey]).trim(); 
      }
      
      return null;
  }

  // Check for old structure
  const matchedKey = Object.keys(sizeInfo).find(k => normalize(k) === targetValue);
  if (matchedKey) {
    return matchedKey;
  }
  
  return null;
}

// Helper to get size data for a specific unit (handles both old and new structures)
function getSizeChartRowData(sizeValue, sizeInfo, unit) {
  if (sizeInfo && sizeInfo._hasPrecomputedData && sizeInfo._tableDataCM && sizeInfo._tableDataINCH && sizeInfo._headers) {
    const targetData = unit === 'inch' ? sizeInfo._tableDataINCH : sizeInfo._tableDataCM;
    // Assume first header is the size key
    const sizeKey = sizeInfo._headers[0]; 
    
    // Find row
    const row = targetData.find(d => String(d[sizeKey]).trim() === String(sizeValue).trim());
    
    if (row) {
      // Return data in a format compatible with existing logic: { Measurement: Value, ... }
      // Exclude the size key itself, maintain header order
      const result = {};
      sizeInfo._headers.slice(1).forEach(header => {
         // Find the key in row that matches header
         const rowKey = Object.keys(row).find(k => k === header);
         if (rowKey) {
             result[header] = row[rowKey];
         } else {
             result[header] = '-';
         }
      });
      return result;
    }
  }
  
  // Legacy data support
  const rawData = sizeInfo && sizeInfo[sizeValue] ? sizeInfo[sizeValue] : null;
  
  if (rawData) {
    const baseUnit = sizeInfo._unit || 'cm';
    
    // If requested unit matches base unit, return raw data
    if (unit === baseUnit) {
      return rawData;
    }
    
    // If requesting CM but base is INCH
    if (unit === 'cm' && baseUnit === 'inch') {
      // Check for cached legacy original CM data
      if (sizeInfo._legacyOriginalDataCM && sizeInfo._legacyOriginalDataCM[sizeValue]) {
        return sizeInfo._legacyOriginalDataCM[sizeValue];
      }
      
      // Fallback: Convert INCH to CM
      const convertedData = {};
      Object.keys(rawData).forEach(key => {
        convertedData[key] = convertRangeValue(rawData[key], 'inch', 'cm');
      });
      return convertedData;
    }
    
    // If requesting INCH but base is CM
    if (unit === 'inch' && baseUnit === 'cm') {
      // Convert CM to INCH
      const convertedData = {};
      Object.keys(rawData).forEach(key => {
        convertedData[key] = convertRangeValue(rawData[key], 'cm', 'inch');
      });
      return convertedData;
    }
  }
  
  const result = rawData;
  return result;
}

// Create smart size tooltip (handles data fetching)
function createSmartSizeTooltip(sizeValue, sizeInfo) {
  const unitDisplayMode = sizeInfo._unitDisplayMode || 'both';
  
  let measurementsCM = null;
  let measurementsINCH = null;

  if (sizeInfo._hasPrecomputedData) {
    measurementsCM = getSizeChartRowData(sizeValue, sizeInfo, 'cm');
    measurementsINCH = getSizeChartRowData(sizeValue, sizeInfo, 'inch');
  } else {
    // With updated getSizeChartRowData handling legacy data conversion and lookup,
    // we can simply call it for both units.
    measurementsCM = getSizeChartRowData(sizeValue, sizeInfo, 'cm');
    measurementsINCH = getSizeChartRowData(sizeValue, sizeInfo, 'inch');
  }

  const baseUnit = sizeInfo._unit || 'cm';
  return createSizeTooltip(sizeValue, measurementsCM, measurementsINCH, unitDisplayMode, baseUnit);
}

// Create size tooltip
function createSizeTooltip(sizeValue, measurementsCM, measurementsINCH, unitDisplayMode, baseUnit = 'cm') {
  // Check if tooltip should be shown
  const showTooltip = window.settings?.primaryInteractiveColor?.showTooltip !== false;
  
  // Basic validation - at least one set of measurements should exist
  if (!showTooltip || (!measurementsCM && !measurementsINCH)) {
    return null;
  }
  
  const tooltip = document.createElement('div');
  tooltip.className = 'pify_size_tooltip';
  // Ensure tooltip does not intercept pointer events
  tooltip.style.pointerEvents = 'none';
  // Add transition effects
  tooltip.style.transition = 'all 0.2s ease-in-out';

  // Determine which keys to iterate over (union of keys)
  const keys = new Set([
    ...(measurementsCM ? Object.keys(measurementsCM) : []),
    ...(measurementsINCH ? Object.keys(measurementsINCH) : [])
  ]);

  // Create table rows
  const rowsHTML = Array.from(keys).map(key => {
    const valCM = measurementsCM ? (measurementsCM[key] || '-') : '-';
    const valINCH = measurementsINCH ? (measurementsINCH[key] || '-') : '-';
    
    // Format label
    const label = key.endsWith('*') ? key.slice(0, -1) : key;
    
    // Determine cell content based on unitDisplayMode
    let cells = '';
    if (unitDisplayMode === 'cm') {
      cells = `<td>${valCM}</td>`;
    } else if (unitDisplayMode === 'inch') {
      cells = `<td>${valINCH}</td>`;
    } else if (unitDisplayMode === 'none') {
      // Show data corresponding to the base unit
      if (baseUnit === 'inch') {
        cells = `<td>${valINCH}</td>`;
      } else {
        cells = `<td>${valCM}</td>`;
      }
    } else {
      // both or default
      cells = `<td>${valCM}</td><td>${valINCH}</td>`;
    }
    
    return `<tr><td>${label}</td>${cells}</tr>`;
  }).join('');

  // Determine header columns
  let headersHTML = '';
  if (unitDisplayMode === 'cm') {
    headersHTML = '<th>CM</th>';
  } else if (unitDisplayMode === 'inch') {
    headersHTML = '<th>INCH</th>';
  } else if (unitDisplayMode === 'none') {
     // No headers for 'none' mode as requested
     headersHTML = ''; 
  } else {
    // both or default
    headersHTML = '<th>CM</th><th>INCH</th>';
  }

  tooltip.innerHTML = `
      <div class="pify_tooltip_title">${sizeValue}</div>
      <table class="pify_tooltip_table">
        ${unitDisplayMode === 'none' ? '' : `
        <thead>
          <tr>
            <th></th>
            ${headersHTML}
          </tr>
        </thead>
        `}
        <tbody>
          ${rowsHTML}
        </tbody>
      </table>
    `;
  
  // Add basic table styles inline to ensure they work immediately
  const style = document.createElement('style');
  style.textContent = `
    .pify_tooltip_table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 5px;
      font-size: 12px;
    }
    .pify_tooltip_table th, .pify_tooltip_table td {
      padding: 4px 8px;
      text-align: center;
      border: 1px solid rgba(255,255,255,0.2);
    }
    .pify_tooltip_table th:first-child, .pify_tooltip_table td:first-child {
      text-align: left;
      font-weight: bold;
    }
    .pify_tooltip_table th {
      background-color: rgba(0,0,0,0.1);
    }
  `;
  tooltip.appendChild(style);

  return tooltip;
}

// Helper function to set parent element overflow to unset for tooltip visibility
function setTooltipParentOverflow(tooltipElement) {
  if (tooltipElement && tooltipElement.parentElement) {
    tooltipElement.parentElement.style.overflow = 'unset';
  }
}

/**
 * Update the size details table and unit controls.
 * @param {string} sizeValue - Selected size key used to lookup measurements in `sizeInfo`.
 * @param {Object<string, Object>} sizeInfo - Normalized size chart data (sizes -> measurements) plus metadata
 *        such as `_unit`, `_sizeOrder`, `_headers`, `_isTextTable`, `_unitDisplayMode`.
 * @param {HTMLElement} selectedSizeDetails - Target container element (`.pify_size_details_container`) where
 *        the size details table and unit controls are rendered.
 */
function updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails) {
  // Add null check to prevent errors when selectedSizeDetails is null
  if (!selectedSizeDetails) {
    return;
  }

  // Use helper to get data, defaulting to 'cm' or existing structure to check existence
  // We'll determine the real unit later for rendering
  const checkData = getSizeChartRowData(sizeValue, sizeInfo, 'cm');

  if (checkData) {
    selectedSizeDetails.style.display = 'block';
    
    const originalUnit = sizeInfo._unit || 'cm';
    const isTextTable = sizeInfo._isTextTable || false;
    
    // Determine current unit early so we can fetch correct data
    const unitDisplayMode = sizeInfo?._unitDisplayMode;
    const fallbackUnit = computeInitialUnit(unitDisplayMode, originalUnit);
    
    // Check global preference first (session persistence), then dataset, then fallback
    let currentUnit = fallbackUnit;
    if (window.pifyCurrentUnit && (unitDisplayMode === 'both' || unitDisplayMode === window.pifyCurrentUnit)) {
       currentUnit = window.pifyCurrentUnit;
    } else if (selectedSizeDetails.dataset.currentUnit) {
       currentUnit = selectedSizeDetails.dataset.currentUnit;
    }
    
    // Ensure currentUnit matches one of the allowed units if not 'both'
    if (unitDisplayMode === 'cm') currentUnit = 'cm';
    if (unitDisplayMode === 'inch') currentUnit = 'inch';
    
    // Always render with currentUnit to ensure we display the correct data immediately
    // Since we now have precomputed data (even for legacy), this is safe and accurate
    const renderUnit = currentUnit;
    
    // Get data for the render unit
    const currentSizeData = getSizeChartRowData(sizeValue, sizeInfo, renderUnit);
    const measurements = Object.keys(currentSizeData);
    const values = Object.values(currentSizeData);

    // Use sizeOrder array if available, otherwise fallback to Object.keys
    const sizeOrder = sizeInfo._sizeOrder || Object.keys(sizeInfo).filter(key =>
      key !== '_unit' && key !== '_sizeOrder' && typeof sizeInfo[key] === 'object' && sizeInfo[key] !== null
    );

    const currentIndex = sizeOrder.indexOf(sizeValue);
    const prevSize = currentIndex > 0 ? sizeOrder[currentIndex - 1] : null;
    const nextSize = currentIndex < sizeOrder.length - 1 ? sizeOrder[currentIndex + 1] : null;
    
    const prevSizeData = prevSize ? getSizeChartRowData(prevSize, sizeInfo, renderUnit) : null;
    const nextSizeData = nextSize ? getSizeChartRowData(nextSize, sizeInfo, renderUnit) : null;

    const radioGroupName = `size_details_unit_${Math.random().toString(36).substr(2, 9)}`;

    // Set the original unit in dataset to the currently rendered unit
    selectedSizeDetails.dataset.originalUnit = renderUnit;
    delete selectedSizeDetails.dataset.originalData; // Clear previous cached data

    // Pass precomputed data to dataset
    if (sizeInfo._hasPrecomputedData) {
      selectedSizeDetails.dataset.hasPrecomputedData = 'true';
      selectedSizeDetails.dataset.tableDataCM = JSON.stringify(sizeInfo._tableDataCM);
      selectedSizeDetails.dataset.tableDataINCH = JSON.stringify(sizeInfo._tableDataINCH);
      selectedSizeDetails.dataset.tableHeaders = JSON.stringify(sizeInfo._headers);
    } else if (sizeInfo._legacyOriginalDataCM && originalUnit === 'inch') {
      // Pass legacy CM data to dataset for accurate conversion
      selectedSizeDetails.dataset.hasLegacyData = 'true';
      selectedSizeDetails.dataset.legacyDataCM = JSON.stringify(sizeInfo._legacyOriginalDataCM);
      selectedSizeDetails.dataset.tableHeaders = JSON.stringify(sizeInfo._headers);
    }

    // For text tables, render without unit selector
    if (isTextTable) {
      let firstHeader = sizeInfo._headers ? sizeInfo._headers[0] : 'Size';
      // Remove trailing asterisk
      if (firstHeader.endsWith('*')) firstHeader = firstHeader.slice(0, -1);

      selectedSizeDetails.innerHTML = `
        <div class="size-details-content" tabindex="0" role="region" aria-label="Size details">
          <table class="size-details-table">
            <tr>
              <th>${firstHeader}</th>
              ${measurements.map(measurement => {
                const headerText = measurement.endsWith('*') ? measurement.slice(0, -1) : measurement;
                return `<th>${headerText}</th>`;
              }).join('')}
            </tr>
            ${prevSize && prevSizeData ? `
                <tr>
                  <td>${prevSize}</td>
                  ${measurements.map(measurement => `<td>${prevSizeData[measurement] || '-'}</td>`).join('')}
                </tr>
              ` : ''}
            <tr class="selected-size-row">
              <td>${sizeValue}</td>
              ${values.map(value => `<td>${value || '-'}</td>`).join('')}
            </tr>
            ${nextSize && nextSizeData ? `
                <tr>
                  <td>${nextSize}</td>
                  ${measurements.map(measurement => `<td>${nextSizeData[measurement] || '-'}</td>`).join('')}
                </tr>
              ` : ''}
          </table>
        </div>
      `;
    } else {
      // Build unit controls based on display mode (reused helpers)
      const { cmText, inchText } = getUnitTexts();
      // currentUnit is already calculated above
      selectedSizeDetails.dataset.currentUnit = currentUnit;
      
      // Fix: Use currentUnit instead of originalUnit/fallbackUnit for rendering unit controls
      // This ensures the correct radio button is checked based on currentUnit state
      const unitControlsHTML = buildSizeDetailsUnitControlsHTML(unitDisplayMode, radioGroupName, currentUnit, cmText, inchText);

      selectedSizeDetails.innerHTML = `
        <div class="size-details-content" tabindex="0" role="region" aria-label="Size details">
          <table class="size-details-table">
            <tr>
              ${unitControlsHTML}
              ${measurements.map(measurement => {
                const headerText = measurement.endsWith('*') ? measurement.slice(0, -1) : measurement;
                return `<th>${headerText}</th>`;
              }).join('')}
            </tr>
          ${prevSize && prevSizeData ? `
              <tr>
                <td>${prevSize}</td>
                ${measurements.map(measurement => `<td>${prevSizeData[measurement] || '-'}</td>`).join('')}
              </tr>
            ` : ''}
          <tr class="selected-size-row">
            <td>${sizeValue}</td>
            ${values.map(value => `<td>${value}</td>`).join('')}
          </tr>
          ${nextSize && nextSizeData ? `
              <tr>
                <td>${nextSize}</td>
                ${measurements.map(measurement => `<td>${nextSizeData[measurement] || '-'}</td>`).join('')}
              </tr>
            ` : ''}
        </table>
        </div >
      `;

      if (unitDisplayMode !== 'none') {
        const table = selectedSizeDetails.querySelector('.size-details-table');
        cacheTableOriginalData(table, selectedSizeDetails);
        // We rendered with currentUnit, so no conversion needed initially
      }

      // Bind events only when both units are available
      if (unitDisplayMode === 'both') {
        const unitControls = selectedSizeDetails.querySelectorAll('.pify_unit_label.size-details-unit');
        const cu = selectedSizeDetails.dataset.currentUnit || originalUnit;
        unitControls.forEach(ctrl => {
          const isActive = (ctrl.dataset.unit === cu);
          ctrl.setAttribute('aria-checked', isActive ? 'true' : 'false');
          ctrl.onclick = function () { handleSizeDetailsUnitChange(this, this.dataset.unit); };
        });
      }
    }
  } else {
    // Add null check before accessing style property
    if (selectedSizeDetails) {
      selectedSizeDetails.style.display = 'none';
    }
  }
}

function handleSizeDetailsUnitChange(control, newUnit) {
  const unitContainer = control.closest('.size-details-unit-container');
  const allControls = unitContainer.querySelectorAll('.pify_unit_label.size-details-unit');
  allControls.forEach(el => el.setAttribute('aria-checked', 'false'));
  control.setAttribute('aria-checked', 'true');

  const sizeDetailsContent = control.closest('.pify_size_details_container');
  const table = sizeDetailsContent.querySelector('.size-details-table');
  sizeDetailsContent.dataset.currentUnit = newUnit;
  // storeUnitPreference(newUnit);
  // Persist unit selection for the current session to handle DOM re-renders
  window.pifyCurrentUnit = newUnit;

  // Check for precomputed data
  if (sizeDetailsContent.dataset.hasPrecomputedData === 'true') {
    const targetDataKey = newUnit === 'inch' ? 'tableDataINCH' : 'tableDataCM';
    const targetDataStr = sizeDetailsContent.dataset[targetDataKey];
    const headersStr = sizeDetailsContent.dataset.tableHeaders;

    if (targetDataStr && headersStr) {
      const targetData = JSON.parse(targetDataStr);
      const headers = JSON.parse(headersStr);
      const rows = table.querySelectorAll('tbody tr, tr:not(:first-child)');

      rows.forEach(row => {
        const cells = row.querySelectorAll('td');
        if (cells.length > 0) {
          const sizeName = cells[0].textContent.trim();
          const sizeKey = headers[0];
          // Find the row in targetData that matches the size name
          const matchedRowData = targetData.find(d => String(d[sizeKey]).trim() === sizeName);

          if (matchedRowData) {
            cells.forEach((cell, index) => {
              if (index > 0) {
                const header = headers[index];
                const key = Object.keys(matchedRowData).find(k => k === header);
                const value = key ? matchedRowData[key] : '-';
                cell.textContent = value;
              }
            });
          }
        }
      });
      return;
    }
  }

  // Check for legacy data (CM data stored separately when unit is INCH)
  if (sizeDetailsContent.dataset.hasLegacyData === 'true' && newUnit === 'cm') {
      const legacyDataStr = sizeDetailsContent.dataset.legacyDataCM;
      const headersStr = sizeDetailsContent.dataset.tableHeaders;
      
      if (legacyDataStr && headersStr) {
        const legacyData = JSON.parse(legacyDataStr);
        const headers = JSON.parse(headersStr);
        const rows = table.querySelectorAll('tbody tr, tr:not(:first-child)');
        
        rows.forEach(row => {
          const cells = row.querySelectorAll('td');
          if (cells.length > 0) {
            const sizeName = cells[0].textContent.trim();
            const rowData = legacyData[sizeName];
            
            if (rowData) {
               cells.forEach((cell, index) => {
                if (index > 0) {
                  const header = headers[index];
                  const value = rowData[header] || '-';
                  cell.textContent = value;
                }
               });
            }
          }
        });
        return;
      }
  }

  // Get the original unit from dataset (set in updateSizeDetails function)
  const originalUnit = sizeDetailsContent.dataset.originalUnit || 'cm';

  // If no original data cached, cache the current data (only for data rows, skip header)
  if (!sizeDetailsContent.dataset.originalData) {
    const originalData = [];
    const rows = table.querySelectorAll('tbody tr, tr:not(:first-child)'); // Skip header row
    rows.forEach(row => {
      const rowData = [];
      const cells = row.querySelectorAll('td');
      cells.forEach((cell, index) => {
        if (index > 0 && cell.textContent !== '-') {
          // Store the original text content (including range values like "99-100")
          rowData.push(cell.textContent.trim());
        } else {
          rowData.push(cell.textContent);
        }
      });
      originalData.push(rowData);
    });
    sizeDetailsContent.dataset.originalData = JSON.stringify(originalData);
  }

  const originalData = JSON.parse(sizeDetailsContent.dataset.originalData);

  const rows = table.querySelectorAll('tbody tr, tr:not(:first-child)'); // Skip header row
  rows.forEach((row, rowIndex) => {
    const cells = row.querySelectorAll('td');
    cells.forEach((cell, index) => {
      if (index > 0 && cell.textContent !== '-') {
        if (originalData[rowIndex] && originalData[rowIndex][index] !== undefined) {
          const originalValue = originalData[rowIndex][index];
          // Use convertRangeValue to handle both single values and range values
          const convertedValue = convertRangeValue(originalValue, originalUnit, newUnit);
          cell.textContent = convertedValue;
        }
      }
    });
  });
}

function handleLiSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  // handleLiSizeSelector called
  
  const pickerItems = selector.querySelectorAll('.product-option-picker__list-item');
  // Found picker items
  
  pickerItems.forEach((item, index) => {
    // Processing item
    
    if (item.dataset.pifyProcessed === 'true') {
      // Item already processed, skipping
      return;
    }
    item.dataset.pifyProcessed = 'true';

    let sizeValue = item.getAttribute('data-option-value') || '';
    // Initial sizeValue from data-option-value
    
    if (!sizeValue) {
      const valueSpan = item.querySelector('.product-option-label__value');
      // Looking for .product-option-label__value
      if (valueSpan) {
        sizeValue = valueSpan.textContent.trim();
        // sizeValue from span text
      }
    }
    
    // Final sizeValue check
    
    if (!sizeValue || !sizeInfo[sizeValue]) {
      // Size value not found or no size info, collecting exception
      exceptionCollector.collect(
        'The corresponding size information was not found',
        `The size value "${sizeValue}" could not be obtained or the corresponding size information was not found. Available sizes: ${Object.keys(sizeInfo).join(', ')}`
      );
      return;
    }

    const labelDiv = item.querySelector('.product-option-label');
    // Found labelDiv
    
    if (!labelDiv) {
      // No .product-option-label found, skipping tooltip creation
      return;
    }

    const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
    // Created tooltip
    
    labelDiv.appendChild(tooltip);
    // setTooltipParentOverflow(tooltip);
    // Tooltip appended to labelDiv

    labelDiv.addEventListener('mouseenter', () => {
      // Mouse entered labelDiv
      if (tooltip) {
        tooltip.style.setProperty('opacity', '1', 'important');
        tooltip.style.setProperty('visibility', 'visible', 'important');
        tooltip.style.setProperty('display', 'block', 'important');
      }
      // Tooltip styles set to visible
    });
    
    labelDiv.addEventListener('mouseleave', () => {
      // Mouse left labelDiv
      if (tooltip) {
        tooltip.style.setProperty('opacity', '0', 'important');
      }
      // Tooltip opacity set to 0
    });

    item.addEventListener('click', () => {
      // Item clicked
      updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
    });

    if (item.classList.contains('chosen')) {
      // Item is chosen, updating size details
      updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
    }
    
    // Completed processing item
  });
}

function findProductContainer() {
  // Array of selectors sorted by priority
  const selectors = [
    '.globo-swatch-product-detail', // Globo App container
    '[id^="ProductInfo-template"]',
    '[class^="m6pr-template"][class*="main-product"]',
    '.product-main',
    '.product__info',
    '.product__info-wrapper',
    '.product-info__blocks',
    '.product-details-wrapper',
    '.main-product--form',
    '.variant-selects',
    '.Product__MiddleLeft',
    '.ProductSummary',
    '.Product__Block',
    '.content-for-layout',
    '.product',
    '[class="#product-media"]',
    '.product-price',
    '.tt-product-single-info',
    '.base-font'
  ];

  // Find the first matching element
  for (const selector of selectors) {
    const element = document.querySelector(selector);
    if (element) return element;
  }

  return null;
}

function observeSizeSelectorChanges() {
  // Listen to the product main container
  const productMain = findProductContainer();
  if (!productMain) return;

  let observer = new MutationObserver(() => {
    addSizeSelectorTooltip();
  });

  observer.observe(productMain, {
    childList: true,
    subtree: true
  });

  // Special handling for Galleria theme, listen for body changes
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
  const specialObserveThemes = ['galleria', 'multi', 'stretch', 'next', 'xclusive', 'xtra', 'tailor', 'satoshi', 'amber', 'marble', 'eclipse', 'handy'];
  if (specialObserveThemes.includes(themeName)) {
    let bodyObserverTimeout = null;
    let bodyObserver = new MutationObserver((mutations) => {
      
      // Debounce to avoid excessive calls
      if (bodyObserverTimeout) {
        clearTimeout(bodyObserverTimeout);
      }
      
      bodyObserverTimeout = setTimeout(() => {
        // If it is a pure floating button, do not add inline button
        const buttonType = window.settings?.buttonType || 'inline';
        if (buttonType === 'floating') {
          return;
        }

        const sizeChartButton = document.querySelector('.pify_inline_button');
        if (!sizeChartButton || sizeChartButton.offsetParent === null) {
          addCustomButtons();
        }
      }, 300); // 300ms debounce
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

{
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
  const skipObserveThemes = new Set(['xtra']);
  const shouldObserve = !skipObserveThemes.has(themeName);
  if (shouldObserve) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeSizeSelectorChanges);
    } else {
      observeSizeSelectorChanges();
    }
  }
}

// Add a function for handling button-style size selectors
function handleButtonSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Support multiple theme button selectors
  let buttonSelectors = ['.optionBtns', '.product__chip', '.product-form__chip', '.product__color-chips'];

  let buttons = [];
  for (const btnSelector of buttonSelectors) {
    const foundButtons = selector.querySelectorAll(btnSelector);
    if (foundButtons.length > 0) {
      buttons = foundButtons;
      break;
    }
  }

  // Special handling for Lorenza theme - position size details after product-form__chip-wrapper
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
  if (themeName === 'lorenza') {
    const chipWrapper = document.querySelector('.product-form__chip-wrapper');
    if (chipWrapper) {
      // Remove existing size details container if it exists
      if (selectedSizeDetails.parentNode) {
        selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
      }
      // Insert size details container after the chip wrapper
      chipWrapper.parentNode.insertBefore(selectedSizeDetails, chipWrapper.nextSibling);
    }
  }

  buttons.forEach(button => {
    if (button.dataset.pifyProcessed === 'true') return;
    button.dataset.pifyProcessed = 'true';

    const sizeValue = button.getAttribute('data-option-value') ||
      button.getAttribute('data-value') ||
      button.textContent.trim();

    if (!sizeValue) return;

    const buttonStyle = window.getComputedStyle(button);
    if (buttonStyle.position === 'static') {
      button.style.position = 'relative';
    }

    if (sizeInfo[sizeValue]) {
      const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
      button.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      button.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });

      button.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    button.addEventListener('click', () => {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    const isActive = button.classList.contains('btnActive') ||
      button.classList.contains('active') ||
      button.classList.contains('selected') ||
      button.classList.contains('product-form__chip selected');
    button.dataset.selected === 'true';

    if (isActive) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

// Add a function for handling Andaman theme
function handleAndamanSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const swatches = selector.querySelectorAll('a.swatch');
  swatches.forEach(swatch => {
    if (swatch.dataset.pifyProcessed === 'true') return;
    swatch.dataset.pifyProcessed = 'true';

    const sizeValue = swatch.getAttribute('value');
    if (!sizeValue) return;

    // Convert the value to uppercase to match size chart data
    const uppercaseSizeValue = sizeValue.toUpperCase();

    // Ensure swatch has the correct positioning
    const swatchStyle = window.getComputedStyle(swatch);
    if (swatchStyle.position === 'static') {
      swatch.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (sizeInfo[uppercaseSizeValue]) {
      const tooltip = createSmartSizeTooltip(uppercaseSizeValue, sizeInfo);
      swatch.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      swatch.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });

      swatch.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    swatch.addEventListener('click', () => {
      if (sizeInfo[uppercaseSizeValue]) {
        updateSizeDetails(uppercaseSizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    if (swatch.classList.contains('selected')) {
      if (sizeInfo[uppercaseSizeValue]) {
        updateSizeDetails(uppercaseSizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

// Add a function for handling chip-style size selectors
function handleChipSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Get all chip-style selector labels
  const chipLabels = selector.querySelectorAll('.variant-option--chips');
  if (!chipLabels.length) {
    return;
  }

  // Save size value mapping
  const sizeValueMap = new Map();

  chipLabels.forEach(label => {
    if (label.dataset.pifyProcessed === 'true') return;
    label.dataset.pifyProcessed = 'true';

    const radio = label.querySelector('input[type="radio"]');
    const button = label.querySelector('button.chip');
    if (!radio || !button) return;

    // Get size value - prioritize aria-label attribute
    const sizeValue = button.getAttribute('aria-label') || button.textContent.trim();
    if (!sizeValue) return;

    // Save size value mapping - use radio ID as key, size value as value
    sizeValueMap.set(radio.id, sizeValue);

    const buttonStyle = window.getComputedStyle(button);
    if (buttonStyle.position === 'static') {
      button.style.position = 'relative';
    }

    if (sizeInfo[sizeValue]) {
      const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
      button.appendChild(tooltip);

      const handleMouseEnter = () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      button.removeEventListener('mouseenter', handleMouseEnter);
      button.removeEventListener('mouseleave', handleMouseLeave);

      button.addEventListener('mouseenter', handleMouseEnter);
      button.addEventListener('mouseleave', handleMouseLeave);

      button.addEventListener('click', () => {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      });
    }

    const handleChange = () => {
      if (radio.checked && sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      }
    };

    radio.removeEventListener('change', handleChange);
    radio.addEventListener('change', handleChange);
  });

  const defaultSelectedRadio = selector.querySelector('input[type="radio"]:checked');
  if (defaultSelectedRadio) {
    const selectedSizeValue = sizeValueMap.get(defaultSelectedRadio.id);
    if (selectedSizeValue && sizeInfo[selectedSizeValue]) {
      updateSizeDetails(selectedSizeValue, sizeInfo, selectedSizeDetails);
    }
  }
}

// Add functions for handling pill-style selectors
function handlePillSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const pillLabels = selector.querySelectorAll('.pill');
  if (!pillLabels.length) {
    return;
  }

  const sizeValueMap = new Map();

  pillLabels.forEach(label => {
    if (label.dataset.pifyProcessed === 'true') return;
    label.dataset.pifyProcessed = 'true';

    const pillLabelEl = label.querySelector('.pill__label');
    if (!pillLabelEl) return;

    const sizeValue = pillLabelEl.textContent.trim();
    if (!sizeValue) return;

    const inputId = label.getAttribute('for');
    if (inputId) {
      sizeValueMap.set(inputId, sizeValue);
    }

    const labelStyle = window.getComputedStyle(label);
    if (labelStyle.position === 'static') {
      label.style.position = 'relative';
    }

    if (sizeInfo[sizeValue]) {
      const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
      label.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      const handleMouseEnter = () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      label.removeEventListener('mouseenter', handleMouseEnter);
      label.removeEventListener('mouseleave', handleMouseLeave);

      label.addEventListener('mouseenter', handleMouseEnter);
      label.addEventListener('mouseleave', handleMouseLeave);
    }

    const handleClick = () => {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      }
    };

    label.removeEventListener('click', handleClick);
    label.addEventListener('click', handleClick);
  });

  const defaultSelectedPill = selector.querySelector('.pill.selected');
  if (defaultSelectedPill) {
    const pillLabelEl = defaultSelectedPill.querySelector('.pill__label');
    if (pillLabelEl) {
      const selectedSizeValue = pillLabelEl.textContent.trim();
      if (selectedSizeValue && sizeInfo[selectedSizeValue]) {
        updateSizeDetails(selectedSizeValue, sizeInfo, selectedSizeDetails);
      }
    }
  }
}

// Add a function for handling clickyboxes with the Showcase theme
function handleClickyboxesSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const sizeLinks = selector.querySelectorAll('li a');
  if (!sizeLinks.length) {
    return;
  }

  sizeLinks.forEach(link => {
    if (link.dataset.pifyProcessed === 'true') return;
    link.dataset.pifyProcessed = 'true';

    const sizeValue = link.getAttribute('data-value');
    if (!sizeValue) return;

    const linkStyle = window.getComputedStyle(link);
    if (linkStyle.position === 'static') {
      link.style.position = 'relative';
    }

    if (sizeInfo[sizeValue]) {
      const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
      link.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      link.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });

      link.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    link.addEventListener('click', (e) => {
      e.preventDefault();

      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }

      sizeLinks.forEach(l => l.classList.remove('active'));
      link.classList.add('active');
    });
  });

  const activeLink = selector.querySelector('a.active');
  if (activeLink) {
    const selectedValue = activeLink.getAttribute('data-value');
    if (selectedValue && sizeInfo[selectedValue]) {
      updateSizeDetails(selectedValue, sizeInfo, selectedSizeDetails);
    }
  }
}

function handleXtraSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const listItems = selector.querySelectorAll('li');


  listItems.forEach(item => {
    const radio = item.querySelector('input[type="radio"]');
    const label = item.querySelector('label');

    if (!radio || !label) return;

    // Get size value - extract size part from title (e.g. "Default / M" -> "M")
    const titleParts = radio.getAttribute('title').split('/');
    const sizeValue = titleParts.length > 1 ? titleParts[1].trim() : '';

    if (!sizeValue || !sizeInfo[sizeValue]) return;

    label.style.position = 'relative';

    const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
    label.appendChild(tooltip);
    // setTooltipParentOverflow(tooltip);

    label.addEventListener('mouseenter', () => {
      tooltip.style.setProperty('opacity', '1', 'important');
    });

    label.addEventListener('mouseleave', () => {
      tooltip.style.setProperty('opacity', '0', 'important');
    });

    radio.addEventListener('change', () => {
      updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
    });

    if (radio.checked) {
      updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
    }
  });
}

function handleCustomDropdownSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  let dropdownContainer = null;
  let button = null;
  let listbox = null;

  if (selector.tagName === 'BUTTON') {
    button = selector;
    dropdownContainer = button.closest('.variant-dropdown');
  } else if (selector.tagName === 'UL' && selector.getAttribute('role') === 'listbox') {
    listbox = selector;
    const listboxId = listbox.id;
    if (listboxId) {
      const buttonId = listboxId.replace('-dropdown', '');
      button = document.getElementById(buttonId);
    }
    dropdownContainer = listbox.closest('.variant-dropdown');
  } else if (selector.classList.contains('variant-dropdown')) {
    dropdownContainer = selector;
    button = dropdownContainer.querySelector('button[id*="SingleOptionSelector"]');
    listbox = dropdownContainer.querySelector('ul[role="listbox"]');
  }

  if (!dropdownContainer || !button) {
    return;
  }

  if (!listbox && button.id) {
    const listboxId = button.id + '-dropdown';
    listbox = document.getElementById(listboxId);
  }

  if (!listbox) {
    return;
  }

  const sizeOptions = listbox.querySelectorAll('li[data-option-name="Size"], li[data-option-value]');
  if (!sizeOptions.length) {
    return;
  }

  const buttonParent = button.parentNode;
  if (window.getComputedStyle(buttonParent).position === 'static') {
    buttonParent.style.position = 'relative';
  }

  // Create tooltip only if showTooltip is enabled
  const showTooltip = window.settings?.primaryInteractiveColor?.showTooltip !== false;
  let tooltip = null;
  if (showTooltip) {
    tooltip = document.createElement('div');
    tooltip.className = 'pify_size_tooltip';
    tooltip.style.opacity = '0';
    tooltip.style.display = 'none';
    buttonParent.appendChild(tooltip);
    // setTooltipParentOverflow(tooltip);
  }

  const selectorContainer = dropdownContainer || buttonParent;

  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  if (selectorContainer && selectorContainer.parentNode) {
    selectorContainer.parentNode.insertBefore(selectedSizeDetails, selectorContainer.nextSibling);
  }

  const updateTooltipContent = (sizeValue) => {
    if (tooltip && sizeInfo[sizeValue]) {
      tooltip.innerHTML = `
        <div class="pify_tooltip_title">${sizeValue}</div>
        ${Object.entries(sizeInfo[sizeValue])
          .map(([measurement, value]) => `<div class="pify_tooltip_row">${measurement.endsWith('*') ? measurement.slice(0, -1) : measurement}: ${value}</div>`)
          .join('')}
      `;
      tooltip.style.display = 'block';
    } else if (tooltip) {
      tooltip.style.display = 'none';
    }
  };

  const handleOptionClick = (sizeValue) => {
    if (sizeValue && sizeInfo[sizeValue]) {
      updateTooltipContent(sizeValue);
      updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
    }
  };

  const selectedSpan = button.querySelector('[data-selected-option]');
  const currentValue = selectedSpan ? selectedSpan.textContent.trim() : '';

  if (currentValue && sizeInfo[currentValue]) {
    updateTooltipContent(currentValue);
    updateSizeDetails(currentValue, sizeInfo, selectedSizeDetails);
  }

  button.addEventListener('mouseenter', () => {
    const currentValue = button.querySelector('[data-selected-option]')?.textContent.trim();
    if (tooltip && currentValue && sizeInfo[currentValue]) {
      tooltip.style.setProperty('opacity', '1', 'important');
    }
  });

  button.addEventListener('mouseleave', () => {
    if (tooltip) {
      tooltip.style.setProperty('opacity', '0', 'important');
    }
  });

  // Listen for click events on the options
  sizeOptions.forEach(option => {
    option.addEventListener('click', () => {
      const sizeValue = option.getAttribute('data-option-value');
      handleOptionClick(sizeValue);
    });
  });

  // Listen for click events on the entire list (capturing bubbles)
  listbox.addEventListener('click', (e) => {
    const clickedOption = e.target.closest('li[data-option-value]');
    if (clickedOption) {
      const sizeValue = clickedOption.getAttribute('data-option-value');
      handleOptionClick(sizeValue);
    }
  });

  // Use MutationObserver to listen for button content changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        const selectedText = button.querySelector('[data-selected-option]')?.textContent.trim();
        if (selectedText && sizeInfo[selectedText]) {
          updateTooltipContent(selectedText);
          updateSizeDetails(selectedText, sizeInfo, selectedSizeDetails);
        }
      }
    });
  });

  observer.observe(button, { childList: true, subtree: true, attributes: true });
}

// Add function to handle XO theme custom dropdown
function handleXoFieldSelectCustom(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Get all radio button labels
  const labels = selector.querySelectorAll('.xo-field-select-custom__check');
  if (!labels.length) {
    return;
  }

  // Ensure the size details container is correctly positioned in the DOM
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Find suitable parent container to insert size details
  const parentContainer = selector.closest('.xo-product-form__options') ||
    selector.closest('.xo-product-form__field') ||
    selector.parentElement;

  if (parentContainer) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    // Fallback - insert after the original selector
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  labels.forEach(label => {
    if (label.dataset.pifyProcessed === 'true') return;
    label.dataset.pifyProcessed = 'true';

    const radio = label.querySelector('input[type="radio"]');
    const labelSpan = label.querySelector('.xo-field-select-custom__label');

    if (!radio || !labelSpan) return;

    const sizeValue = labelSpan.textContent.trim();
    if (!sizeValue) return;

    const labelStyle = window.getComputedStyle(label);
    if (labelStyle.position === 'static') {
      label.style.position = 'relative';
    }

    if (sizeInfo[sizeValue]) {
      const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
      label.appendChild(tooltip);

      const iconSpan = label.querySelector('.xo-field-select-custom__icon');
      const elementsToWatch = [label, iconSpan, labelSpan].filter(Boolean);

      elementsToWatch.forEach(element => {
        element.addEventListener('mouseenter', () => {
          tooltip.style.setProperty('opacity', '1', 'important');
        });

        element.addEventListener('mouseleave', () => {
          tooltip.style.setProperty('opacity', '0', 'important');
        });
      });
    }

    const handleChange = () => {
      if (radio.checked && sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else if (radio.checked && !sizeInfo[sizeValue]) {
        selectedSizeDetails.style.display = 'none';
      }
    };

    radio.addEventListener('change', handleChange);

    const iconSpan = label.querySelector('.xo-field-select-custom__icon');
    if (iconSpan) {
      iconSpan.addEventListener('click', () => {
        if (!radio.checked) {
          radio.checked = true;
          if (sizeInfo[sizeValue]) {
            updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
          }
        }
      });
    }
  });

  const defaultSelectedRadio = selector.querySelector('input[type="radio"]:checked');
  if (defaultSelectedRadio) {
    const label = defaultSelectedRadio.closest('.xo-field-select-custom__check');
    const labelSpan = label?.querySelector('.xo-field-select-custom__label');

    if (labelSpan) {
      const selectedSizeValue = labelSpan.textContent.trim();
      if (selectedSizeValue && sizeInfo[selectedSizeValue]) {
        updateSizeDetails(selectedSizeValue, sizeInfo, selectedSizeDetails);
      }
    }
  }

  if (window.getComputedStyle(selector).position === 'fixed') {
    selector.style.overflow = 'visible';
    selector.style.zIndex = '9999';
  }
}

function handleKallesSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const items = selector.querySelectorAll('.t4s-swatch__item');
  items.forEach(item => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    const sizeValue = item.getAttribute('data-value') || item.textContent.trim();
    if (!sizeValue) return;

    if (sizeInfo[sizeValue]) {
      const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
      item.style.position = 'relative';
      item.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      // Show tooltip when mouse enters size item
      item.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
        tooltip.style.setProperty('visibility', 'visible', 'important');
        tooltip.style.setProperty('display', 'block', 'important');
      });
      
      // When mouse leaves size item, check if moved to tooltip
      item.addEventListener('mouseleave', (e) => {
        // Check if mouse moved to tooltip
        const toElement = e.relatedTarget;
        if (tooltip.contains(toElement) || tooltip === toElement) {
          // If moved to tooltip, keep showing
          return;
        }
        // Otherwise hide tooltip
        setTimeout(() => {
          // Check again if mouse is on tooltip to avoid hiding during delay
          if (!tooltip.matches(':hover')) {
            tooltip.style.setProperty('opacity', '0', 'important');
          }
        }, 100);
      });
      
      // Add mouse leave event for tooltip
      tooltip.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    item.addEventListener('click', () => {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    if (item.classList.contains('is--selected')) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

function handleBeeSwatchSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const items = selector.querySelectorAll('.bee-swatch__item');
  items.forEach(item => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    const sizeValue = item.getAttribute('data-value') || item.textContent.trim();
    if (!sizeValue) return;

    if (sizeInfo[sizeValue]) {
      const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
      item.style.position = 'relative';
      item.appendChild(tooltip);

      // Show tooltip when mouse enters size item
      item.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
        tooltip.style.setProperty('visibility', 'visible', 'important');
        // tooltip.style.setProperty('display', 'block', 'important');
      });
      
      // When mouse leaves size item, check if moved to tooltip
      item.addEventListener('mouseleave', (e) => {
        // Check if mouse moved to tooltip
        const toElement = e.relatedTarget;
        if (tooltip.contains(toElement) || tooltip === toElement) {
          // If moved to tooltip, keep showing
          return;
        }
        
        // Add brief delay to avoid tooltip flickering
        setTimeout(() => {
          // Check again if mouse is on tooltip
          if (tooltip.matches(':hover')) {
            return;
          }
          // Otherwise hide tooltip
          tooltip.style.setProperty('opacity', '0', 'important');
        }, 100);
      });
      
      // Add mouse leave event for tooltip
      tooltip.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    item.addEventListener('click', () => {
      // Remove active class from all items
      items.forEach(i => i.classList.remove('active'));
      
      // Add active class to clicked item
      item.classList.add('active');
      
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    // Check if this item is initially active
    if (item.classList.contains('active')) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

function handleShellaSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  const sizeSection = document.querySelector('.product-options__section[data-property="size"]');
  if (sizeSection && sizeSection.parentNode) {
    sizeSection.parentNode.insertBefore(selectedSizeDetails, sizeSection.nextSibling);
  } else {
    const parentContainer = selector.closest('.product-options__section') || selector.parentElement;
    if (parentContainer && parentContainer.parentNode) {
      parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
    }
  }

  const valueDivs = selector.querySelectorAll('.product-options__value[data-value]');
  valueDivs.forEach(div => {
    if (div.dataset.pifyProcessed === 'true') return;
    div.dataset.pifyProcessed = 'true';

    const sizeValue = div.getAttribute('data-value');
    if (!sizeValue) return;

    if (sizeInfo[sizeValue.toUpperCase()] || sizeInfo[sizeValue]) {
      const key = sizeInfo[sizeValue] ? sizeValue : sizeValue.toUpperCase();
      const tooltip = createSmartSizeTooltip(key, sizeInfo);
      div.style.position = 'relative';
      div.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      div.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });
      div.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    if (div.classList.contains('active')) {
      const key = sizeInfo[sizeValue] ? sizeValue : sizeValue.toUpperCase();
      if (sizeInfo[key]) {
        updateSizeDetails(key, sizeInfo, selectedSizeDetails);
      }
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('product-options__value') && target.classList.contains('active')) {
          const sizeValue = target.getAttribute('data-value');
          if (sizeValue) {
            const key = sizeInfo[sizeValue] ? sizeValue : sizeValue.toUpperCase();
            if (sizeInfo[key]) {
              updateSizeDetails(key, sizeInfo, selectedSizeDetails);
            } else {
              selectedSizeDetails.style.display = 'none';
            }
          }
        }
      }
    });
  });

  valueDivs.forEach(div => {
    observer.observe(div, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
}

function handleUminoSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const swatches = selector.querySelectorAll('.bls__option-swatch');
  swatches.forEach(swatch => {
    if (swatch.dataset.pifyProcessed === 'true') return;
    swatch.dataset.pifyProcessed = 'true';

    const sizeValue = swatch.getAttribute('data-value');
    if (!sizeValue) return;

    if (sizeInfo[sizeValue]) {
      const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
      swatch.style.position = 'relative';
      swatch.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      swatch.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });
      swatch.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    swatch.addEventListener('click', () => {
      swatches.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    if (swatch.classList.contains('active')) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

// Helper function to fix size details container position for specific themes
function fixSizeDetailsPosition(themeName, selector, sizeInfo, existingSizeDetails) {
  const detailsContainer = document.querySelector('.pify_size_details_container');
  if (!detailsContainer) return;

  const datasetKey = `${themeName.replace(/\s+/g, '')}Fixed`;
  if (detailsContainer.dataset[datasetKey]) return;

  let targetContainer = null;

  switch (themeName) {
    case 'proto':
    case 'electro theme':
      const swatchContainer = document.querySelector('.swatch[data-option-index="0"]');
      if (swatchContainer) {
        targetContainer = swatchContainer;
      } else {
        const swatches = document.querySelectorAll('.swatch');
        for (const swatch of swatches) {
          const header = swatch.querySelector('.header');
          if (header && matchesSizeKeyword(header.textContent.trim())) {
            targetContainer = swatch;
            break;
          }
        }
      }
      break;

    case 'elomus':
      targetContainer = document.querySelector('.swatch[data-option-index="0"]');
      break;

    case 'corano':
      // For Corano theme, find the visible size swatch container
      const sizeSwatch = document.querySelector('.swatch[data-option-index="0"]:not([style*="display: none"]), .swatch.Size:not([style*="display: none"])');
      if (sizeSwatch) {
        // Find the parent container that contains both hidden selectors and visible swatches
        const productVariantOption = sizeSwatch.closest('.product-variant-option');
        if (productVariantOption) {
          targetContainer = productVariantOption;
        } else {
          targetContainer = sizeSwatch;
        }
      }
      break;

    case 'lezada os 2.0':
      // For Lezada theme, find the visible size swatch container
      const lezadaSizeSwatch = document.querySelector('.swatch[data-option-index="0"]:not([style*="display: none"]), .swatch.Size:not([style*="display: none"])');
      if (lezadaSizeSwatch) {
        // Find the parent container that contains both hidden selectors and visible swatches
        const productVariantOption = lezadaSizeSwatch.closest('.product-variant-option');
        if (productVariantOption) {
          targetContainer = productVariantOption;
        } else {
          targetContainer = lezadaSizeSwatch;
        }
      }
      break;

    case 'learts - shopify theme ':
      // For Learts theme, find the product-variant-option container
      const productVariantOption = document.querySelector('.product-variations');
      if (productVariantOption) {
        targetContainer = productVariantOption;
      }
      break;
  }

  if (targetContainer) {
    // Remove the details container from its current position
    if (detailsContainer.parentNode) {
      detailsContainer.parentNode.removeChild(detailsContainer);
    }
    // Insert after the target container
    targetContainer.parentNode.insertBefore(detailsContainer, targetContainer.nextSibling);
    detailsContainer.dataset[datasetKey] = "true";

    // Update size details for the default selected size
    const defaultSelectedRadio = targetContainer.querySelector('input[type="radio"]:checked');
    if (defaultSelectedRadio) {
      let selectedValue = defaultSelectedRadio.value.split('[')[0].trim();

      // Try multiple formats for size matching (same logic as handleCoranoSizeSelector)
      const sizeVariations = [
        selectedValue,                    // Original value (e.g., "s")
        selectedValue.toUpperCase(),      // Uppercase (e.g., "S")
        selectedValue.toLowerCase(),      // Lowercase (e.g., "s")
        selectedValue.charAt(0).toUpperCase() + selectedValue.slice(1).toLowerCase() // Title case (e.g., "S")
      ];

      let matchedSizeValue = null;
      for (const variation of sizeVariations) {
        if (sizeInfo[variation]) {
          matchedSizeValue = variation;
          break;
        }
      }

      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, detailsContainer);
      }
    }
  }
}

// Add a function for handling Venedor theme size selector
function handleVenedorSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Handle Venedor theme structure: div.product-single-option > label.option-label
  const sizeLabels = selector.querySelectorAll('label.option-label');
  if (!sizeLabels.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the selector container
  const parentContainer = selector.closest('.product-single-option') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  sizeLabels.forEach(label => {
    if (label.dataset.pifyProcessed === 'true') return;
    label.dataset.pifyProcessed = 'true';

    const sizeValue = label.getAttribute('data-value') || label.textContent.trim();
    if (!sizeValue) return;

    // Ensure label has the correct positioning
    const labelStyle = window.getComputedStyle(label);
    if (labelStyle.position === 'static') {
      label.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (sizeInfo[sizeValue]) {
      const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
      label.appendChild(tooltip);

      label.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });

      label.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    // Handle click events
    label.addEventListener('click', () => {
      // Remove active class from all labels
      sizeLabels.forEach(l => l.classList.remove('active'));
      // Add active class to clicked label
      label.classList.add('active');

      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    // Check if this label is initially active
    if (label.classList.contains('active')) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

// Add a function for handling Vinova Modamate theme size selector
function handleVinovaModamateSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Handle Vinova Modamate theme structure: fieldset.product-variant-form-input > div.product-single__variant-item > label
  const variantItems = selector.querySelectorAll('div.product-single__variant-item');

  if (!variantItems.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the fieldset container
  const parentContainer = selector.closest('.product-variant-form-input') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }


  // Track if we have any valid size data
  let hasValidSizeData = false;

  variantItems.forEach((item, index) => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    const radio = item.querySelector('input[type="radio"]');
    const label = item.querySelector('label');

    if (!radio || !label) {
      return;
    }

    const sizeValue = radio.value || label.textContent.trim();

    if (!sizeValue) return;

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "s")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "S")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "s")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "S")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Ensure label has the correct positioning
    const labelStyle = window.getComputedStyle(label);
    if (labelStyle.position === 'static') {
      label.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (sizeInfo[matchedSizeValue]) {
      const tooltip = createSmartSizeTooltip(matchedSizeValue, sizeInfo);
      label.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      // Remove existing listeners to prevent duplicates
      label.removeEventListener('mouseenter', handleMouseEnter);
      label.removeEventListener('mouseleave', handleMouseLeave);

      // Add new listeners
      label.addEventListener('mouseenter', handleMouseEnter);
      label.addEventListener('mouseleave', handleMouseLeave);

      // Also add listeners to the item container for better coverage
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    }

    // Handle radio change events
    const handleChange = () => {
      if (radio.checked && sizeInfo[matchedSizeValue]) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else if (radio.checked && !sizeInfo[matchedSizeValue]) {
        selectedSizeDetails.style.display = 'none';
      }
    };

    // Remove existing listeners to prevent duplicates
    radio.removeEventListener('change', handleChange);
    radio.addEventListener('change', handleChange);

    // Check if this radio is initially checked
    if (radio.checked) {
      if (sizeInfo[matchedSizeValue]) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  // If no valid size data found, hide the details container
  if (!hasValidSizeData) {
    selectedSizeDetails.style.display = 'none';
  }
}

function handleLusionSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Get current theme name to determine if hover should be disabled
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
  const isEvaTheme = themeName === 'eva';
  const isUneroTheme = themeName === 'unero';
  const isNoHoverTheme = isEvaTheme || isUneroTheme;

  // Handle Lusion theme structure: div.selector-wrapper > div.swatch > span.option-item
  // Handle Eva/Unero theme structure: div.tawcvs-swatches > span.swatch
  const optionItems = isNoHoverTheme ?
    selector.querySelectorAll('span.swatch') :
    selector.querySelectorAll('span.option-item');

  if (!optionItems.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the appropriate container
  let parentContainer;
  if (isNoHoverTheme) {
    parentContainer = selector.closest('.tawcvs-swatches') || selector.parentElement;
  } else {
    parentContainer = selector.closest('.selector-wrapper') || selector.parentElement;
  }

  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;

  optionItems.forEach((item, index) => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    // Get size value based on theme
    let sizeValue;
    if (isNoHoverTheme) {
      sizeValue = item.getAttribute('data-value');
    } else {
      sizeValue = item.getAttribute('data-value') || item.textContent.trim();
    }

    if (!sizeValue) return;

    // Check if we have size data for this value
    if (sizeInfo[sizeValue]) {
      hasValidSizeData = true;
    }

    // Ensure item has the correct positioning
    const itemStyle = window.getComputedStyle(item);
    if (itemStyle.position === 'static') {
      item.style.position = 'relative';
    }

    // Add tooltip for sizes with data (only for non-Eva/Unero themes)
    if (sizeInfo[sizeValue] && !isNoHoverTheme) {
      const tooltip = createSmartSizeTooltip(sizeValue, sizeInfo);
      item.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };
      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };
      // Remove existing listeners to prevent duplicates
      item.removeEventListener('mouseenter', handleMouseEnter);
      item.removeEventListener('mouseleave', handleMouseLeave);
      // Add new listeners
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    }

    // Handle click events
    const handleClick = (e) => {
      e.preventDefault();
      // Remove selected class from all items
      optionItems.forEach(i => i.classList.remove('selected'));
      // Add selected class to clicked item
      item.classList.add('selected');
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    };
    // Remove existing listeners to prevent duplicates
    item.removeEventListener('click', handleClick);
    item.addEventListener('click', handleClick);
    // Check if this item is initially selected
    if (item.classList.contains('selected')) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  // If no valid size data found, hide the details container
  if (!hasValidSizeData) {
    selectedSizeDetails.style.display = 'none';
  }

  // Listen for dynamic changes using MutationObserver (only for Eva/Unero themes)
  if (isNoHoverTheme) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('selected') && target.classList.contains('swatch')) {
            const sizeValue = target.getAttribute('data-value');
            if (sizeValue && sizeInfo[sizeValue]) {
              updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
              selectedSizeDetails.style.display = 'block';
            } else {
              selectedSizeDetails.style.display = 'none';
            }
          }
        }
      });
    });

    // Observe the selector container for class changes
    observer.observe(selector, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  }
}

function handleGoodwinSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Handle Goodwin theme structure: div.prd-size > ul.size-list > li > a
  const sizeList = selector.querySelector('ul.size-list');
  if (!sizeList) {
    return;
  }

  const sizeItems = sizeList.querySelectorAll('li a');

  if (!sizeItems.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the prd-size container
  const parentContainer = selector.closest('.prd-size') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;

  sizeItems.forEach((item, index) => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    const sizeValue = item.getAttribute('data-value') || item.textContent.trim();

    if (!sizeValue) return;

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "Small")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "SMALL")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "small")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "Small")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Ensure item has the correct positioning
    const itemStyle = window.getComputedStyle(item);
    if (itemStyle.position === 'static') {
      item.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (matchedSizeValue) {
      const tooltip = createSmartSizeTooltip(matchedSizeValue, sizeInfo);
      item.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);
      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      // Remove existing listeners to prevent duplicates
      item.removeEventListener('mouseenter', handleMouseEnter);
      item.removeEventListener('mouseleave', handleMouseLeave);

      // Add new listeners
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    }

    // Check if this item is initially active
    if (item.closest('li').classList.contains('active')) {
      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.tagName === 'LI' && target.classList.contains('active')) {
          const link = target.querySelector('a');
          if (link) {
            const sizeValue = link.getAttribute('data-value') || link.textContent.trim();
            if (sizeValue) {
              // Try multiple formats for size matching
              const sizeVariations = [
                sizeValue,
                sizeValue.toUpperCase(),
                sizeValue.toLowerCase(),
                sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase()
              ];

              let matchedSizeValue = null;
              for (const variation of sizeVariations) {
                if (sizeInfo[variation]) {
                  matchedSizeValue = variation;
                  break;
                }
              }

              if (matchedSizeValue) {
                updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
                selectedSizeDetails.style.display = 'block';
              } else {
                selectedSizeDetails.style.display = 'none';
              }
            }
          }
        }
      }
    });
  });

  const listItems = sizeList.querySelectorAll('li');
  listItems.forEach(li => {
    observer.observe(li, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // If no valid size data found, hide the details container
  if (!hasValidSizeData) {
    selectedSizeDetails.style.display = 'none';
  }
}

function handleCoranoSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Check if this is a color selector and skip it
  const isColorSelector =
    selector.classList.contains('color') ||
    selector.classList.contains('color-swatch') ||
    selector.classList.contains('color-option') ||
    selector.classList.contains('color-selector') ||
    selector.getAttribute('data-value')?.toLowerCase().match(/^(red|green|blue|yellow|white|black|pink|purple|orange|brown|gray|grey|navy|teal|cyan|magenta|lime|olive|maroon|silver|gold|beige|ivory|cream|tan|coral|salmon|peach|apricot|mint|lavender|plum|indigo|violet|turquoise|aqua|azure|crimson|scarlet|burgundy|ruby|emerald|jade|sapphire|diamond|pearl|amber|topaz|garnet|onyx|jet|charcoal|slate|steel|bronze|copper|brass|chrome|nickel|zinc|titanium|aluminum|aluminium)$/);

  if (isColorSelector) {
    return;
  }

  // Handle Corano theme structure: div.swatch > div.swatch-element > input[type="radio"] + label
  // Find size swatch specifically (not color swatch)
  const sizeSwatch = selector.querySelector('.swatch[data-option-index="0"], .swatch.Size');
  if (!sizeSwatch) {
    // Try to find size swatch in the entire page
    const pageSizeSwatch = document.querySelector('.swatch[data-option-index="0"], .swatch.Size');
    if (pageSizeSwatch) {
      // Use the page size swatch instead
      const pageSizeSwatchParent = pageSizeSwatch.closest('.product-variant-option') || pageSizeSwatch.parentElement;
      if (pageSizeSwatchParent && pageSizeSwatchParent.parentNode) {
        pageSizeSwatchParent.parentNode.insertBefore(selectedSizeDetails, pageSizeSwatchParent.nextSibling);
      } else {
        pageSizeSwatch.parentNode.insertBefore(selectedSizeDetails, pageSizeSwatch.nextSibling);
      }

      // Process the page size swatch
      processSwatchElements(pageSizeSwatch, sizeInfo, selectedSizeDetails);
    }
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the size swatch container
  const parentContainer = sizeSwatch.closest('.product-variant-option') || sizeSwatch.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    sizeSwatch.parentNode.insertBefore(selectedSizeDetails, sizeSwatch.nextSibling);
  }

  // Process the swatch elements
  processSwatchElements(sizeSwatch, sizeInfo, selectedSizeDetails);
}

function processSwatchElements(sizeSwatch, sizeInfo, selectedSizeDetails) {
  // Get all swatch elements (size options)
  const swatchElements = sizeSwatch.querySelectorAll('.swatch-element');
  if (!swatchElements.length) {
    return;
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;
  let initiallySelectedSize = null;

  swatchElements.forEach((swatchElement, index) => {
    if (swatchElement.dataset.pifyProcessed === 'true') return;
    swatchElement.dataset.pifyProcessed = 'true';

    const sizeValue = swatchElement.getAttribute('data-value');
    if (!sizeValue) {
      return;
    }

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "s")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "S")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "s")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "S")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Check if this element is initially selected (multiple ways to check)
    const isInitiallySelected = swatchElement.classList.contains('selected') ||
      swatchElement.querySelector('input[type="radio"]:checked') ||
      swatchElement.classList.contains('active') ||
      swatchElement.querySelector('input[type="radio"]').checked;

    if (isInitiallySelected && matchedSizeValue) {
      initiallySelectedSize = matchedSizeValue;
    }
  });

  // Function to update size details based on current selection
  const updateSizeDetailsFromCurrentSelection = () => {
    const selectedElement = sizeSwatch.querySelector('.swatch-element.selected, .swatch-element.active') ||
      sizeSwatch.querySelector('.swatch-element input[type="radio"]:checked')?.closest('.swatch-element');

    if (selectedElement) {
      const sizeValue = selectedElement.getAttribute('data-value');
      if (sizeValue) {
        const sizeVariations = [
          sizeValue,
          sizeValue.toUpperCase(),
          sizeValue.toLowerCase(),
          sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase()
        ];

        let matchedSizeValue = null;
        for (const variation of sizeVariations) {
          if (sizeInfo[variation]) {
            matchedSizeValue = variation;
            break;
          }
        }

        if (matchedSizeValue) {
          updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
          selectedSizeDetails.style.display = 'block';
        } else {
          selectedSizeDetails.style.display = 'none';
        }
      }
    } else {
      selectedSizeDetails.style.display = 'none';
    }
  };

  // Enhanced MutationObserver to handle class changes and radio button changes
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;

    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        const target = mutation.target;

        // Handle class attribute changes
        if (mutation.attributeName === 'class' && target.classList.contains('swatch-element')) {
          if (target.classList.contains('selected') || target.classList.contains('active')) {
            shouldUpdate = true;
          }
        }

        // Handle radio button checked state changes
        if (mutation.attributeName === 'checked' && target.type === 'radio') {
          if (target.checked) {
            shouldUpdate = true;
          }
        }
      }
    });

    if (shouldUpdate) {
      // Add a small delay to ensure DOM updates are complete
      setTimeout(updateSizeDetailsFromCurrentSelection, 10);
    }
  });

  // Observe all swatch elements for class changes
  swatchElements.forEach(swatchElement => {
    observer.observe(swatchElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Also observe radio buttons for checked state changes
    const radio = swatchElement.querySelector('input[type="radio"]');
    if (radio) {
      observer.observe(radio, {
        attributes: true,
        attributeFilter: ['checked']
      });
    }
  });

  // Also observe the entire swatch container for any changes
  observer.observe(sizeSwatch, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  // Add event listeners to labels for additional coverage
  swatchElements.forEach(swatchElement => {
    const label = swatchElement.querySelector('label');
    if (label) {
      // Use a more passive approach - just trigger update after a short delay
      const handleLabelInteraction = () => {
        setTimeout(updateSizeDetailsFromCurrentSelection, 50);
      };

      label.addEventListener('click', handleLabelInteraction, { passive: true });
      label.addEventListener('change', handleLabelInteraction, { passive: true });
    }

    // Also listen to radio button events
    const radio = swatchElement.querySelector('input[type="radio"]');
    if (radio) {
      const handleRadioInteraction = () => {
        setTimeout(updateSizeDetailsFromCurrentSelection, 50);
      };

      radio.addEventListener('change', handleRadioInteraction, { passive: true });
      radio.addEventListener('click', handleRadioInteraction, { passive: true });
    }
  });

  // Show initially selected size details if available
  if (initiallySelectedSize) {
    updateSizeDetails(initiallySelectedSize, sizeInfo, selectedSizeDetails);
    selectedSizeDetails.style.display = 'block';
  } else if (hasValidSizeData) {
    // If no initially selected size but we have valid data, show the first available size
    const firstSwatchElement = swatchElements[0];
    const firstSizeValue = firstSwatchElement.getAttribute('data-value');
    if (firstSizeValue) {
      const sizeVariations = [
        firstSizeValue,
        firstSizeValue.toUpperCase(),
        firstSizeValue.toLowerCase(),
        firstSizeValue.charAt(0).toUpperCase() + firstSizeValue.slice(1).toLowerCase()
      ];

      for (const variation of sizeVariations) {
        if (sizeInfo[variation]) {
          updateSizeDetails(variation, sizeInfo, selectedSizeDetails);
          selectedSizeDetails.style.display = 'block';
          break;
        }
      }
    }
  } else {
    // If no valid size data found, hide the details container
    selectedSizeDetails.style.display = 'none';
  }
}

// Handle prd-option-list size selector with quantity status
function handlePrdOptionListSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Helper: delegate to global matcher
  function findMatchingSizeValue(value, sizeInfo) {
    return matchSizeValue(value, sizeInfo);
  }

  // Get all label elements with radio buttons
  const labels = selector.querySelectorAll('label.label-radio');
  if (!labels.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the fieldset container
  const parentContainer = selector.closest('.prd-option-list') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;
  let initiallySelectedSize = null;

  labels.forEach((label, index) => {
    if (label.dataset.pifyProcessed === 'true') return;
    label.dataset.pifyProcessed = 'true';

    const radio = label.querySelector('input[type="radio"]');
    if (!radio) return;

    // Get size value from label text content (remove any extra whitespace)
    const sizeValue = label.childNodes[0]?.nodeType === Node.TEXT_NODE ?
      label.childNodes[0].textContent.trim() :
      label.textContent.trim();

    if (!sizeValue) return;

    // Match size value using global matcher
    const matchedSizeValue = matchSizeValue(sizeValue, sizeInfo);

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Check if this label is initially selected
    const isInitiallySelected = label.classList.contains('swatch-active') ||
      radio.checked ||
      label.classList.contains('active') ||
      label.classList.contains('selected');

    if (isInitiallySelected && matchedSizeValue) {
      initiallySelectedSize = matchedSizeValue;
    }

    // Ensure label has the correct positioning
    const labelStyle = window.getComputedStyle(label);
    if (labelStyle.position === 'static') {
      label.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (matchedSizeValue) {
      const tooltip = createSmartSizeTooltip(matchedSizeValue, sizeInfo);
      label.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      // Remove existing listeners to prevent duplicates
      label.removeEventListener('mouseenter', handleMouseEnter);
      label.removeEventListener('mouseleave', handleMouseLeave);

      // Add new listeners
      label.addEventListener('mouseenter', handleMouseEnter);
      label.addEventListener('mouseleave', handleMouseLeave);
    }

    // Handle radio change events
    const handleChange = () => {
      if (radio.checked && matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else if (radio.checked && !matchedSizeValue) {
        selectedSizeDetails.style.display = 'none';
      }
    };

    // Remove existing listeners to prevent duplicates
    radio.removeEventListener('change', handleChange);
    radio.addEventListener('change', handleChange);

    // Also handle label click events for better compatibility
    const handleLabelClick = () => {
      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    };

    label.removeEventListener('click', handleLabelClick);
    label.addEventListener('click', handleLabelClick);

    // Check if this radio is initially checked
    if (radio.checked) {
      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  // Show initially selected size details if available
  if (initiallySelectedSize) {
    updateSizeDetails(initiallySelectedSize, sizeInfo, selectedSizeDetails);
    selectedSizeDetails.style.display = 'block';
  } else if (hasValidSizeData) {
    // If no initially selected size but we have valid data, show the first available size
    const firstLabel = labels[0];
    const firstSizeValue = firstLabel.childNodes[0]?.nodeType === Node.TEXT_NODE ?
      firstLabel.childNodes[0].textContent.trim() :
      firstLabel.textContent.trim();

    if (firstSizeValue) {
      const sizeVariations = [
        firstSizeValue,
        firstSizeValue.toUpperCase(),
        firstSizeValue.toLowerCase(),
        firstSizeValue.charAt(0).toUpperCase() + firstSizeValue.slice(1).toLowerCase()
      ];

      for (const variation of sizeVariations) {
        if (sizeInfo[variation]) {
          updateSizeDetails(variation, sizeInfo, selectedSizeDetails);
          selectedSizeDetails.style.display = 'block';
          break;
        }
      }
    }
  } else {
    // If no valid size data found, hide the details container
    selectedSizeDetails.style.display = 'none';
  }
}

// Add a generic function for handling prd-size list structure (used by Foxic and Goodwin themes)
function handlePrdSizeListSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Handle prd-size list structure: div.prd-size > ul.size-list > li > a
  const sizeList = selector.querySelector('ul.size-list');
  if (!sizeList) {
    return;
  }

  const sizeItems = sizeList.querySelectorAll('li a');

  if (!sizeItems.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the prd-size container
  const parentContainer = selector.closest('.prd-size') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;

  sizeItems.forEach((item, index) => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    const sizeValue = item.getAttribute('data-value') || item.textContent.trim();

    if (!sizeValue) return;

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "Small")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "SMALL")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "small")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "Small")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Ensure item has the correct positioning
    const itemStyle = window.getComputedStyle(item);
    if (itemStyle.position === 'static') {
      item.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (matchedSizeValue) {
      const tooltip = createSmartSizeTooltip(matchedSizeValue, sizeInfo);
      item.appendChild(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      // Remove existing listeners to prevent duplicates
      item.removeEventListener('mouseenter', handleMouseEnter);
      item.removeEventListener('mouseleave', handleMouseLeave);

      // Add new listeners
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    }

    // Check if this item is initially active
    if (item.closest('li').classList.contains('active')) {
      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.tagName === 'LI' && target.classList.contains('active')) {
          const link = target.querySelector('a');
          if (link) {
            const sizeValue = link.getAttribute('data-value') || link.textContent.trim();
            if (sizeValue) {
              // Try multiple formats for size matching
              const sizeVariations = [
                sizeValue,
                sizeValue.toUpperCase(),
                sizeValue.toLowerCase(),
                sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase()
              ];

              let matchedSizeValue = null;
              for (const variation of sizeVariations) {
                if (sizeInfo[variation]) {
                  matchedSizeValue = variation;
                  break;
                }
              }

              if (matchedSizeValue) {
                updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
                selectedSizeDetails.style.display = 'block';
              } else {
                selectedSizeDetails.style.display = 'none';
              }
            }
          }
        }
      }
    });
  });

  const listItems = sizeList.querySelectorAll('li');
  listItems.forEach(li => {
    observer.observe(li, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // If no valid size data found, hide the details container
  if (!hasValidSizeData) {
    selectedSizeDetails.style.display = 'none';
  }
}

function handleWokieeSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;

  const titleElement = selector.querySelector('.tt-title-options');
  if (titleElement) {
    const titleText = titleElement.textContent.trim().toLowerCase();
    if (!matchesSizeKeyword(titleText)) {
      return;
    }
  } else {
    const sizeLinks = selector.querySelectorAll('li a[data-value]');
    if (sizeLinks.length > 0) {
      const sizeValues = Array.from(sizeLinks).map(link => link.getAttribute('data-value'));
      const sizePatterns = [
        /^(XXS|XS|S|M|L|XL|XXL|XXXL)$/i,
        /^(2XS|3XS|2XL|3XL|4XL|5XL)$/i,
        /^\d+$/,
        /^\d+[A-Z]?$/i,
        /^\d+\.\d+$/,
        /^\d+\/\d+$/,
        /^(ONE SIZE|ONESIZE|OS|FREE SIZE|FREESIZE)$/i
      ];

      let sizeCount = 0;
      sizeValues.forEach(value => {
        if (sizePatterns.some(pattern => pattern.test(value))) {
          sizeCount++;
        }
      });

      if (sizeCount / sizeValues.length < 0.5) {
        return;
      }
    } else {
      return;
    }
  }

  selector.dataset.pifyProcessed = 'true';

  // Handle Wokiee theme structure: div.tt-wrapper > ul.tt-options-swatch > li > a
  const sizeList = selector.querySelector('ul.tt-options-swatch');
  if (!sizeList) {
    return;
  }

  const sizeItems = sizeList.querySelectorAll('li a');
  if (!sizeItems.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the selector container
  const parentContainer = selector.closest('.tt-wrapper') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;

  sizeItems.forEach((link, index) => {
    if (link.dataset.pifyProcessed === 'true') return;
    link.dataset.pifyProcessed = 'true';

    const sizeValue = link.getAttribute('data-value') || link.textContent.trim();
    if (!sizeValue) return;

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "S")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "S")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "s")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "S")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Ensure link has the correct positioning
    const linkStyle = window.getComputedStyle(link);
    if (linkStyle.position === 'static') {
      link.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (matchedSizeValue) {
      const tooltip = createSmartSizeTooltip(matchedSizeValue, sizeInfo);
      link.appendChild(tooltip);
      // setTooltipParentOverflow(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      // Remove existing listeners to prevent duplicates
      link.removeEventListener('mouseenter', handleMouseEnter);
      link.removeEventListener('mouseleave', handleMouseLeave);

      // Add new listeners
      link.addEventListener('mouseenter', handleMouseEnter);
      link.addEventListener('mouseleave', handleMouseLeave);
    }

    // Check if this item is initially active
    if (link.closest('li').classList.contains('active')) {
      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  // Add MutationObserver to watch for active state changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.tagName === 'LI' && target.classList.contains('active')) {
          const link = target.querySelector('a');
          if (link) {
            const sizeValue = link.getAttribute('data-value') || link.textContent.trim();
            if (sizeValue) {
              // Try multiple formats for size matching
              const sizeVariations = [
                sizeValue,
                sizeValue.toUpperCase(),
                sizeValue.toLowerCase(),
                sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase()
              ];

              let matchedSizeValue = null;
              for (const variation of sizeVariations) {
                if (sizeInfo[variation]) {
                  matchedSizeValue = variation;
                  break;
                }
              }

              if (matchedSizeValue) {
                updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
                selectedSizeDetails.style.display = 'block';
              } else {
                selectedSizeDetails.style.display = 'none';
              }
            }
          }
        }
      }
    });
  });

  const listItems = sizeList.querySelectorAll('li');
  listItems.forEach(li => {
    observer.observe(li, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // If no valid size data found, hide the details container
  if (!hasValidSizeData) {
    selectedSizeDetails.style.display = 'none';
  }
}

// ==================== FIT CHARTS FUNCTIONALITY INTEGRATION ====================

/**
 * Get current product ID
 */
function getCurrentProductId() {
  // Method 1: Get from window.pageData
  if (window.pageData && window.pageData.productId) {
    return window.pageData.productId.toString();
  }

  // Method 2: Get from ShopifyAnalytics
  if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
    const productId = window.ShopifyAnalytics.meta.product.id;
    return productId ? productId.toString() : null;
  }

  // Method 3: Get from meta tags
  const metaProduct = document.querySelector('meta[property="product:id"]');
  if (metaProduct) {
    return metaProduct.getAttribute('content');
  }

  // Method 4: Parse from URL path (/products/handle)
  const pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
  if (pathMatch) {
    // Return handle here, need other methods to get ID later
    const handle = pathMatch[1];

    // Try to get product data from script tags on page
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (const script of scripts) {
      try {
        const data = JSON.parse(script.textContent);
        if (data['@type'] === 'Product' && data.sku) {
          // Some themes may have product ID here
          const productId = data.productID || data['@id'];
          if (productId) {
            return productId.toString();
          }
        }
      } catch (e) {
        // Ignore parsing errors
      }
    }
  }

  // Method 5: Get from Shopify global variables
  if (window.meta && window.meta.product && window.meta.product.id) {
    return window.meta.product.id.toString();
  }

  return null;
}

/**
 * Normalize product ID format
 */
function normalizeProductId(productId) {
  if (!productId) return null;

  // If it's Shopify GID format, extract numeric ID
  if (productId.includes('gid://shopify/Product/')) {
    return productId.replace('gid://shopify/Product/', '');
  }

  // Remove any non-numeric characters, keep only numbers
  const numericId = productId.toString().replace(/\D/g, '');
  return numericId || null;
}

/**
 * Get FitProfiles from existing data
 */
function getFitProfilesFromData() {
  // 1. Check global pageData object
  if (window.pageData && window.pageData.fitProfiles) {
    return window.pageData.fitProfiles;
  }

  // 2. Fallback: parse from script element
  const scriptElement = document.getElementById('pify-sizechart-data');
  if (scriptElement) {
    try {
      const pageData = JSON.parse(scriptElement.textContent);
      if (pageData.fitProfiles) {
        return pageData.fitProfiles;
      }
    } catch (error) {
      return [];
    }
  }

  return [];
}

/**
 * Check if FitChart should be displayed
 * Reuse shouldDisplaySizeChart logic, adapted for fit chart data structure
 */
function shouldDisplayFitChart(fitChart) {
  if (!fitChart) {
    return false;
  }

  // Check status
  const status = fitChart.status || fitChart.settings?.status || 'active';
  if (status !== 'active') {
    return false;
  }

  // Get targeting configuration
  const targeting = fitChart.settings?.targeting || fitChart.targeting;
  if (!targeting) {
    return false;
  }

  // Check if on product page
  const isProductPage = window.location.pathname.startsWith('/products/') ||
    window.location.pathname.includes('/products/');
  if (!isProductPage) {
    return false;
  }

  // Global product-level exclusion, applies to all modes
  const excludedProducts = targeting.excludedProducts;
  if (excludedProducts && Array.isArray(excludedProducts) && window.pageData && window.pageData.productId) {
    const pageProductIdStr = String(window.pageData.productId);
    const isExcluded = excludedProducts.some(product => {
      if (!product || !product.id) return false;
      const productId = product.id.split('/').pop();
      return String(productId) === pageProductIdStr;
    });
    if (isExcluded) return false;
  }

  // Reuse shouldDisplaySizeChart logic
  // 1. All products - show to all products
  if (targeting.displayPosition === 'all') return true;

  // 2. Selected products - show only on specified products
  if (targeting.displayPosition === 'products') {
    if (!window.pageData || !window.pageData.productId) return false;

    return targeting.selectedProducts.some(product => {
      if (!product || !product.id) return false;

      const productId = product.id.split('/').pop();
      const productIdStr = String(productId);
      const pageProductIdStr = String(window.pageData.productId);

      return productIdStr === pageProductIdStr;
    });
  }

  // 3. Product Collections - show only on products in specified collections
  if (targeting.displayPosition === 'collections') {
    if (!window.pageData || !window.pageData.collectionIds || !Array.isArray(window.pageData.collectionIds)) return false;

    return targeting.selectedCollections.some(collection => {
      if (!collection || !collection.id) return false;

      const collectionId = collection.id.split('/').pop();
      const collectionIdStr = String(collectionId);

      return window.pageData.collectionIds.some(pageCollectionId =>
        String(pageCollectionId) === collectionIdStr
      );
    });
  }

  // 4. Product Tags - show only on products with specified tags
  if (targeting.displayPosition === 'tags') {
    if (!window.pageData || !window.pageData.productTags || !Array.isArray(window.pageData.productTags)) return false;
    if (!targeting.productTags || !Array.isArray(targeting.productTags)) return false;

    return targeting.productTags.some(tag =>
      window.pageData.productTags.includes(tag)
    );
  }
  if (targeting.displayPosition === 'vendors') {
    if (!window.pageData || !window.pageData.productVendor) return false;
    const selectedVendors = targeting.selectedVendors;
    if (!selectedVendors || !Array.isArray(selectedVendors)) return false;
    return selectedVendors.includes(window.pageData.productVendor);
  }

  if (targeting.displayPosition === 'tags_collections_vendors') {
    return checkTagsCollectionsVendors(targeting);
  }

  return false;
}

/**
 * Render Fit selector
 */
function renderFitSelector(fitChart) {
  const fitData = fitChart.settings?.fitSettings || fitChart.fitSettings || {};
  const container = document.createElement('div');
  container.className = 'pify_fit_selector_container';
  container.dataset.fitCode = fitChart.code;

  // Identify if it's advanced mode
  if (fitData.styles?.segmentBar?.advancedMode) {
    container.dataset.advancedMode = 'true';
  }

  // Handle data format compatibility
  let types = [];
  if (fitData.types && Array.isArray(fitData.types)) {
    if (typeof fitData.types[0] === 'string') {
      // Old format: string array, convert to new format
      const selectedType = fitData.selectedType || fitData.types[0];
      types = fitData.types.map((type, index) => ({
        id: index,
        name: type,
        isSelected: type === selectedType
      }));
    } else {
      // New format: object array
      types = fitData.types;
    }
  }

  if (!types.length) {
    return null; // Don't render if no type data
  }

  // Get style configuration
  const titleStyle = {
    color: fitData.styles?.title?.color || '#333333',
    fontSize: fitData.styles?.title?.fontSize || '16px',
    fontWeight: fitData.styles?.title?.fontWeight || 'bold',
    margin: '0 0 8px 0',
    padding: '0',
    display: 'block'
  };

  const typesStyle = {
    color: fitData.styles?.types?.color || '#666666',
    fontSize: fitData.styles?.types?.fontSize || '12px',
    fontWeight: fitData.styles?.types?.fontWeight || 'normal',
    margin: '0',
    padding: '0'
  };

  // Create title
  const titleElement = document.createElement('div');
  titleElement.className = 'pify_fit_title';
  titleElement.textContent = fitData.fitTitle ?? 'Fit';
  titleElement.style.color = titleStyle.color;
  titleElement.style.fontSize = titleStyle.fontSize;
  titleElement.style.fontWeight = titleStyle.fontWeight;

  // Create type container
  const typesContainer = document.createElement('div');
  typesContainer.className = 'pify_fit_types_container';
  // CSS styles applied through class names

  // Create type label container
  const typesLabelsContainer = document.createElement('div');
  typesLabelsContainer.className = 'pify_fit_types_labels';

  // Add type labels
  types.forEach((typeObj, index) => {
    const typeLabel = document.createElement('span');
    typeLabel.className = 'pify_fit_type_label';
    // Only set text content when name is not empty
    if (typeObj.name && typeObj.name.trim()) {
      typeLabel.textContent = typeObj.name;
    }
    // Use CSS variables to set styles
    typeLabel.style.setProperty('--label-color', typesStyle.color);
    typeLabel.style.setProperty('--label-font-size', typesStyle.fontSize);
    typeLabel.style.setProperty('--label-font-weight', typesStyle.fontWeight);
    typeLabel.dataset.fitTypeId = typeObj.id;
    typeLabel.dataset.fitIndex = index;
    typesLabelsContainer.appendChild(typeLabel);
  });

  // Create arrow indicator container
  const arrowContainer = document.createElement('div');
  arrowContainer.className = 'pify_fit_arrow_container';

  // Create Segment Bar
  const segmentBarContainer = document.createElement('div');
  segmentBarContainer.className = 'pify_fit_segment_bar';

  // segment bar styles moved to CSS classes

  // Determine currently selected index
  const selectedIndex = types.findIndex(type => type.isSelected);

  // Add segments
  types.forEach((typeObj, index) => {
    // Create arrow - determine arrow color based on selected type
    const arrowElement = document.createElement('div');
    arrowElement.className = 'pify_fit_arrow';
    arrowElement.style.opacity = '0';

    const arrowSize = parseInt(fitData.styles?.arrow?.size || '6px');

    // Get arrow color based on Advanced Mode and segments
    let arrowColor = fitData.styles?.arrow?.color;
    if (!arrowColor && fitData.styles?.segmentBar?.advancedMode && fitData.styles?.segmentBar?.segments?.[index]) {
      arrowColor = fitData.styles.segmentBar.segments[index].activeColor;
    }
    if (!arrowColor) {
      arrowColor = fitData.styles?.segmentBar?.backgroundColor || '#007ace';
    }

    // Ensure arrow color is not empty and visible
    if (!arrowColor || arrowColor === 'transparent' || arrowColor === '') {
      arrowColor = '#007ace'; // Default blue
    }

    // Use Unicode down arrow character
    arrowElement.innerHTML = `
      <div class="pify_fit_arrow_icon" style="color: ${arrowColor}; font-size: ${arrowSize}px;">▼</div>
    `;

    arrowContainer.appendChild(arrowElement);

    // Create segment
    const segment = document.createElement('div');
    segment.className = 'pify_fit_segment';
    
    // Add zero-width space to prevent hiding by div:empty{display:none} rule
    segment.innerHTML = '&zwj;'; // Zero-width joiner, invisible but makes element non-empty

    // Get styles based on Advanced Mode
    const isAdvancedMode = fitData.styles?.segmentBar?.advancedMode;
    const segmentStyle = isAdvancedMode && fitData.styles?.segmentBar?.segments?.[index]
      ? fitData.styles.segmentBar.segments[index]
      : null;

    // Determine currently selected index
    const isActive = index <= selectedIndex;

    // Get color (only keep color configuration)
    let backgroundColor;
    if (segmentStyle) {
      backgroundColor = isActive ? segmentStyle.activeColor : segmentStyle.inactiveColor;
    } else {
      backgroundColor = isActive
        ? (fitData.styles?.segmentBar?.backgroundColor || '#000000')
        : (fitData.styles?.segmentBar?.inactiveColor || '#e1e3e5');
    }

    // Apply background color styles
    segment.style.backgroundColor = backgroundColor;

    segment.dataset.fitTypeId = typeObj.id;
    segment.dataset.fitIndex = index;
    segmentBarContainer.appendChild(segment);
  });

  // segment bar only for display status, does not respond to click events

  // Assemble container - decide whether to add arrow based on showArrow configuration
  container.appendChild(titleElement);

  // Only add arrow container when showArrow is true
  if (fitData.showArrow !== false) { // Show arrow by default unless explicitly set to false
    container.appendChild(arrowContainer);
  }

  container.appendChild(segmentBarContainer);
  typesContainer.appendChild(typesLabelsContainer);
  container.appendChild(typesContainer);

  // Set default selected state - call after all elements are added to DOM
  const defaultSelectedType = types.find(t => t.isSelected);
  if (defaultSelectedType) {
    setFitSelection(container, defaultSelectedType.id, { types, styles: fitData.styles });
  }

  return container;
}

/**
 * Set Fit selection state
 */
function setFitSelection(container, selectedId, fitData) {
  const types = fitData.types || [];
  const selectedIndex = types.findIndex(type => type.id === selectedId);

  if (selectedIndex < 0) return;

  // Update arrow display and color (only when showArrow is true)
  if (fitData.showArrow !== false) {
    const arrows = container.querySelectorAll('.pify_fit_arrow');
    arrows.forEach((arrow, index) => {
      const isSelected = index === selectedIndex;
      arrow.style.opacity = isSelected ? '1' : '0';

      // If it's selected arrow, update its color
      if (isSelected) {
        const arrowDiv = arrow.querySelector('.pify_fit_arrow_icon');
        if (arrowDiv) {
          // Get arrow color based on Advanced Mode and segments
          let arrowColor = fitData.styles?.arrow?.color;
          if (!arrowColor && fitData.styles?.segmentBar?.advancedMode && fitData.styles?.segmentBar?.segments?.[index]) {
            arrowColor = fitData.styles.segmentBar.segments[index].activeColor;
          }
          if (!arrowColor) {
            arrowColor = fitData.styles?.segmentBar?.backgroundColor || '#007ace';
          }

          // Ensure arrow color is visible and properly formatted
          if (!arrowColor || arrowColor === 'transparent' || arrowColor === '') {
            arrowColor = '#007ace';
          }

          // Handle color format, remove alpha channel
          if (arrowColor.length > 7 && arrowColor.startsWith('#')) {
            arrowColor = arrowColor.substring(0, 7);
          }

          // Set arrow color
          arrowDiv.style.color = arrowColor;
        }
      }
    });
  }

  // Update segments state
  const segments = container.querySelectorAll('.pify_fit_segment');
  segments.forEach((segment, index) => {
    const isActive = index <= selectedIndex;

    // Get color based on Advanced Mode
    const isAdvancedMode = fitData.styles?.segmentBar?.advancedMode;
    const segmentStyle = isAdvancedMode && fitData.styles?.segmentBar?.segments?.[index]
      ? fitData.styles.segmentBar.segments[index]
      : null;

    let backgroundColor;
    if (segmentStyle) {
      backgroundColor = isActive ? segmentStyle.activeColor : segmentStyle.inactiveColor;
    } else {
      backgroundColor = isActive
        ? (fitData.styles?.segmentBar?.backgroundColor || '#000000')
        : (fitData.styles?.segmentBar?.inactiveColor || '#e1e3e5');
    }

    segment.style.setProperty('--segment-bg-color', backgroundColor);
  });

  // Trigger custom event for other features to listen
  const selectedType = types[selectedIndex];
  const event = new CustomEvent('fitSelectionChanged', {
    detail: {
      selectedType: selectedType?.name,
      selectedId: selectedId,
      selectedIndex: selectedIndex,
      fitData: fitData
    }
  });
  container.dispatchEvent(event);
}

/**
 * Find Quantity selector
 */
function findQuantitySelector() {
  const themeFitSelectorMap = {
    boutique: { selector: '.product-quantity__wrapper' },
    drop: { selector: '.product__variants-swatches' },
    dawn: { selector: '.product-form__quantity'}
  };
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
  const themeSelector = themeFitSelectorMap[themeName]?.selector;
  if (themeSelector) {
    const themeEl = document.querySelector(themeSelector);
    if (themeEl && isElementVisible(themeEl)) {
      return themeEl;
    }
  }

  const fallbackSelectors = [
     //Better compatibility 
    '[class*="product-form"]',
    '[class*="product-form__buttons"]',
    '.product-form__quantity',  //Parent node might be flex layout
    '.product-form__input',
    //custom theme
    '.bee-product-form__buttons',   //Nitro theme


    '.variant-selector',
    '.option-selector',
    '.product-option-picker',
    '.variant-picker',
    '.variant-radios',
    '.variant-selects',
    '.product-variant-picker',
    '.swatches',
    '.color-swatch',
    '.size-selector',
    '.color-selector',
    '.product-form__variants',
    '.product-form__option',
    '.variant-picker__option',
    '.js-variant-selector',
    '.SwatchList',
    '.BlockSwatch',
    '.ImageSwatchWrapper',
    '.color-swatch-list',
    '.product-variants-selector',
    '.sticky-variant-select',
    
    // Second level: quantity selector
    '.quantity-input',
    '.quantity-selector',
    '.product-quantity-picker',
    '.quantity-picker',
    '.quantity',
    '.qty',
    '.product__quantity-input',
    '.quantity-input-wrapper',
    '.quantity-submit-row',
    '.product-qty',
    'quantity-input',
    '[data-quantity-input]',
    'input[name="quantity"]',
    // '[class*="quantity"]', causes serious style issues
    // '[class*="product"]', causes serious style issues
    
    // Third level: price
    '.price',
    '.product-price',
    '.price__container',
    '.price__regular',
    '.price__sale',
    '.product__price',
    '.product-price--original',
    '.product--price',
    '.grid-product__price',
    '.main-product-price',
    '.price-container',
    '.product-buy-price',
    '.current-price',
    '.price__main',
    '.ab-price',
    '[data-price]',
    '[data-product-price]',
    '#product-price',
    '.money',
    
    // Fourth level: add to cart
    '.product-form__buttons',
    '.add-to-cart',
    '.btn-cart',
    '.product-form__controls',
    '.product-form__actions',
    '.product-form__button-container',
    '.product-form__payment-container',
    '.product-form__atc-container',
    '.product-form__submit-container',
    '.product-form__cta',
    '.product-form__buttons-container',
    '.product-form__add-to-cart',
    '.product__submit',
    '.product__buttons',
    '.product-page__submit',
    '.add-to-cart-container',
    '.atc-btn-container',
    '.button-wrapper',
    '.button-container',
    '.btn-wrapper',
    '.form-actions',
    '.product-form__buy-buttons',
    '.product-form__atc-wrapper',
    '.product-form__button-wrapper',
    '.product-form__submit-wrapper',
    '.product-form__action-wrapper',
    '.product-buy-buttons',
    '.product-add-to-cart',
    '.product-form-inline-atc',
    '.product-form__buy-now',
    '.product-form__payment-buttons',
    '.product-form__buttons--primary',
    '.product-form__buttons--secondary',
    '.button-action-wrapper',
    '.btn-cart-wrapper',
    '.atc-button-container',
    '.product-summary__add-to-cart',
    '.product-checkout-buttons',
    '.single-add-to-cart-button',
    '.product-add-to-cart-container',
    '.product-add-to-cart-sticky',
    '.card__add-to-cart',
    '.shopify-product-form',
    '[data-add-to-cart]',
    'button[name="add"]',
    '.product-form__submit',
    '.add-to-cart__submit'
  ];

  for (const selector of fallbackSelectors) {
    const elements = document.querySelectorAll(selector);
    for (const element of elements) {
      if (isElementVisible(element)) {
        return element;
      }
    }
  }

  return null;
}

/**
 * Add Fit selector to page
 */
function addFitSelector() {
  try {
    // Check if fit selector is already inserted to avoid duplication
    if (document.querySelector('[data-pify-fit="true"]')) {
      return;
    }

    // Get FitProfiles from existing data
    window.fitChartsData = getFitProfilesFromData();

    if (!window.fitChartsData || !Array.isArray(window.fitChartsData) || window.fitChartsData.length === 0) {
      return; // Don't show if no fit data
    }

    // Filter out FitCharts that should be displayed
    const activeFitCharts = window.fitChartsData.filter(shouldDisplayFitChart);

    if (activeFitCharts.length === 0) {
      return; // No qualifying fit chart
    }

    // If there are pify_fit_selectors_wrapper containers on page, insert into each
    const pifyFitWrappers = document.querySelectorAll('.pify_fit_selectors_wrapper');
    if (pifyFitWrappers && pifyFitWrappers.length > 0) {
      pifyFitWrappers.forEach((wrapper) => {
        // Skip if already populated to avoid duplicates
        const alreadyHasFit = wrapper.querySelector('[data-pify-fit="true"]');
        if (alreadyHasFit) return;

        // Create selector for each active FitChart
        activeFitCharts.forEach((fitChart, index) => {
          const fitSelector = renderFitSelector(fitChart);
          fitSelector.setAttribute('data-pify-fit', 'true'); // Add identifier

          if (index > 0) {
            fitSelector.classList.add('pify_fit_selector_spacing');
          }

          wrapper.appendChild(fitSelector);
        });
      });
      return;
    }

    // Find Quantity selector
    const quantitySelector = findQuantitySelector();

    // Create fit selector container
    const fitContainer = document.createElement('div');
    fitContainer.className = 'pify_fit_selectors_wrapper';
    fitContainer.setAttribute('data-pify-fit', 'true'); // Add identifier

    // Create selector for each active FitChart
    activeFitCharts.forEach((fitChart, index) => {
      const fitSelector = renderFitSelector(fitChart);

      if (index > 0) {
        fitSelector.classList.add('pify_fit_selector_spacing');
      }

      fitContainer.appendChild(fitSelector);
    });

    // Insert above Quantity
    if (quantitySelector && quantitySelector.parentNode) {
      quantitySelector.parentNode.insertBefore(fitContainer, quantitySelector);
    } else {
      // If Quantity selector not found, try inserting at other positions
      const fallbackSelectors = [
        // First priority: form button area
        '.product-form__buttons',
        '.product-form__actions',
        '.product-form__button-container',
        '.product-form__submit',
        '.product__submit',
        '.product__buttons',
        '.add-to-cart-container',
        '.atc-btn-container',
        '.button-wrapper',
        '.button-container',
        '.btn-wrapper',
        '.form-actions',

        // Second priority: add to cart button
        'button[name="add"]',
        'button[type="submit"]',
        'button[name="add"][type="submit"]',
        'input[name="add"][type="submit"]',
        'form[action*="/cart/add"] button[type="submit"]',
        '#AddToCart',
        '#add-to-cart',
        '.add-to-cart',
        '.addtocart',
        '.add-to-cart-btn',
        '.btn-cart',
        '.product-form__submit-button',
        '.btn-add-to-cart',
        '.add-to-cart-button',

        // Third priority: product options area
        '.product-form__input',
        '.product-form__item',
        '.product-options',
        '.product-variants',
        '.variant-picker',
        '.variant-selector',
        '.product-form__controls',
        '.product-form__field',
        '.options-selection',
        '.variant-input',
        '.product-form__input-wrapper',

        // Fourth priority: price area
        '.product-price',
        '.price-wrapper',
        '.price-container',
        '.product__price',
        '.price-section',
        '.product-form__price',

        // Fifth priority: product info area
        '.product-form',
        '.product-form__wrapper',
        '.product-info',
        '.product__info',
        '.product-details',
        '.product-summary',
        '.product-content',
        '.product-meta',

        // Sixth priority: general container
        '.main-product',
        '.product-main',
        '.product-single',
        '.product-page',
        '.product-template',
        '.product-container',
        '.product-wrap',
        '.product-wrapper',
        '.product-content-wrapper',
        '.product-detail',
        '.product-info-wrapper',
        '.product-form-container'
      ];
      let inserted = false;
      for (const selector of fallbackSelectors) {
        const element = document.querySelector(selector);
        if (element && element.parentNode && isElementVisible(element)) {
          element.parentNode.insertBefore(fitContainer, element);
          inserted = true;
          break;
        }
      }

      // Final fallback: insert to product info area
      if (!inserted) {
        const productInfo = document.querySelector('.product__info, .product-info, .product-details');
        if (productInfo) {
          productInfo.appendChild(fitContainer);
          inserted = true;
        } else {
          // Final guarantee: find any possible container
          const finalFallbacks = [
            'main',
            '.main-content',
            '.content',
            '.container',
            '.page-content',
            '.wrapper',
            '#main',
            'body'
          ];

          for (const fallback of finalFallbacks) {
            const element = document.querySelector(fallback);
            if (element) {
              element.appendChild(fitContainer);
              inserted = true;
              break;
            }
          }
        }
      }
    }
  } catch (error) {
    // Handle errors silently
  }
}

/**
 * Delayed addition of Fit selector (for handling dynamically loaded elements)
 */
function addFitSelectorWithRetry(retryCount = 0, maxRetries = 5) {
  // First try to add immediately
  addFitSelector();

  // // Check if successfully inserted
  // const fitSelector = document.querySelector('[data-pify-fit="true"]');
  // if (fitSelector) {
  //   return;
  // }

  // // If not successful and retries remaining, delay retry
  // if (retryCount < maxRetries) {
  //   const delay = (retryCount + 1) * 500; // 500ms, 1000ms, 1500ms...
  //   setTimeout(() => {
  //     addFitSelectorWithRetry(retryCount + 1, maxRetries);
  //   }, delay);
  // }
}

/**
 * Initialize Fit functionality
 * This function will run automatically after page load
 */
function initializeFitFeature() {
  // Check if on product page
  const isProductPage = window.location.pathname.includes('/products/') ||
    document.querySelector('[data-section-type="product"]') ||
    document.querySelector('.product-form, .product__form, #product-form');

  if (!isProductPage) {
    return;
  }

  // Try to add immediately
  addFitSelectorWithRetry();

  // Set up observer for dynamically loaded content
  // const observer = new MutationObserver(() => {
  //   if (!document.querySelector('[data-pify-fit="true"]')) {
  //     addFitSelectorWithRetry();
  //   }
  // });

  // observer.observe(document.body, {
  //   childList: true,
  //   subtree: true
  // });

  // Listen for page content changes (like variant selection)
  // document.addEventListener('change', () => {
  //   setTimeout(() => {
  //     if (!document.querySelector('[data-pify-fit="true"]')) {
  //       addFitSelectorWithRetry();
  //     }
  //   }, 100);
  // });
}

/**
 * Listen for sizechart.js data loading completion
 */
function waitForSizeChartData() {
  // Check if data already exists
  if (window.pageData && window.pageData.fitProfiles) {
    initializeFitFeature();
    return;
  }

  // Listen for window.pageData changes
  let checkCount = 0;
  const maxChecks = 20; // Maximum 20 checks (10 seconds)

  const checkInterval = setInterval(() => {
    checkCount++;

    if (window.pageData && window.pageData.fitProfiles) {
      clearInterval(checkInterval);
      initializeFitFeature();
    } else if (checkCount >= maxChecks) {
      clearInterval(checkInterval);
      initializeFitFeature();
    }
  }, 500);
}

/**
 * Add CSS styles for Fit selector
 */
function addFitSelectorStyles() {
  const styleId = 'pify-fit-selector-styles';
  if (document.getElementById(styleId)) {
    return; // Styles already added
  }

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    .pify_fit_selectors_wrapper {
      width:100%;
    }
    
    .pify_fit_selector_container {
      user-select: none;
    }
    
    .pify_fit_title {
      padding: 0;
      display: block;
      font-weight: bold;
    }
    
    .pify_fit_types_container {
      margin-bottom: 12px;
    }
    
    .pify_fit_types_labels {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;
    }
    
    .pify_fit_type_label {
      flex: 1;
      text-align: center;
      transition: color 0.2s ease;
      color: var(--label-color, inherit);
      font-size: var(--label-font-size, inherit);
      font-weight: var(--label-font-weight, inherit);
    }
    
    .pify_fit_arrow_container {
      display: flex;
      gap: 8px;
      width: 100%;
      align-items: center;
      margin-bottom: 4px;
      height: 12px;
      background-color: transparent;
    }
    
    .pify_fit_arrow {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: opacity 0.2s ease;
      height: 12px;
      background-color: transparent;
    }
    
    .pify_fit_arrow_icon {
      font-size: 12px;
      line-height: 1;
      text-align: center;
      margin: 0 auto;
      display: block;
      font-weight: bold;
    }
    
    .pify_fit_segment_bar {
      display: flex;
      width: 100%;
      border-radius: 3px;
      height: 5px;
      min-height: 5px;
      gap: 2px;
    }
    
    .pify_fit_segment {
      flex: 1;
      transition: all 0.2s ease;
      box-sizing: border-box;
      display: block;
      border-radius: 3px;
      height: 5px;
      min-height: 5px;
      border: none;
    }
    
    .pify_fit_selector_spacing {
      margin-top: 20px;
    }
    
    .pify_fit_segment:first-child {
      border-top-left-radius: inherit;
      border-bottom-left-radius: inherit;
    }
    
    .pify_fit_segment:last-child {
      border-top-right-radius: inherit;
      border-bottom-right-radius: inherit;
    }
    
    /* Ensure segments display their respective styles correctly in advanced mode */
    .pify_fit_selector_container[data-advanced-mode="true"] .pify_fit_segment {
      border-radius: inherit;
    }
    
    @media (max-width: 768px) {
      .pify_fit_selectors_wrapper {
        margin-bottom: 12px;
      }
      
      .pify_fit_type_label {
        font-size: 12px;
        padding: 1px 2px;
      }
      
      .pify_fit_title {
        font-size: 14px;
      }
      
      .pify_fit_segment {
        min-height: 3px;
        height: 3px;
      }
    }
  `;

  document.head.appendChild(style);
}

// Wait for data after DOM loading
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForSizeChartData);
} else {
  waitForSizeChartData();
}


// Additional insurance: delayed initialization
setTimeout(() => {
  if (!document.querySelector('[data-pify-fit="true"]')) {
    addFitSelectorWithRetry();
  }
}, 2000);

/**
 * Create size chart inline block content
 * Processes existing .pify_inline_size_chart_block containers and populates them with size chart data
 * @returns {boolean} Success status
 */
function createSizeChartInlineBlock() {
  // Validate size chart data availability
  if (!window.sizeChartData || !window.sizeChartData.length) {
    console.warn('Size chart data is not available');
    return false;
  }
  
  // Find the first size chart that should be displayed
  const sizeChart = window.sizeChartData.find(chart => shouldDisplaySizeChart(chart));
  
  if (!sizeChart) {
    console.warn('No size chart matches the display criteria');
    return false;
  }
  
  // Find existing inline size chart containers
  const existingContainers = document.querySelectorAll('.pify_inline_size_chart_block');
  if (existingContainers.length > 0) {
    // Process each existing container
    existingContainers.forEach((container, containerIndex) => {
      // Generate unique identifier for container isolation
      const containerId = `pify_inline_container_${containerIndex}_${Date.now()}`;
      container.setAttribute('data-container-id', containerId);
      
      // Clear existing content
      container.innerHTML = '';
      
      // Create main content wrapper
      const contentWrapper = document.createElement('div');
      contentWrapper.className = 'pify_inline_block_content';

      // Create tabs navigation container
      const tabsContainer = document.createElement('div');
      tabsContainer.className = 'pify_tabs_container';
      // A11y: tabs semantics
      tabsContainer.setAttribute('role', 'tablist');

      // Create content display area
      const contentContainer = document.createElement('div');
      contentContainer.className = 'pify_size_chart_content';
      // A11y: panel semantics (id/label set in switchInlineTab)
      contentContainer.setAttribute('role', 'tabpanel');
      
      // Live region for announcements (inline)
      const liveRegion = document.createElement('div');
      liveRegion.className = 'pify_live_region';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.style.position = 'absolute';
      liveRegion.style.width = '1px';
      liveRegion.style.height = '1px';
      liveRegion.style.margin = '-1px';
      liveRegion.style.padding = '0';
      liveRegion.style.border = '0';
      liveRegion.style.overflow = 'hidden';
      liveRegion.style.clip = 'rect(0 0 0 0)';
      liveRegion.style.clipPath = 'inset(50%)';

      // Generate tabs from size chart blocks
      const tabs = sizeChart.settings.blocks;
      tabs.forEach((tab, index) => {
        const tabElement = document.createElement('div');
        tabElement.className = `pify_tab ${index === 0 ? 'pify_tab_active' : ''}`;
        tabElement.textContent = tab.name;

        // A11y: tab semantics and association
        const tabId = `pify_inline_tab_${containerId}_${index}`;
        const panelId = `pify_inline_tabpanel_${containerId}_${index}`;
        tabElement.id = tabId;
        tabElement.setAttribute('role', 'tab');
        tabElement.setAttribute('aria-controls', panelId);
        tabElement.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        tabElement.setAttribute('tabindex', index === 0 ? '0' : '-1');

        // Bind tab click event with container isolation
        tabElement.onclick = () => switchInlineTab(index, contentContainer, sizeChart, containerId);
        tabsContainer.appendChild(tabElement);
      });

      // A11y: keyboard navigation for inline tabs
      tabsContainer.addEventListener('keydown', (e) => {
        const key = e.key;
        const tabNodes = Array.from(tabsContainer.querySelectorAll('[role="tab"]'));
        const currentIndex = tabNodes.indexOf(document.activeElement);
        const moveFocus = (nextIndex) => {
          if (nextIndex < 0) nextIndex = tabNodes.length - 1;
          if (nextIndex >= tabNodes.length) nextIndex = 0;
          const nextTab = tabNodes[nextIndex];
          if (nextTab) {
            nextTab.focus();
          }
        };
        if (key === 'ArrowRight') {
          e.preventDefault();
          moveFocus(currentIndex + 1);
        } else if (key === 'ArrowLeft') {
          e.preventDefault();
          moveFocus(currentIndex - 1);
        } else if (key === 'Home') {
          e.preventDefault();
          moveFocus(0);
        } else if (key === 'End') {
          e.preventDefault();
          moveFocus(tabNodes.length - 1);
        } else if (key === 'Enter' || key === ' ') {
          e.preventDefault();
          const focusedIndex = tabNodes.indexOf(document.activeElement);
          if (focusedIndex >= 0) {
            switchInlineTab(focusedIndex, contentContainer, sizeChart, containerId);
          }
        }
      });

      // Assemble complete inline structure
      contentWrapper.appendChild(liveRegion);
      contentWrapper.appendChild(tabsContainer);
      contentWrapper.appendChild(contentContainer);
      container.appendChild(contentWrapper);

      // Initialize with first tab active
      switchInlineTab(0, contentContainer, sizeChart, containerId);
    });
    
    // Apply inline block styles
    addInlineBlockStyles();
    return true;
  }

  // Apply styles even if no containers found
  addInlineBlockStyles();
  return true;
}

/**
 * Switch active tab in inline size chart
 * @param {number} selectedIndex - Index of the tab to activate
 * @param {HTMLElement} contentContainer - Container element for tab content
 * @param {Object} sizeChart - Size chart data object
 * @param {string} containerId - Unique container identifier for isolation
 */
function switchInlineTab(selectedIndex, contentContainer, sizeChart, containerId) {
  // Target only tabs within the specific container to avoid conflicts
  const containerElement = document.querySelector(`[data-container-id="${containerId}"]`);
  if (!containerElement) return;
  
  // Update tab active states
  const tabs = containerElement.querySelectorAll('.pify_tab');
  tabs.forEach((tab, index) => {
    if (index === selectedIndex) {
      tab.classList.add('pify_tab_active');
      // A11y: selected tab state
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
    } else {
      tab.classList.remove('pify_tab_active');
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    }
  });

  // Clear previous content
  contentContainer.innerHTML = '';

  // Render selected tab content
  const currentTab = sizeChart.settings.blocks[selectedIndex];
  
  // A11y: update panel association
  const panelId = `pify_inline_tabpanel_${containerId}_${selectedIndex}`;
  const tabId = `pify_inline_tab_${containerId}_${selectedIndex}`;
  contentContainer.id = panelId;
  contentContainer.setAttribute('aria-labelledby', tabId);

  // Announce selection via inline live region
  if (currentTab && currentTab.name) {
    const contentWrapper = containerElement.querySelector('.pify_inline_block_content');
    updateInlineLiveRegion(contentWrapper, `Tab selected: ${currentTab.name}`);
  }
  if (currentTab && currentTab.modules) {
    currentTab.modules.forEach(module => {
      contentContainer.appendChild(renderModule(module));
    });
  }
}

// Add inline styles
function addInlineBlockStyles() {
  const existingStyle = document.querySelector('#pify-inline-styles');
  if (existingStyle) {
    return;
  }

  const style = document.createElement('style');
  style.id = 'pify-inline-styles';
  style.textContent = `
    .pify_inline_size_chart_block {
      // margin: 20px 0;
      background: transparent;
      color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#333'};
    }
    
    .pify_inline_block_content {
      // padding: 20px;
    }
    
    .pify_inline_size_chart_block .pify_tabs_container {
      display: flex;
      border-bottom: 1px solid #e0e0e0;
      // margin-bottom: 15px;
    }
    
    .pify_inline_size_chart_block .pify_tab {
      padding: 10px 20px;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      transition: all 0.3s ease;
      font-weight: 500;
    }
    
    .pify_inline_size_chart_block .pify_tab:hover {
      background-color: #f5f5f5;
    }
    
    .pify_inline_size_chart_block .pify_tab_active {
      border-bottom-color: ${window.settings?.primaryInteractiveColor?.backgroundColor || '#007cba'};
         color: ${window.settings?.primaryInteractiveColor?.hoverFontColor || '#007cba'};
    }
    
    .pify_inline_size_chart_block .pify_size_chart_content {
      max-height: 400px;
      overflow-x: auto;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: #c1c1c1 transparent;
    }
    
    @media (max-width: 768px) {
      .pify_inline_size_chart_block {
        // margin: 15px 0;
      }
      
      .pify_inline_block_content {
        // padding: 15px;
      }
      
      .pify_inline_size_chart_block .pify_tab {
        padding: 8px 15px;
        font-size: 14px;
      }
    }
  `;
  
  document.head.appendChild(style);
}

// Expose necessary APIs
window.FitSelector = {
  addFitSelector,
  addFitSelectorWithRetry,
  findQuantitySelector,
  isElementVisible,
  getFitProfilesFromData,
  shouldDisplayFitChart,
  renderFitSelector,
  setFitSelection,
  addFitSelectorStyles,
  initializeFitFeature,
  getCurrentProductId,
  normalizeProductId,
};



/**
 * Wrapper method for adding size chart button wrapper
 * Responsible for adding style classes to target element and inserting wrapper span
 * @param {HTMLElement} targetElement - The target element
 * @returns {void}
 */
function addSizeChartWrapper(targetElement) {
  // Add style class to target element
  targetElement.classList.add('size_chart_title');

  // Create and insert wrapper span
  const wrapperSpan = document.createElement('span');
  wrapperSpan.className = 'pify_size_chart_wrapper';
  targetElement.appendChild(wrapperSpan);
  
  return wrapperSpan;
}

/**
 * Create size chart button specifically for variant position
 * Simplified function that only handles button creation and modal functionality
 * @param {HTMLElement} targetWrapper - The wrapper element to insert button into
 * @returns {boolean} - Success status
 */
function createSizeChartButtonForVariant(targetWrapper) {
  try {
    if (!window.sizeChartData || !Array.isArray(window.sizeChartData)) {
      return false;
    }

    // Check if button already exists in this wrapper
    const existingButton = targetWrapper.querySelector('.pify_inline_button');
    if (existingButton) {
      return true;
    }

    // Create button for each size chart
    window.sizeChartData.forEach((sizeChart, index) => {
      if (!shouldDisplaySizeChart(sizeChart)) return;

      // Create button element
      const buttonDiv = document.createElement('div');
      buttonDiv.className = 'pify_inline_button pify-overlay-button';
      
      // Apply button styles from settings
  const buttonStyle = window.settings?.inlineButton?.style || {};
  if (buttonStyle.backgroundColor) {
    buttonDiv.style.setProperty('--button-bg-color', buttonStyle.backgroundColor);
  }
      if (buttonStyle.color) {
        buttonDiv.style.setProperty('--button-text-color', buttonStyle.color);
      }
      if (buttonStyle.borderColor) {
        buttonDiv.style.setProperty('--button-border-color', buttonStyle.borderColor);
      }
      if (buttonStyle.borderRadius) {
        buttonDiv.style.setProperty('--button-border-radius', buttonStyle.borderRadius);
      }
  if (buttonStyle.borderWidth) {
    buttonDiv.style.setProperty('--button-border-width', buttonStyle.borderWidth);
  }
  {
    const hasBg = !!buttonStyle.backgroundColor && !isTransparentColor(buttonStyle.backgroundColor);
    const hasBorder = !!buttonStyle.borderWidth && parseFloat(buttonStyle.borderWidth) > 0;
    if (hasBg || hasBorder) {
      buttonDiv.style.setProperty('--button-padding', '8px 12px');
    }
  }
      if (buttonStyle.fontSize) {
        buttonDiv.style.setProperty('--button-font-size', buttonStyle.fontSize);
      }
      if (buttonStyle.textDecoration) {
        buttonDiv.style.setProperty('--button-text-decoration', buttonStyle.textDecoration);
      }

      // Create button icon
      createButtonIcon(buttonDiv, buttonStyle.fontSize || '16px');

      // Create button text
      const textSpan = document.createElement('span');
      textSpan.className = 'pify_button_text';
      textSpan.textContent = window.settings?.buttonText || 'Size Chart';
      buttonDiv.appendChild(textSpan);

      // Add click event to open modal
      buttonDiv.addEventListener('click', function () {
        const modal = createModal(sizeChart);
        document.body.appendChild(modal);
      });

      // Append button to wrapper
      targetWrapper.appendChild(buttonDiv);
    });

    return true;
  } catch (error) {
    console.error('Error creating size chart button for variant:', error);
    return false;
  }
}

// Method to insert size chart button near the variant selector
/**

 * @returns {Element|null} 
 */
function findSizeChartTargetElement() {
  try {
    // Pre-compiled regex for better performance
    const sizeRegex = /\b(SIZE|Size|TAILLE|Taille|GRÖßE|Größe|TAMAÑO|Tamaño|STØRRELSE|Størrelse|サイズ|사이즈|尺寸|尺码)\b/;
    
    // Use Set for faster tag name checking
    const validTags = new Set(['LEGEND', 'LABEL']);

    let allElements = [];
    
    // Use universal selector for all themes - simplified hierarchy (no span, no div)
    const selector = 'label, legend';

    if (selector) {
      const containers = document.querySelectorAll(selector);
      containers.forEach(container => {
        // Only add elements that are label, legend, or div - using Set for faster lookup
        if (container.tagName && validTags.has(container.tagName.toUpperCase())) {
          allElements.push(container);
        }
        // Add child elements but filter for specific tags (no span, no div)
        const childElements = container.querySelectorAll('label, legend');
        allElements.push(...childElements);
      });
    }
    
    // Only log allElements in debug mode or when needed
    
    for (const element of allElements) {
      // Only check specific element types that are safe for insertion (no span) - using Set for faster lookup
      if (element.tagName && validTags.has(element.tagName.toUpperCase()) && element.textContent) {
        
        const elementText = element.textContent.trim();
        // Use regex for faster keyword matching
        const hasSizeKeyword = sizeRegex.test(elementText);

        if (hasSizeKeyword) {
          // Check if this element is part of a variant selector
          const fieldset = element.closest('fieldset, variant-wrapper, selector-wrapper, variant-selects,.product-form__input');
          if (fieldset && (
            fieldset.querySelector('input[type="radio"]') ||
            fieldset.querySelector('select') ||
            fieldset.querySelector('.variant-option')
          )) {
            const tagName = element.tagName.toLowerCase();
            // Additional validation to ensure it's a proper label element (no span, no div validation)
            if ((tagName === 'legend' || 
                 element.classList.contains('form__label') ||
                 element.classList.contains('product__label') ||
                 (tagName === 'label' && !element.getAttribute('for'))) &&
                // Ensure the element is not inside an input or other form control
                !element.closest('input, select, textarea, button')) {
              return element;
            }
          }
        }
      }
    }
    
    return null;
  } catch (error) {
    console.error('Error finding size chart target element:', error);
    return null;
  }
}



/**
 * Order of inserting size chart buttons:
 * 1. pify_size_chart_wrapper first
 * 2. window.settings?.inlineButton?.cssSelector
 * 3. size of right (auto-find size selector on the right)
 * 4. inline button (addCustomButtons)
 */
// Expose main SizeChart APIs
window.SizeChart = {
  createSizeChartInlineBlock,
  createModal,
  getCurrentThemeSelectors,
  shouldDisplaySizeChart,
};

